import {
  BASINC_TESTI_HATLARI,
  BELGE_KOLONLARI,
  belgeAlanlari,
  BICIM_ADI,
  DONUSTURUCU_AILE_ADI,
  GELEN_ETIKET_ADI,
  GELEN_GRUPLARI,
  GELEN_TURLERI,
  GELEN_YUKLEME_SINIRI_MB,
  KUTUK_EKRAN_ADI,
  htRetAdiMi,
  ROL_ETIKET,
  SET_HATLARI,
  adimYontemleri,
  dosyalamaIslemi,
  gelenGorunumu,
  gelenSinifi,
  gelenTuruMu,
  kalipDoldur,
  imzalayanSorulurMu,
  kutukYetkiMetni,
  montajRnBul,
  mrbSnBul,
  raporDosyaBul,
  sokumRnBul,
  YETKI,
  type BelgeBicimi,
  type BelgeKutugu,
  type DonusturucuAilesi,
  type DosyaGirdiTuru,
  type GelenEtiketi,
  type GelenGrubu,
  type GelenHedef,
  type GelenIpucu,
  type GelenSatiri,
  type GelenSinifi,
  type GelenTuruTanimi,
  type GirdiKapsami,
  type HidrotestKarti,
  type HidrotestTutma,
  type KararGerekcesi,
  type KararSecenegi,
  type KarsilastirmaNotu,
  type KartUyarisi,
  type Rol,
  DOSYALAMA_ENGEL_METNI,
  KARSILASTIRMA_YERI_METNI,
  KARAR_GEREKCE_ADI,
  KARAR_SECENEK_ADI,
  hidrotestEtiketi,
  NDT_ASAMA_ADI,
  dosyalamaEngeli,
  hedefEsit,
  istanbulGunu,
  ndtEtiketi,
  ndtGelenTuruMu,
  type NdtKarti,
  type NdtKartRaporu,
  type NdtNotu,
  type NdtOneriNedeni,
  cizimUcu,
  cizimUcuMetni,
  weldMapEtiketi,
  pwhtAdimiMi,
  pwhtEtiketi,
  type OkunanDeger,
  type PwhtKanalSonucu,
  type PwhtKarti,
  type PwhtKartKaynagi,
  type PwhtNotu,
  type PwhtOneriKaynagi,
  type PwhtOneriNedeni,
  type WeldMapKarti,
  type WeldMapKartKaynagi,
  type WeldMapNotu,
  type WeldMapOneriNedeni,
  type WeldMapPasoOkumasi,
  ndtSertifikaEtiketi,
  ndtSektorKapsami,
  ndtSemaOku,
  type NdtSertifikaKarti,
  type NdtSertifikaKartSatiri,
  type NdtSertifikaNotu,
  type NdtSertifikaOneriNedeni,
  kaynakciStandartOku,
  wpqEtiketi,
  type WpqKarti,
  type WpqNotu,
  type WpqOneriNedeni,
  type WpqSureklilikKartSatiri,
  type WpqTablo,
  type WpqYeterlilikKartSatiri,
  KALIBRASYON_CINSLERI,
  kalibrasyonEtiketi,
  kalibrasyonTarihEtkisi,
  type KalibrasyonKartCihazi,
  type KalibrasyonKarti,
  type KalibrasyonNotu,
  type KalibrasyonOneriNedeni,
  sarfEtiketi,
  type SarfKarti,
  type SarfKayitAlani,
  type SarfKayitSatiri,
  type SarfNotu,
  type SarfOneriNedeni,
  wpsBelgesiEtiketi,
  type WpsBelgesiKarti,
  type WpsCinsi,
  type WpsEskiSurum,
  type WpsFarkSonucu,
  type WpsNotu,
  type WpsOneriNedeni,
  teslimEtiketi,
  TESLIM_LISTE_ALANI,
  type TeslimKartKalemi,
  type TeslimKarti,
  type TeslimNotu,
  type TeslimOneriNedeni,
  type TeslimPaketOnerisi,
  BELGE_TURU_ADI,
  MALZEME_SAYFA_METNI,
  malzemeAralikMetni,
  malzemeEtiketi,
  sayfaAraligiOku,
  type MalzemeDosyaCinsi,
  type MalzemeHaritaSatiri,
  type MalzemeKarti,
  type MalzemeKartSertifikasi,
  type MalzemeKayitSatiri,
  type MalzemeNotu,
  type MalzemeOneriNedeni,
  uygunlukEtiketi,
  type UygunlukKartKalemi,
  type UygunlukKarti,
  type UygunlukNotu,
  type UygunlukOneriNedeni,
  satinAlmaCinsiOku,
  satinAlmaEtiketi,
  satinAlmaFiyatOku,
  type SatinAlmaKartSatiri,
  type SatinAlmaKarti,
  type SatinAlmaNotu,
  type SatinAlmaOneriNedeni,
  boyaFormOku,
  boyaOkumaEtiketi,
  evetHayirOku,
  type BoyaDftKolonu,
  type BoyaFinalOnerisi,
  type BoyaIkinciDurumu,
  type BoyaNotu,
  type BoyaOkumaKarti,
  type BoyaOneriNedeni,
} from "@oasis/domain";
import { api } from "@/lib/api";
import { cevir } from "@/lib/dil";
import { boyaEtkileri, type BoyaFinalSecimi } from "@/lib/boya-raporu";
import { YuklemeHatasi, dosyaYukle, tarih, tarihSaat } from "@/lib/veri";
import { saat, type DosyaBenzeri, type Ton } from "@/lib/mrb-toplu";
import * as mrbToplu from "@/lib/mrb-toplu";
import * as raporToplu from "@/lib/rapor-toplu";
import * as sokumToplu from "@/lib/sokum-toplu";
import * as montajToplu from "@/lib/montaj-toplu";
import { sayfaAlanlari, type SayfaSecimi } from "@/components/pdf-sayfa";

/**
 * D-074 Faz 1 (U-073): "Documents" sayfasının saf yardımcıları. Sayfa dosyayı hemen gelen kutusunda saklar; kişi türünü ve yerini
 * seçer, dosya BUGÜNKÜ yolundan dosyalanır: tarayıcı saklı dosyayı alır (`dosyaGetir`), iş ekranının gönderdiği alanlarla bugünkü uca
 * gönderir (`aktarimIstegi`; dönüştürücülü türlerde toplu pencerelerin kendi `istekParcalari`'yla, `donusturucuIstegi`), sonra sunucuya
 * "dosyalandı" der ve sunucu hedefte aynı baytları arar. Hiçbir belge okunmaz: öneri yalnız dosya adındaki bugünkü tanıyıcılardan gelir
 * ve "ipucu"dur (K5). Kurallar alan paketindedir (belgeler.ts); burada süzgeçler, ekran metinleri, "Effects of filing", kapının
 * yaptıkları, istek kurucuları ve dosyalama akışı durur. JSX yok.
 */

/* ------------------------------------------------------------ yanıt tipleri ------------------------------------------------------------ */

export type ListeSuzgeci = "tumu" | "bende" | "dosyalanan" | "taninmayan" | "bekleyen";
/** Ekrandaki süzgeçler: liste süzgeçleri ve Alerts görünümü. D-074 Faz 2 · PR 9: "Waiting" (`bekleyen`, K31). */
export type Suzgec = ListeSuzgeci | "uyarilar";
export const SUZGEC_SIRASI: readonly Suzgec[] = ["tumu", "bende", "uyarilar", "bekleyen", "dosyalanan", "taninmayan"];

export interface Sayilar { tumu: number; bende: number; uyarilar: number; dosyalanan: number; taninmayan: number; bekleyen: number }
export interface Serit { sonBaglanti: string | null; sira: { disposition: number; rework: number; sokum: number; assembly: number; mrb: number; hidrotest: number; ndt: number; weldmap?: number; pwht?: number; ndtSertifika?: number; wpq?: number; kalibrasyon?: number; sarf?: number; wps?: number; teslim?: number; malzeme?: number; uygunluk?: number; satinAlma?: number; boya?: number } }
/** GET /api/belgeler */
export interface ListeYaniti { satirlar: GelenSatiri[]; sayilar: Sayilar; serit: Serit; sonraki: string | null }
/** GEN-01: dosyanın OASIS'teki bir yeri. Belge kimliği ve yol yalnız kişi o yeri açabiliyorsa gelir. */
export interface KopyaYeri { kalip: string; degerler: string[]; yol: string | null; dokumanId: string | null }
export interface KartNotu { kalip: string; degerler: string[] }
/** GET /api/belgeler/:id */
export interface KartYaniti {
  satir: GelenSatiri;
  kopyalar: KopyaYeri[];
  notlar: KartNotu[];
  gecmis: { kim: string; ts: string; olay: string }[];
  ipucu: GelenIpucu | null;
  /** D-074 Faz 2: hidrotest sertifikasının okuması ("Document reading" bölümü); okunabilir tür değilse ya da satır maskeliyse null */
  okuma: HidrotestKarti | null;
  /** D-074 Faz 2 · PR 9: NDT raporunun okuması (NDT "Document reading" bölümü); NDT türü değilse ya da satır maskeliyse null */
  ndtOkuma: NdtKarti | null;
  /** D-074 Faz 2 · PR 10: weld map'in okuması (weld map "Document reading" bölümü); weld map türü değilse ya da satır maskeliyse null */
  weldMapOkuma?: WeldMapKarti | null;
  /** D-074 Faz 2 · PR 11: PWHT grafiğinin okuması (PWHT "Document reading" bölümü); PWHT türü değilse ya da satır maskeliyse null */
  pwhtOkuma?: PwhtKarti | null;
  /** D-074 Faz 3 · PR 14: NDT personel sertifikasının okuması (NDT sertifikası "Document reading" bölümü); bu tür değilse ya da satır maskeliyse null */
  ndtSertifikaOkuma?: NdtSertifikaKarti | null;
  /** D-074 Faz 3 · PR 15: kaynakçı yeterlilik belgesinin ya da süreklilik kaydının okuması ("Document reading" bölümü); bu tür değilse ya da satır maskeliyse null */
  wpqOkuma?: WpqKarti | null;
  /** D-074 Faz 3 · PR 16: kalibrasyon sertifikasının okuması (cihazlarıyla; "Document reading" bölümü); bu tür değilse ya da satır maskeliyse null */
  kalibrasyonOkuma?: KalibrasyonKarti | null;
  /** D-074 Faz 3 · PR 17: sarf sertifikasının ya da sarf kabul formunun okuması ("Document reading" bölümü); bu tür değilse ya da satır maskeliyse null */
  sarfOkuma?: SarfKarti | null;
  /** D-074 Faz 3 · PR 18: WPS'in, PQR'ın ya da dolgu onay sayfasının okuması ("Document reading" bölümü); bu tür değilse ya da satır maskeliyse null */
  wpsOkuma?: WpsBelgesiKarti | null;
  /** D-074 Faz 4 · PR 20: packing list'in okuması (kalemleriyle; "Document reading" bölümü); bu tür değilse ya da satır maskeliyse null */
  teslimOkuma?: TeslimKarti | null;
  /** D-074 Faz 4 · PR 21: malzeme sertifikasının okuması (sertifikalarıyla; "Document reading" bölümü); bu tür değilse ya da satır maskeliyse null */
  malzemeOkuma?: MalzemeKarti | null;
  /** D-074 Faz 4 · PR 22: CoC'nin okuması (kalemleriyle; "Document reading" bölümü); bu tür değilse ya da satır maskeliyse null */
  uygunlukOkuma?: UygunlukKarti | null;
  /** D-074 Faz 4 · PR 23: PO'nun okuması (satırlarıyla; "Document reading" bölümü); bu tür değilse ya da satır maskeliyse null */
  satinAlmaOkuma?: SatinAlmaKarti | null;
  /** D-074 Faz 5 · PR 25: boya raporunun okuması ("Document reading" bölümü); bu tür değilse ya da satır maskeliyse null */
  boyaOkuma?: BoyaOkumaKarti | null;
}
/** Yazım yanıtı: satır yazandan gizlendiyse (J21) `gizlendi`. */
export interface YazimYaniti { satir: GelenSatiri | null; gizlendi?: true }
export interface AktarimDosyasi { dokumanId: string; ad: string; mime: string }
/** POST /api/belgeler/:id/dosyala-basla */
export type BaslaYaniti = { zatenDosyali: true; satir: GelenSatiri | null } | (AktarimDosyasi & { hedef: GelenHedef; ek?: AktarimDosyasi & { id: string } });
/** Documents › Alerts satırı (GET /api/belgeler/uyarilar). */
export interface BelgeUyarisi {
  anahtar: string;
  kod: string;
  renk: "sari" | "kirmizi";
  kalip: string;
  degerler: string[];
  kayit: { tur: string; kalip: string; degerler: string[]; yol: string | null };
  /** "Since": ISO gün */
  tarih: string;
  ts: string;
  karar: { kim: string; rol: string; ts: string; gerekce: string } | null;
  gelenId?: string;
  kayitAnahtari: string;
}

/** Seçiciler (GET /api/belgeler/secenekler/:tur). */
export interface SeciciRiseri {
  rn: string;
  assemblySn: string | null;
  kuyrukta: boolean;
  boyaVar: boolean;
  asmVar: boolean;
  /** D-074 Faz 5 · PR 24: riserin final boya raporu (etkiler ve oncekiFinal; `anahtar` sunucunun boyaFinalAnahtari'sı); eski yanıtta yok. */
  boyaFinal?: { dosya: string; anahtar: string } | null;
  hatlar: { hat: string; ht: number; ndt: number; kayitYok: boolean }[];
}
export interface IsSecenegi {
  tamirId: string;
  riserRn: string;
  hat: string;
  is: string;
  grup: string | null;
  aktifAdim: string | null;
  raporAlir: boolean;
  weldler: { id: string; no: number }[];
  weldMapVar: boolean;
  /** Aktif adımın daha önce yüklenmiş raporu var mı (D-074 Faz 2: yeni rapor adımın rapor listesine eklenir). */
  adimRaporuVar?: boolean;
  bom: { id: string; sira: number; pn: string; tanim: string; durum: string }[];
}
export interface KutukKaydi { anahtar: string; etiket: string; aktif: boolean }

/* ------------------------------------------------------------ süzgeçler ve durumlar ------------------------------------------------------------ */

export function suzgecAdi(s: Suzgec): string {
  switch (s) {
    case "tumu": return cevir("All");
    case "bende": return cevir("Needs me");
    case "uyarilar": return cevir("Alerts");
    case "bekleyen": return cevir("Waiting");
    case "dosyalanan": return cevir("Filed");
    case "taninmayan": return cevir("Not recognised");
  }
}

/** Liste başlığı: All'da "Recent uploads", öteki süzgeçlerde süzgecin adı (statik sayfalardaki gibi). */
export const listeBasligi = (s: Suzgec): string => (s === "tumu" ? cevir("Recent uploads") : suzgecAdi(s));

const SUZGEC_ANAHTARI = "oasis.belgeler.suzgec";

/** Kişinin son seçtiği süzgeç (tarayıcıda; okunamazsa null). */
export function kayitliSuzgec(depo: Pick<Storage, "getItem"> | null = typeof localStorage === "undefined" ? null : localStorage): Suzgec | null {
  try {
    const v = depo?.getItem(SUZGEC_ANAHTARI) ?? null;
    return v && (SUZGEC_SIRASI as readonly string[]).includes(v) ? (v as Suzgec) : null;
  } catch {
    return null;
  }
}
export function suzgecKaydet(s: Suzgec, depo: Pick<Storage, "setItem"> | null = typeof localStorage === "undefined" ? null : localStorage): void {
  try { depo?.setItem(SUZGEC_ANAHTARI, s); } catch { /* özel pencerede yazılamayabilir */ }
}

/** Açılış süzgeci: kişinin seçtiği; seçmediyse "Needs me" sayısı varsa o, yoksa All. */
export const acilisSuzgeci = (kayitli: Suzgec | null, bende: number): Suzgec => kayitli ?? (bende > 0 ? "bende" : "tumu");

/** Listenin isteği: Alerts görünümünde sayılar için All okunur, arama gönderilmez (K46: Alerts araması istemcide). */
export function listeYolu(s: Suzgec, ara: string, once: string | null = null): string {
  const q = new URLSearchParams({ suzgec: s === "uyarilar" ? "tumu" : s });
  if (s !== "uyarilar" && ara.trim()) q.set("ara", ara.trim());
  if (once) q.set("once", once);
  return `/belgeler?${q.toString()}`;
}

/** Görünen durumun adı. */
export const etiketAdi = (e: GelenEtiketi): string => cevir(GELEN_ETIKET_ADI[e]);

/**
 * Durum hapının tonu: Uploaded gri · Waiting for someone who can file sarı · Filing… mavi · Needs decision kırmızı · Filed yeşil.
 * D-074 Faz 2 (okuma durumları; bugün hiçbir satır bu durumlarda değil): Waiting for reading gri · Reading mavi · Needs confirmation
 * sarı · Waiting for its riser / the step mavi · Needs owner sarı · Could not read sarı · Filed · decision needed kırmızı.
 */
export const ETIKET_TONU: Record<GelenEtiketi, Ton> = {
  yuklendi: "neutral",
  yetkili_bekleniyor: "warn",
  dosyalaniyor: "info",
  karar_bekliyor: "bad",
  dosyalandi: "ok",
  referans: "neutral",
  donusturucu: "info",
  reddedildi: "neutral",
  zaten_var: "neutral",
  okuma_sirasinda: "neutral",
  okunuyor: "info",
  onay_bekliyor: "warn",
  riser_bekliyor: "info",
  adim_bekliyor: "info",
  yer_bekliyor: "warn",
  okunamadi: "warn",
  dosyalandi_karar: "bad",
};

/** Uyarı çipinin tonu: GEN-16 kırmızı, kayıt uyarıları sarı, gri notlar gri. */
export const uyariTonu = (renk: string): Ton => (renk === "kirmizi" ? "bad" : renk === "sari" ? "warn" : "neutral");

/** Boyut: "120 KB" · "1.7 MB". */
export function boyutMetni(bayt: number): string {
  if (bayt < 1024 * 1024) return `${Math.max(1, Math.round(bayt / 1024))} KB`;
  return `${(bayt / (1024 * 1024)).toFixed(1)} MB`;
}

/** Biçimin ekran adı: "PDF" · "image" · "excel" · "Word document". */
export function bicimMetni(bicim: string): string {
  if (bicim === "pdf") return "PDF";
  if (bicim === "jpeg" || bicim === "png") return cevir("image");
  if (bicim === "xlsx" || bicim === "xls" || bicim === "csv") return cevir("excel");
  if (bicim === "word") return cevir("Word document");
  return bicim;
}

/** Listenin dosya altı satırı: "3 pages · Ensari İpek · 28/10/2026 10:16" (PDF değilse biçimin adı). */
export function dosyaAltMetni(s: Pick<GelenSatiri, "bicim" | "sayfaSayisi" | "yukleyen" | "ts">): string {
  const ilk = s.bicim === "pdf" && s.sayfaSayisi ? (s.sayfaSayisi === 1 ? cevir("1 page") : cevir("{0} pages", s.sayfaSayisi)) : bicimMetni(s.bicim);
  return [ilk, s.yukleyen, tarihSaat(s.ts)].join(" · ");
}

/** Kartın başlık altı: "3 pages · PDF · 1.7 MB · uploaded by Mutlu Tıpırdamaz 28/10/2026 09:58". */
export function kartAltMetni(s: Pick<GelenSatiri, "bicim" | "sayfaSayisi" | "boyut" | "yukleyen" | "ts">): string {
  const parcalar = [
    ...(s.bicim === "pdf" && s.sayfaSayisi ? [s.sayfaSayisi === 1 ? cevir("1 page") : cevir("{0} pages", s.sayfaSayisi)] : []),
    bicimMetni(s.bicim),
    boyutMetni(s.boyut),
    cevir("uploaded by {0} {1}", s.yukleyen, tarihSaat(s.ts)),
  ];
  return parcalar.join(" · ");
}

/**
 * Satırın durum hapının altındaki satır: başkası dosyalıyorsa kim ve ne zamandan beri; dönüştürücüye gönderilmiş satırda kapının
 * cevabı ("input attached", "queued"; onaylı belgeler--faz1, inceleme bulgusu U-073); öteki kapanmış satırda kim, ne zaman.
 */
export function durumAltMetni(s: Pick<GelenSatiri, "durum" | "etiket" | "dosyalayan" | "kapanis">): string | null {
  if (s.etiket === "dosyalaniyor" && s.dosyalayan) return cevir("Someone is filing this file now: {0} since {1}.", s.dosyalayan.ad, saat(s.dosyalayan.ts));
  if (s.durum === "donusturucu" && s.kapanis?.not) return cevir(s.kapanis.not);
  if (s.durum !== "acik" && s.kapanis?.kim) return `${s.kapanis.kim}, ${tarihSaat(s.kapanis.ts)}`;
  return null;
}

/** Yer metnindeki ekran adları (sunucunun İngilizce yer metninde yalnız bunlar çevrilir; riser, hat, kayıt kodu değerdir). */
const YER_EKRANLARI: ReadonlySet<string> = new Set([...Object.values(KUTUK_EKRAN_ADI), "Project documents", "Project"]);
/**
 * D-074 K7: reddedilmiş hidrotest hedefinin yer metni eki ("R107 · Booster · Rejected") durum sözcüğüdür, o da çevrilir. Sözlük
 * üreticisi anahtarı `cevir` çağrısının düz metninden topladığı için ayrı yazılır.
 */
const yerParcasi = (p: string) => (p === "Rejected" ? cevir("Rejected") : p === "Superseded" ? cevir("Superseded") : YER_EKRANLARI.has(p) ? cevir(p) : p);

/**
 * Sunucunun yer metni ekranda (inceleme bulgusu, U-073): " · " ile ayrılan parçalardan ekran adı olanlar sözlükten geçer ("Registers ›
 * Instruments · AN-2134" → "Kütükler › Aletler · AN-2134"); öteki parçalar değerdir. Önceden "Owner" sütunu ve GEN-01 yeri Türkçe kipte
 * İngilizce kalıyordu. Arama sunucuda İngilizce metin üzerindedir.
 */
export function yerCevir(metin: string | null | undefined): string | null {
  if (!metin) return metin ?? null;
  return metin.split(" · ").map(yerParcasi).join(" · ");
}

/** Hedefin ekranı ("Owner" sütununun alt satırı). */
export function hedefEkrani(h: GelenHedef | null): string | null {
  if (!h) return null;
  switch (h.tur) {
    case "ht": case "hat_ndt": case "boya": return cevir("Finishing");
    case "proje": return cevir("Project documents");
    case "adim_raporu": case "pwht": case "urun_geldi": return cevir("Component");
    case "weldmap": return "Weld map";
    case "kutuk": return cevir("Registers");
    case "donusturucu":
      if (h.aile === "mrb") return "MRB intake";
      if (h.aile === "sokum") return cevir("Disassembly");
      if (h.aile === "montaj") return cevir("Finishing");
      return cevir("Inspection verification");
  }
}

/* ------------------------------------------------------------ türler ------------------------------------------------------------ */

/** Tür adı (sözlükle). */
export const turAdi = (tur: string | null | undefined): string | null => (tur && gelenTuruMu(tur) ? cevir(GELEN_TURLERI[tur]!.ad) : null);

/** Grubun adı: "Other" grubunun ekrandaki adı "Other"; öteki grupların adları var olan anahtarlar. */
export function grupAdi(g: GelenGrubu): string {
  switch (g) {
    case "Registers": return cevir("Registers");
    case "Finishing": return cevir("Finishing");
    case "Component": return cevir("Component");
    case "Weld map": return "Weld map";
    case "Project documents": return cevir("Project documents");
    case "Converter types": return cevir("Converter types");
    case "Filed on another screen": return cevir("Filed on another screen");
    case "Other": return cevir("Other");
  }
}

/** Seçimdeki sıra (statik sayfa belgeler--faz1-elle): listede olmayan anahtar tanım sırasıyla sona. */
const TUR_SIRASI: readonly string[] = [
  // D-074 Faz 3 (K20): yeni türler kendi kütüğünün türlerinin ardında.
  "kutuk:alet:kalibrasyon", "kutuk:alet:ce_uygunluk", "kutuk:alet:uretici_test",
  "kutuk:stok_paket:en10204_31", "kutuk:stok_paket:en10204_32", "kutuk:stok_paket:coc", "kutuk:stok_paket:teslim", "kutuk:stok_paket:po", "kutuk:stok_paket:fatura",
  "kutuk:sarf:en10204_31", "kutuk:sarf:po", "kutuk:sarf:kabul_formu",
  "kutuk:kaynakci:wpq", "kutuk:kaynakci:sureklilik", "kutuk:ndt_inspektor:ndt_sertifika", "kutuk:wps:wps", "kutuk:wps:pqr", "kutuk:wps:dolgu_onayi",
  ...["musteri_siparisi", "bom", "montaj_resmi", "dvr_osi", "kalite_plani", "prosedur", "osi_coc", "dnv_survey_report", "kimlik_plakasi", "malzeme_sertifika_listesi", "onceki_cevrim"].map((t) => `proje:${t}`),
  "ekran:sokum_imzali", "ekran:adim_dosyasi", "ekran:foto", "ekran:batch_rn", "ekran:saha_survrep",
];
const sira = (anahtar: string) => { const i = TUR_SIRASI.indexOf(anahtar); return i < 0 ? TUR_SIRASI.length : i; };

/**
 * "What is this file?" seçiminin grupları ve türleri, ekrandaki sırayla. Aynı adı taşıyan iki kütük türü (stok paketinin ve sarf
 * lotunun PO'su) kütüğün adıyla ayrılır: "PO · Registers › Stock".
 */
export function turGruplari(): { grup: GelenGrubu; ad: string; turler: { anahtar: string; ad: string }[] }[] {
  return GELEN_GRUPLARI.map((grup) => {
    const turler = Object.entries(GELEN_TURLERI).filter(([, t]) => t.grup === grup).sort(([a], [b]) => sira(a) - sira(b));
    const ayni = (ad: string) => turler.filter(([, t]) => t.ad === ad).length > 1;
    return {
      grup,
      ad: grupAdi(grup),
      turler: turler.map(([anahtar, t]) => ({ anahtar, ad: t.kutuk && ayni(t.ad) ? `${cevir(t.ad)} · ${cevir(KUTUK_EKRAN_ADI[t.kutuk])}` : cevir(t.ad) })),
    };
  });
}

export const turTanimi = (tur: string | null | undefined): GelenTuruTanimi | null => (tur && gelenTuruMu(tur) ? GELEN_TURLERI[tur]! : null);

/** İpucunun metni: "Disposition report · R107" · "MRB (Complete PDF) · SN 1306722-1" · "Disposition report". */
export function ipucuMetni(i: GelenIpucu): string {
  const yer = i.sn ? `SN ${i.sn}` : i.rn;
  return [turAdi(i.tur) ?? i.tur, yer].filter(Boolean).join(" · ");
}

/** Biçim türe uymuyorsa cümle ("A Word file cannot be filed as Hydrotest certificate."); uyuyorsa null. */
export function bicimHatasi(bicim: string, tur: string | null): string | null {
  const t = turTanimi(tur);
  if (!t || !t.hedef || t.kabul.includes(bicim as BelgeBicimi)) return null;
  return cevir("A {0} file cannot be filed as {1}.", BICIM_ADI[bicim as BelgeBicimi] ?? bicim, cevir(t.ad));
}

/**
 * Türün dosyalama yetkisinin cümlesi (pasif düğmenin ipucu ve altındaki yazı; kütükte K2 cümleleri). Ekran denemesi bulgusu (U-073):
 * cümle düğmenin altında görünür yazıdır, dilin kalıbıyla kurulur ("Permission: Field Inspector" · "Yetki: Saha İnspektörü", İşlerim'deki
 * gibi). Önceden alan paketinin `yetkiMetni`'si kullanılıyordu: o, iş ekranlarında düğme ipucudur, her dilde Türkçe "Yetki:" ile başlar ve
 * rol adlarını çevirmez; İngilizce ekranda "Yetki: Field Inspector", Türkçe ekranda "Yetki: Field Inspector" yazıyordu. Roller " · " ile
 * ayrılır (İşlerim'deki gibi): rol adının kendisinde "/" var ("Foreman / Welding"), " / " ile "Foreman / Welding / Field Supervisor" üç rol gibi okunuyordu.
 */
export function yetkiCumlesi(tur: string): string {
  const t = turTanimi(tur);
  if (t?.hedef === "kutuk") return cevir(kutukYetkiMetni(t.belgeTuru!));
  const islem = dosyalamaIslemi(tur);
  return islem ? `${cevir("Permission:")} ${(YETKI[islem] as readonly Rol[]).map((r) => cevir(ROL_ETIKET[r])).join(" · ")}` : cevir("Choose where the file belongs.");
}

/* ------------------------------------------------------------ cümleler (kalıp + değer) ------------------------------------------------------------ */

const ISO_GUN = /^\d{4}-\d{2}-\d{2}$/;

/** Kalıbı sözlükle çevirir; ISO gün değerleri ekranın tarih biçimiyle, `cevrilecek` sıradaki değerler sözlükten (tür adı, durum adı). */
export function kalipMetni(kalip: string, degerler: readonly string[], cevrilecek: readonly number[] = []): string {
  return cevir(kalip, ...degerler.map((d, i) => (ISO_GUN.test(d) ? tarih(`${d}T12:00:00.000Z`) : cevrilecek.includes(i) ? cevir(d) : d)));
}

/** Satırın uyarı cümlesi: GEN-16'da tür adı, GEN-01 kalıbında tür adı çevrilir. */
export const satirUyariMetni = (u: { kod: string; kalip: string; degerler: string[] }): string => kalipMetni(u.kalip, u.degerler, u.kod === "GEN-16" ? [1] : []);

/** GEN-01 yerinin cümlesi: tür adı ({0}), yerin ekran adı ({1}, `yerCevir`) ve, gelen kutusu satırında, durum adı ({2}) çevrilir. */
export function kopyaMetni(k: KopyaYeri): string {
  const gelen = k.kalip.startsWith("Already in Documents");
  const degerler = !gelen && k.degerler.length > 1 ? [k.degerler[0]!, yerCevir(k.degerler[1]) ?? "", ...k.degerler.slice(2)] : k.degerler;
  return kalipMetni(k.kalip, degerler, gelen ? [2] : [0]);
}

/** Documents › Alerts satırının "Alert" ve "Record" hücreleri. */
export const uyariMetni = (u: Pick<BelgeUyarisi, "kalip" | "degerler" | "kod">): string => kalipMetni(u.kalip, u.degerler, u.kod === "GEN-16" ? [1] : []);
export const uyariKaydi = (u: Pick<BelgeUyarisi, "kayit">): string => kalipMetni(u.kayit.kalip, u.kayit.degerler);

/** İncelenmiş uyarının durum hücresi: "Reviewed by {0} on {1}: {2}". */
export const incelemeMetni = (k: NonNullable<BelgeUyarisi["karar"]>): string => cevir("Reviewed by {0} on {1}: {2}", k.kim, tarih(k.ts), k.gerekce);

/**
 * Aramada iki taraf aynı biçime gelir: Türkçe küçültme ("İ" → "i", "I" → "ı"), sonra "ı" ile "i" eşit ve birleşen nokta (U+0307)
 * atılır. Böylece "KALİBRASYON", "kalibrasyon" ve "KALIBRASYON" aynı metni bulur; "en" küçültmesi "İ"yi "i̇" yapıp eşleşmeyi bozuyordu.
 */
const aramaBicimi = (x: string): string => x.toLocaleLowerCase("tr").replace(/\u0307/g, "").replace(/ı/g, "i");

/**
 * D-074 Faz 2 (K46): Alerts araması. Uyarı, aranan metin (büyük-küçük harfsiz) ekranda gösterilen hücrelerinden birinde geçiyorsa kalır:
 * kod, cümle, kayıt, "Since" günü, incelenmiş satırın inceleme notu. Boş arama hepsini verir. Sunucuya gidilmez.
 */
export function uyarilariSuz(uyarilar: readonly BelgeUyarisi[], ara: string): BelgeUyarisi[] {
  const a = aramaBicimi(ara.trim());
  if (!a) return [...uyarilar];
  return uyarilar.filter((u) =>
    [u.kod, uyariMetni(u), uyariKaydi(u), tarih(`${u.tarih}T12:00:00.000Z`), u.karar ? incelemeMetni(u.karar) : ""].some((x) => aramaBicimi(x).includes(a)),
  );
}

/**
 * Kapanmış satırın kart cümlesi. Dönüştürücüde §5.2'nin cümlesi: "Sent to converter: {aile} · {riser} · {kapının cevabı}" (inceleme
 * bulgusu, U-073: önceden tür adı ve "Disposition · R107" yazılıyor, aile iki kez geçiyor ve kapının cevabı yoktu).
 */
export function kapanisMetni(s: Pick<GelenSatiri, "durum" | "turAdi" | "hedefMetni" | "kapanis"> & Partial<Pick<GelenSatiri, "hedef">>, yer: string | null = null): string | null {
  const not = s.kapanis?.not ?? "";
  switch (s.durum) {
    case "dosyalandi": return cevir("Filed: {0} · {1}", s.turAdi ? cevir(s.turAdi) : "—", yerCevir(s.hedefMetni) ?? "—");
    case "donusturucu": {
      const aile = s.hedef?.tur === "donusturucu" ? DONUSTURUCU_AILE_ADI[s.hedef.aile] : s.turAdi ? cevir(s.turAdi) : "—";
      return not ? cevir("Sent to converter: {0} · {1} · {2}", aile, s.hedefMetni ?? "—", cevir(not)) : cevir("Sent to converter: {0} · {1}", aile, s.hedefMetni ?? "—");
    }
    case "referans": return not ? cevir("Filed as reference: {0}", not) : etiketAdi("referans");
    case "reddedildi": return not ? cevir("Rejected upload: {0}", not) : etiketAdi("reddedildi");
    case "zaten_var": return yer ?? etiketAdi("zaten_var");
    default: return null;
  }
}

/**
 * Şerit: "Converter computer last connected: {0}", hiç bağlanmadıysa "…: none" ve tür başına sıra. Bekir, 29.10.2026: Türkçesi
 * "…son bağlantısı: yok" olsun (önceki tek kalıp "son bağlantısı hiç" okunuyordu).
 */
export const baglantiMetni = (s: Serit): string =>
  s.sonBaglanti ? cevir("Converter computer last connected: {0}", tarihSaat(s.sonBaglanti)) : cevir("Converter computer last connected: none");
export const siraMetni = (s: Serit): string =>
  cevir(
    "Converter queue: Disposition {0} · Rework {1} · Disassembly {2} · Assembly {3} · MRB {4} · Hydrotest {5} · NDT {6} · Weld map {7} · PWHT chart {8} · NDT certificate {9} · Welder documents {10} · Calibration certificates {11} · Consumable documents {12} · WPS documents {13} · Packing lists {14} · Material certificates {15} · Certificates of conformity {16} · Purchase orders {17} · Coating reports {18}",
    s.sira.disposition, s.sira.rework, s.sira.sokum, s.sira.assembly, s.sira.mrb, s.sira.hidrotest, s.sira.ndt ?? 0, s.sira.weldmap ?? 0, s.sira.pwht ?? 0, s.sira.ndtSertifika ?? 0, s.sira.wpq ?? 0,
    s.sira.kalibrasyon ?? 0, s.sira.sarf ?? 0, s.sira.wps ?? 0, s.sira.teslim ?? 0, s.sira.malzeme ?? 0, s.sira.uygunluk ?? 0, s.sira.satinAlma ?? 0, s.sira.boya ?? 0,
  );

/* ------------------------------------------------------------ hidrotest okuması (D-074 Faz 2) ------------------------------------------------------------ */

/** Okuma uçları: sıraya koy / çıkar (`islem`) ve elle okuma excel'i (form-data `excel`). */
export const OKUMA_UCU = {
  sira: (id: string) => `/belgeler/${id}/okuma`,
  girdi: (id: string) => `/belgeler/${id}/okuma/girdi`,
  /** D-074 Faz 2 · PR 8: "Compare again" */
  karsilastir: (id: string) => `/belgeler/${id}/okuma/karsilastir`,
} as const;
/** D-074 Faz 2 · PR 8: saklı uyarının kararı ve hatırlanan kararın geri alınması. */
export const KARAR_UCU = {
  karar: (uyariId: string) => `/belgeler/uyarilar/${uyariId}/karar`,
  geriAl: (kararId: string) => `/belgeler/uyarilar/karar/${kararId}/geri-al`,
} as const;

/** "ekle" düğmesinin adı: iş hata verdiyse "Retry", okuma varsa "Read again", değilse "Send for reading". */
export function okumaDugmesi(k: { is: HidrotestKarti["is"]; okuma: unknown }): "Send for reading" | "Retry" | "Read again" {
  if (k.is.durum === "hata") return "Retry";
  if (k.okuma) return "Read again";
  return "Send for reading";
}

/**
 * Bölümün gösterdiği düğmeler (sunucunun hesapladığı eylemler). Kapanmış satırda (`salt`) yalnız "Remove from reading queue" kalır:
 * satır sırada iken elle dosyalanırsa iş sırada kalır ve zamanlanmış görev bu türü almadıkça düşmez; kişi onu buradan çıkarır.
 */
export function okumaEylemleri(k: Pick<HidrotestKarti, "eylemler">, salt = false): HidrotestKarti["eylemler"] {
  return { gonder: !salt && k.eylemler.gonder, cikar: k.eylemler.cikar, girdi: !salt && k.eylemler.girdi, karsilastir: !salt && Boolean(k.eylemler.karsilastir) };
}

/** Kapanmış satırın kartında bölüm çizilir mi: okuma varsa ya da iş hâlâ sıradan çıkarılabiliyorsa. */
export const okumaBolumuKapanmista = (k: { okuma: unknown; eylemler: { cikar: boolean } } | null | undefined): boolean => Boolean(k && (k.okuma || k.eylemler.cikar));

/**
 * Bir beklemenin tek satırı: ad · saatler · basınçlar · düşüş. Okunamayan beklemede yalnız ad ve "not read". Basınçlar MPa, okunduğu
 * gibi (psi çevirisi ve karşılaştırma yok).
 */
export function tutmaMetni(t: HidrotestTutma): string {
  if (t.kesinlik === "bos") return [t.bekleme, cevir("not read")].join(" · ");
  const p: string[] = [t.bekleme];
  if (t.baslangic !== null || t.bitis !== null) p.push(`${t.baslangic ?? "?"}-${t.bitis ?? "?"}`);
  if (t.baslangicMpa !== null && t.bitisMpa !== null) p.push(cevir("{0} → {1} MPa", String(t.baslangicMpa), String(t.bitisMpa)));
  if (t.dusumMpa !== null) p.push(cevir("drop {0} MPa", String(t.dusumMpa)));
  return p.join(" · ");
}

/* ------------------------------------------------------------ karşılaştırma ve uyarılar (D-074 Faz 2 · PR 8) ------------------------------------------------------------ */

/** Notun alan adı: okunan değerin etiketi (sözlükte), beklemeler "Holds". */
const notAlani = (alan: string): string => (alan === "tutma" ? cevir("Holds") : cevir(hidrotestEtiketi(alan)));

/** Karşılaştırma notunun ekran cümlesi ("Compared with OASIS" altında; uyarı değildir). */
export function notMetni(n: KarsilastirmaNotu): string {
  switch (n.tur) {
    case "yer_yok": return cevir("Choose where the file belongs to compare it with OASIS.");
    case "suphe": return cevir("Not compared: {0} is uncertain. Check it on the page.", notAlani(n.alan));
    case "bicim": return cevir("Not compared: {0} is not in a form OASIS reads ({1}).", notAlani(n.alan), n.deger);
    case "hatlar_yok": return cevir("Line SNs of riser {0} are not in OASIS; the SN was not compared.", n.rn);
    case "tutma_yok": return cevir("Holds were not read.");
    case "kural":
      if (n.kural === "K6") return cevir("Required test pressure not checked: rule K6 waits for approval.");
      if (n.kural === "K8") return cevir("Chart scale range not checked: rule K8 waits for approval.");
      return cevir("Test date against the repair (HT-07) not checked: the historical-entry list (K28) waits.");
    case "kural_onayli":
      return cevir("Required test pressure (rule K6, approved on {2}): {0} psi without repair, {1} psi after weld, part change or PWHT.", n.mwpPsi.toLocaleString("en-US"), n.testPsi.toLocaleString("en-US"), tarih(n.onayTs));
  }
}

/** Kartta saklı uyarının cümlesi (kalıp sözlükle; ISO günler ekranın tarih biçimiyle). */
export const kartUyariMetni = (u: Pick<KartUyarisi, "kalip" | "degerler">): string => kalipMetni(u.kalip, u.degerler);

/**
 * Kararın tek satırı: "Decided by {0} on {1}: {2}" (seçenek, hat, gerekçe, not " · " ile). "Mark reviewed" kararında var olan inceleme
 * biçimi ("Reviewed by {0} on {1}: {2}", not).
 */
export function kararMetni(k: NonNullable<KartUyarisi["karar"]>): string {
  if (k.secenek === "incelendi") return cevir("Reviewed by {0} on {1}: {2}", k.kim, tarih(k.ts), k.not ?? "");
  const secenek = KARAR_SECENEK_ADI[k.secenek as KararSecenegi];
  const gerekce = k.gerekce ? KARAR_GEREKCE_ADI[k.gerekce as KararGerekcesi] : null;
  return cevir("Decided by {0} on {1}: {2}", k.kim, tarih(k.ts), [secenek ? cevir(secenek) : k.secenek, k.hat, gerekce ? cevir(gerekce) : k.gerekce, k.not].filter(Boolean).join(" · "));
}

/**
 * "Confirm and file"ın okuma kapısı (T21): kararsız kırmızı ya da "Do not file" kararı varken dosyalanmaz. Sertifika "Rejected" dosyalanırken
 * (`ret`) yalnız kimlik ve kopya kırmızıları kapatır (`retteSerbest`). Kapı yoksa null.
 */
export function okumaDosyalamaEngeli(k: Pick<HidrotestKarti, "dosyalamaEngeli"> | null | undefined, ret: boolean): string | null {
  const e = k?.dosyalamaEngeli;
  if (!e) return null;
  if (e.tur === "kirmizi" && ret && e.retteSerbest) return null;
  return cevir(DOSYALAMA_ENGEL_METNI[e.tur]);
}

/**
 * "Confirm and file"ın yer kapısı (T3, T16; sunucuda da var): okunmuş sertifika yalnız güncel okumasının karşılaştırıldığı yere dosyalanır.
 * Okuma hiç karşılaştırılmadıysa ya da formdaki yer karşılaştırmanın yeri değilse cümle; okumasız satırda, yer seçilmemişken ya da yer aynıyken null.
 * Dosyalayan kişinin yer seçimi de kaydedilir (kartın otomatik kaydı) ve sunucu yeniden karşılaştırır; cümle o arada görünür.
 */
export function okumaYeriEngeli(k: Pick<HidrotestKarti, "okuma" | "karsilastirma"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.okuma || !k.karsilastirma || hedef?.tur !== "ht") return null;
  const y = k.karsilastirma.yer;
  return !k.karsilastirma.karsilastirildi || y?.rn !== hedef.rn || y?.hat !== hedef.hat ? cevir(KARSILASTIRMA_YERI_METNI) : null;
}

/* ------------------------------------------------------------ NDT raporu okuması (D-074 Faz 2 · PR 9) ------------------------------------------------------------ */

/** Önerinin yapılamama nedeni (raporun satırı ve not). */
export function ndtNedenMetni(n: NdtOneriNedeni): string {
  switch (n) {
    case "supheli": return cevir("The riser number or SN is uncertain. Check it on the page and choose the place.");
    case "hat": return cevir("The line is not known from the SN. Choose the line.");
    case "birden_cok": return cevir("Several open steps match this report. Choose the place.");
    case "kapali": return cevir("The matching step is already closed. File it as a reference.");
    case "asama": return cevir("The stage of the report does not match a step. Choose the place.");
  }
}

/** NDT karşılaştırma notunun ekran cümlesi ("Compared with OASIS" altında; uyarı değildir). */
export function ndtNotMetni(n: NdtNotu): string {
  const rapor = (r: number, metin: string) => `${cevir("Report")} ${r}: ${metin}`;
  switch (n.tur) {
    case "suphe": return cevir("Not compared: Report {0} · {1} is uncertain. Check it on the page.", n.rapor, cevir(ndtEtiketi(n.alan)));
    case "bicim": return cevir("Not compared: Report {0} · {1} is not in a form OASIS reads ({2}).", n.rapor, cevir(ndtEtiketi(n.alan)), n.deger);
    case "hatlar_yok": return cevir("Report {0}: line SNs of riser {1} are not in OASIS; the SN was not compared.", n.rapor, n.rn);
    case "hat_karsilastirilmaz": return cevir("Report {0}: the SN is not compared for the {1} line.", n.rapor, n.hat);
    case "asama_belirsiz": return cevir("Report {0}: the stage is unclear (material condition and report number differ).", n.rapor);
    case "oneri_yok": return rapor(n.rapor, ndtNedenMetni(n.neden));
    case "sn_bilinmiyor": return rapor(n.rapor, cevir("SN {0} is not on any riser in OASIS.", n.sn));
    case "imzaci_belirsiz": return cevir("Report {0}: several NDT inspectors are named {1}; choose the signer yourself.", n.rapor, n.ad);
    case "imzaci_kaydi_eksik": return cevir("Report {0}: the certificate of {1} has no method or level in Registers.", n.rapor, n.ad);
    case "tarih_yok": return cevir("Report {0}: no test date; the signer's certificate was not checked for the date.", n.rapor);
    case "kural": return cevir("Date order (GEN-14) not checked: the historical-entry list (K28) waits.");
    case "veri_yok":
      if (n.kod === "NR-01") return cevir("Stage against the weld and PWHT dates (NR-01) is checked when the weld map and the PWHT chart are read.");
      if (n.kod === "NR-07") return cevir("Bevel report of each weld (NR-07) is checked when the job's other reports are read.");
      // D-074 Faz 2 · PR 10 (Z45): weld map okunuyor ama NR-09 açılmadı; NDT raporlarının sonuç satırları okunmuyor.
      return cevir("Weld numbers against the weld map (NR-09) are checked when the result rows of NDT reports are read.");
  }
}

/** Raporun kısa satırı: yöntem · aşama · test günü ("MT · before welding (bevel) · 10/01/2099"). */
export const ndtRaporSatiri = (r: Pick<NdtKartRaporu, "yontem" | "asama" | "testTarihi">): string =>
  [r.yontem, r.asama ? cevir(NDT_ASAMA_ADI[r.asama]) : null, r.testTarihi ? tarih(r.testTarihi) : null].filter(Boolean).join(" · ");

/** Raporun yer durumunun hapı ("Waiting for its riser", "proposed", "this place"); yer yoksa nedeni. */
export function ndtDurumMetni(r: Pick<NdtKartRaporu, "durum" | "neden">): string {
  switch (r.durum) {
    case "riser_bekliyor": return cevir("Waiting for its riser");
    case "adim_bekliyor": return cevir("Waiting for the step");
    case "yer_bekliyor": return cevir("Needs owner");
    case "oneri": return cevir("proposed");
    case "kisi": return cevir("this place");
    case "yok": return r.neden ? ndtNedenMetni(r.neden) : "—";
  }
}

/** Formun yerindeki raporların sıraları (yeri olan ve yeri formunkine eşit raporlar). */
export const ndtYerdekiler = (k: Pick<NdtKarti, "raporlar"> | null | undefined, hedef: GelenHedef | null): number[] =>
  (k?.raporlar ?? []).filter((r) => (r.durum === "kisi" || r.durum === "oneri") && hedefEsit(r.yer, hedef)).map((r) => r.sira);

/** Sayfa aralığının metni ("3" ya da "1-2"). */
const aralikMetni = (s: { bas: number; son: number }) => (s.bas === s.son ? String(s.bas) : `${s.bas}-${s.son}`);

/**
 * N21 "Use these pages": formun yerindeki raporların aralıkları sırayla ("1-2, 3-4"). Finishing NDT raporunda bir PDF bir hatta tek aralıkla
 * dosyalanır: yalnız ilk rapor. Yerde rapor yoksa null.
 */
export function ndtSayfaMetni(k: Pick<NdtKarti, "raporlar"> | null | undefined, hedef: GelenHedef | null, tur: string | null): string | null {
  const siralar = new Set(ndtYerdekiler(k, hedef));
  const l = (k?.raporlar ?? []).filter((r) => siralar.has(r.sira)).sort((a, b) => a.sira - b.sira);
  if (!l.length) return null;
  return (tur === "hat_ndt" ? l.slice(0, 1) : l).map((r) => aralikMetni(r.sayfalar)).join(", ");
}

/** N21 "Use this signer": formun yerindeki raporların eşleşen imzacıları (tekil; NDT inspektörü kimlikleri). */
export function ndtImzacilari(k: Pick<NdtKarti, "raporlar"> | null | undefined, hedef: GelenHedef | null): string[] {
  const siralar = new Set(ndtYerdekiler(k, hedef));
  return [...new Set((k?.raporlar ?? []).filter((r) => siralar.has(r.sira) && r.imzaci).map((r) => r.imzaci!.inspektorId))];
}

/** N22 yer kapısı (sunucuda da var): okunmuş NDT raporu yalnız bir raporunun yerine dosyalanır; formun yerinde rapor yoksa cümle. */
export function ndtYerEngeli(k: Pick<NdtKarti, "okuma" | "raporlar"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.okuma || !k.raporlar.length || !hedef || !ndtGelenTuruMu(hedef.tur)) return null;
  return ndtYerdekiler(k, hedef).length ? null : cevir(KARSILASTIRMA_YERI_METNI);
}

/** N22 karar kapısı: yalnız formun yerindeki raporların uyarıları ve parçasız uyarılar (GEN-09); kapı yoksa null. */
export function ndtDosyalamaEngeli(k: Pick<NdtKarti, "raporlar" | "karsilastirma"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.karsilastirma) return null;
  const siralar = new Set(ndtYerdekiler(k, hedef));
  const uyarilar = [...k.raporlar.filter((r) => siralar.has(r.sira)).flatMap((r) => r.uyarilar), ...k.karsilastirma.uyarilar];
  const e = dosyalamaEngeli(uyarilar, false);
  return e ? cevir(DOSYALAMA_ENGEL_METNI[e]) : null;
}

/** Rapor sıralarının kısa metni: ardışıklar aralık olur ("2-4", "2, 4", "1-2, 5"). */
export function siraListesi(l: readonly number[]): string {
  const s = [...new Set(l)].sort((a, b) => a - b);
  const parcalar: string[] = [];
  for (let i = 0; i < s.length; i++) {
    let j = i;
    while (j + 1 < s.length && s[j + 1] === s[j]! + 1) j++;
    parcalar.push(j > i ? `${s[i]}-${s[j]}` : String(s[i]));
    i = j;
  }
  return parcalar.join(", ");
}

/**
 * N30 "Effects of filing": formun yerine düşmeyen raporların sıraları (yoksa boş metin). N21: Finishing NDT raporunda dosya hatta tek aralıkla
 * dosyalanır; aynı hatta düşen ikinci ve sonraki raporlar da bu dosyalamayla dosyalanmaz, onlar da sayılır.
 */
export const ndtDisarida = (k: Pick<NdtKarti, "raporlar"> | null | undefined, hedef: GelenHedef | null): string => {
  const yerdekiler = ndtYerdekiler(k, hedef).sort((a, b) => a - b);
  const yerde = new Set(hedef?.tur === "hat_ndt" ? yerdekiler.slice(0, 1) : yerdekiler);
  return siraListesi((k?.raporlar ?? []).map((r) => r.sira).filter((x) => !yerde.has(x)));
};

/** "Effects of filing"in dışarıda kalan raporlar cümlesi: tek rapor tekil cümleyle. */
const disaridaMetni = (l: string) =>
  /^\d+$/.test(l)
    ? cevir("Report {0} is not filed with this place. File it from the job screen with Partial pages, or keep the file here.", l)
    : cevir("Reports {0} are not filed with this place. File them from the job screen with Partial pages, or keep the file here.", l);

/* ------------------------------------------------------------ weld map okuması (D-074 Faz 2 · PR 10) ------------------------------------------------------------ */

/** Weld map okuma uçları (Z33): sıraya koy / çıkar, elle okuma excel'i ve kaynak tarihi kaydı. "Compare again" ortak `OKUMA_UCU.karsilastir`. */
export const WELDMAP_UCU = {
  sira: (id: string) => `/belgeler/${id}/weldmap/okuma`,
  girdi: (id: string) => `/belgeler/${id}/weldmap/okuma/girdi`,
  kaynakTarihi: (id: string) => `/belgeler/${id}/weldmap/kaynak-tarihi`,
} as const;

/** İş önerisinin yapılamama nedeni (parça satırı). */
export function weldMapNedenMetni(n: WeldMapOneriNedeni): string {
  switch (n) {
    case "supheli": return cevir("The riser number or SN is uncertain. Check it on the page and choose the job.");
    case "riser_yok": return cevir("The riser is not known from the document. Choose the job.");
    case "hat_yok": return cevir("The line is not known from the SN. Choose the job.");
    case "is_yok": return cevir("No job with welds on this riser and line. Choose the job or file as reference.");
    case "birden_cok": return cevir("Several jobs match. Choose the job.");
  }
}

/** Weld map karşılaştırma notunun ekran cümlesi ("Compared with OASIS" altında; uyarı değildir). */
export function weldMapNotMetni(n: WeldMapNotu): string {
  const alan = (a: string) => cevir(weldMapEtiketi(a));
  switch (n.tur) {
    case "yer_yok": return cevir("Choose where the file belongs to compare it with OASIS.");
    case "suphe":
      if (n.kaynak === null) return cevir("Not compared: {0} is uncertain. Check it on the page.", alan(n.alan));
      if (n.satir === null) return cevir("Not compared: W{0} · {1} is uncertain. Check it on the page.", n.kaynak, alan(n.alan));
      return cevir("Not compared: W{0} row {1} · {2} is uncertain. Check it on the page.", n.kaynak, n.satir, alan(n.alan));
    case "bicim":
      if (n.kaynak === null) return cevir("Not compared: {0} is not in a form OASIS reads ({1}).", alan(n.alan), n.deger);
      if (n.satir === null) return cevir("Not compared: W{0} · {1} is not in a form OASIS reads ({2}).", n.kaynak, alan(n.alan), n.deger);
      return cevir("Not compared: W{0} row {1} · {2} is not in a form OASIS reads ({3}).", n.kaynak, n.satir, alan(n.alan), n.deger);
    case "hatlar_yok": return cevir("Line SNs of riser {0} are not in OASIS; the SN was not compared.", n.rn);
    case "hat_karsilastirilmaz": return cevir("The SN is not compared for the {0} line.", n.hat);
    case "riser_sn_bilinmiyor": return cevir("Riser SN {0} is not on any riser in OASIS.", n.sn);
    case "kimlik_yok": return cevir("No riser number, riser SN or line SN on the document.");
    case "kaynak_iste_yok": return cevir("W{0} on the weld map is not a weld of this job.", n.no);
    case "kaynak_haritada_yok": return cevir("W{0} of this job is not on the weld map.", n.no);
    case "plan_yok": return cevir("No approved cut plan; the weld count was not compared.");
    case "fitup_yok": return cevir("W{0} has no fit-up form; its values were not compared.", n.no);
    case "kaynakci_belirsiz": return cevir("Initials {0} match several welders; the welder was not chosen.", n.deger);
    case "kaynakci": return cevir("Initials {0}: welder {1} ({2}).", n.deger, n.ad, n.kod);
    case "wps_yok": return cevir("WPS {0} is not in Registers; preheat and interpass were not compared.", n.kod);
    case "wps_sinirsiz": return cevir("Registers has no preheat or interpass limit for WPS {0}.", n.kod);
    case "lot_yok": return cevir("Lot {0} is not in Registers; its type was not compared.", n.lot);
    case "stok_paketi": return cevir("New part {0} is in stock package {1}.", n.sn, n.paket);
    case "kural":
      if (n.kural === "K28") return cevir("Welder qualification on the weld date (WPQ-01) and date order (GEN-14) are not checked: the historical-entry list (K28) waits.");
      if (n.kural === "WPQ-03") return cevir("Qualification range of the weld (WPQ-03) is not checked: its rule (diameter, thickness, position) waits for approval.");
      return cevir("Known misprints (WPS-07) are not used: the list of known misprints waits for approval.");
    // D-074 Faz 3 · PR 15 (M7-20): WPQ-03'ün proses ve WPS kısmı kaynakçıların okunmuş yeterlilikleriyle.
    case "wpq03_kismi": return cevir("Qualification range of the weld (WPQ-03): process and WPS are checked against the welders’ read qualifications; diameter, thickness and position wait for approval.");
    case "yeterlilik_yok": return cevir("Welder {0} has no read qualification in OASIS; WPQ-03 is not checked for this welder.", n.kod);
    case "proses_bilinmiyor": return cevir("The process of welder {0} could not be compared: a process on the qualification is not one OASIS knows.", n.kod);
    // D-074 Faz 3 · PR 18 (M9-21): SARF-03 ve WPS-06 WPS'in okunmuş dolgu listesiyle.
    case "dolgu_kismi": return cevir("Consumable class and filler name are checked against the read WPS and its filler approval sheets (SARF-03, WPS-06). Receipt date and size of the lot (SARF-04, SARF-05) are not checked on weld maps yet.");
    case "dolgu_listesi_yok": return cevir("WPS {0} has no read filler list in OASIS; SARF-03 and WPS-06 are not checked for it.", n.kod);
    case "veri_yok":
      if (n.kod === "WM-04") return cevir("Heat of the new part (WM-04) is checked when packing lists and mill certificates are read.");
      // SARF-03 ve SARF-05 aynı cümledir (weldMapNotMetinleri yinelenen cümleyi bir kez verir).
      return cevir("Consumable class against the WPS filler list (SARF-03), receipt date and size of the lot (SARF-04, SARF-05) are checked when WPS and consumable documents are read.");
  }
}

/** Notların cümleleri sırayla, yinelenen cümle bir kez (SARF-03 ve SARF-05 aynı cümledir); şüpheli değer notu "check" noktasıyla. */
export const weldMapNotMetinleri = (l: readonly WeldMapNotu[]): { metin: string; suphe: boolean }[] =>
  l.reduce<{ metin: string; suphe: boolean }[]>((t, n) => {
    const metin = weldMapNotMetni(n);
    if (!t.some((x) => x.metin === metin)) t.push({ metin, suphe: n.tur === "suphe" });
    return t;
  }, []);

const degerOf = (l: readonly OkunanDeger[], alan: string): OkunanDeger | null => l.find((d) => d.alan === alan) ?? null;
const tekil = (l: readonly string[]) => [...new Set(l.filter(Boolean))];
const santigratsiz = (v: string) => v.replace(/\s*°\s*C$/i, "");

/** Kaynağın iki sayfadaki kesin çizim ucu (Z46, `cizimUcuMetni`): "box end" ya da "pin end (p.1), box end (p.2)"; uç yoksa null. */
export function weldMapUcMetni(k: Pick<WeldMapKartKaynagi, "degerler">): string | null {
  const d1 = degerOf(k.degerler, "cizim_ucu");
  const d2 = degerOf(k.degerler, "cizim_ucu_2");
  const u1 = d1?.kesinlik === "kesin" ? cizimUcu(d1.deger) : null;
  const u2 = d2?.kesinlik === "kesin" ? cizimUcu(d2.deger) : null;
  const c = cizimUcuMetni(u1, d1?.sayfa ?? null, u2, d2?.sayfa ?? null);
  if (c.farkli) return cevir("{0} end (p.{1}), {2} end (p.{3})", u1!, d1?.sayfa ?? "—", u2!, d2?.sayfa ?? "—");
  return c.uc ? cevir("{0} end", c.uc) : null;
}

/**
 * Kaynağın weld map'teki özeti ("On the weld map"): uç · WPS ve rev'ler · kaynakçılar · lotlar · satır tarihleri ("box end · WPS W-99901 rev 3 ·
 * welders A.S, B.S · lots 99L001, 99L003 · 4 rows dated 2099-03-14"). Yalnız okunmuş değerler; boş parçalar atlanır.
 */
export function weldMapKaynakHaritada(k: Pick<WeldMapKartKaynagi, "degerler" | "pasolar">): string {
  const d = (p: WeldMapPasoOkumasi, alan: string) => degerOf(p.degerler, alan)?.deger ?? null;
  const wps = tekil(k.pasolar.map((p) => (d(p, "wps") ? cevir("WPS {0} rev {1}", d(p, "wps")!, d(p, "wps_rev") ?? "—") : "")));
  const kaynakcilar = tekil(k.pasolar.map((p) => d(p, "kaynakci") ?? ""));
  const lotlar = tekil(k.pasolar.map((p) => d(p, "lot") ?? ""));
  const gunler = tekil(k.pasolar.map((p) => d(p, "tarih") ?? ""));
  const tarihli = k.pasolar.filter((p) => d(p, "tarih")).length;
  return [
    weldMapUcMetni(k),
    wps.length ? wps.join(", ") : null,
    kaynakcilar.length ? cevir("welders {0}", kaynakcilar.join(", ")) : null,
    lotlar.length ? cevir("lots {0}", lotlar.join(", ")) : null,
    gunler.length === 1 ? cevir("{0} rows dated {1}", tarihli, gunler[0]!) : gunler.length > 1 ? cevir("rows dated {0}", gunler.join(" and ")) : null,
  ].filter(Boolean).join(" · ");
}

/** Kaynağın OASIS'teki hâli ("In OASIS (this job)"): joint · fit-up · paso kaydı sayısı; işte yoksa "not a weld of this job". */
export function weldMapKaynakOasis(k: Pick<WeldMapKartKaynagi, "oasis">): string {
  const o = k.oasis;
  if (!o) return cevir("not a weld of this job");
  return [
    o.joint,
    o.fitup ? cevir("fit-up: WPS {0}, welders {1}, lots {2}", o.fitup.wps ?? "—", o.fitup.kaynakcilar.join(", ") || "—", o.fitup.lotlar.join(", ") || "—") : cevir("no fit-up form"),
    o.pasoSayisi ? cevir("{0} pass records", o.pasoSayisi) : cevir("no pass records"),
  ].filter(Boolean).join(" · ");
}

/** Kaynağın sonucu (Result): bu kaynaktan çıkan kodlar; yoksa ve kaynak işteyse "✓ OK", işte yoksa "—". */
export const weldMapKaynakSonucu = (k: Pick<WeldMapKartKaynagi, "kodlar" | "oasis">): string =>
  k.kodlar.length ? k.kodlar.join(" · ") : k.oasis ? cevir("✓ OK") : "—";

/** Kaynak tarihi önerisinin cümlesi (Z20): önerilen gün ya da önerilmeme nedeni. */
export function weldMapTarihMetni(k: Pick<WeldMapKartKaynagi, "tarih" | "pasolar">): string {
  const t = k.tarih;
  if (t.gun && t.neden === null) return cevir("{0} on every row", tarih(t.gun));
  switch (t.neden) {
    case "farkli": return cevir("Not proposed: the rows show {0}.", t.gunler.map((g) => tarih(g)).join(", "));
    case "suphe": return cevir("Not proposed: a date on the rows is uncertain or missing. Check it on the page.");
    case "yok": return cevir("Not proposed: no date on the rows.");
    case "bicim": {
      const v = k.pasolar.map((p) => degerOf(p.degerler, "tarih")).find((d) => d?.kesinlik === "kesin" && d.deger && !ISO_GUN.test(d.deger.trim()))?.deger ?? "—";
      return cevir("Not proposed: {0} is not in a form OASIS reads.", v);
    }
    case "gelecek": return cevir("Not proposed: {0} is after today.", tarih(t.gunler[0] ?? null));
    default: return cevir("not proposed");
  }
}

/**
 * Açık satırdaki "Weld dates" cümlesi: "Can be recorded…" eki yalnız işte kaynak varken ve kaynağın OASIS'te tarihi yokken yazılır (dolu tarih
 * değişmez; kaynak işte yoksa kayıt da yoktur). OASIS'teki tarih farklıysa iki değer yan yana gibi "OASIS keeps its date" (Z21).
 */
export function weldMapAcikTarihMetni(k: Pick<WeldMapKartKaynagi, "tarih" | "pasolar" | "oasis">): string {
  const t = k.tarih;
  if (!(t.gun && t.neden === null)) return weldMapTarihMetni(k);
  if (k.oasis && !k.oasis.kayitliTarih) return cevir("{0} on every row. Can be recorded for the weld after filing.", tarih(t.gun));
  if (k.oasis?.kayitliTarih && k.oasis.kayitliTarih !== t.gun) return `${cevir("{0} on every row", tarih(t.gun))} · ${cevir("OASIS keeps its date")}`;
  return cevir("{0} on every row", tarih(t.gun));
}

/**
 * Önerilen yerin açıklaması: yer önerisinin kullandığı değerler (Z10, yalnız kesin): riser no, yoksa riser SN; hat SN, yoksa ikinci hat SN.
 */
export function weldMapYerOneriMetni(l: readonly OkunanDeger[]): string {
  const kesin = (alan: string) => { const d = degerOf(l, alan); return d?.kesinlik === "kesin" ? d.deger : null; };
  const hatSn = kesin("hat_sn") ?? kesin("hat_sn_2") ?? "—";
  const riserNo = kesin("riser_no");
  return riserNo
    ? cevir("Proposed from riser {0} and line SN {1}.", riserNo, hatSn)
    : cevir("Proposed from riser SN {0} and line SN {1}.", kesin("riser_sn") ?? "—", hatSn);
}

/**
 * Okunan satırın tek satırı ("Rows read from the weld map"): WPS + rev · sarf tipi · lot · kaynakçı · tarih · ön ısıtma · paso arası. Boş değerler
 * atlanır; şüpheli değer de yazılır (satırın noktası "check" olur). Run, proses, çap, amper, volt ve gaz okunmaz.
 */
export function weldMapPasoSatiri(p: Pick<WeldMapPasoOkumasi, "degerler">): string {
  const d = (alan: string) => degerOf(p.degerler, alan)?.deger ?? null;
  const wps = d("wps");
  const rev = d("wps_rev");
  const on = d("on_isitma");
  const ara = d("paso_arasi");
  return [
    wps ? (rev ? cevir("WPS {0} rev {1}", wps, rev) : `WPS ${wps}`) : null,
    d("sarf_tipi"),
    d("lot") ? cevir("lot {0}", d("lot")!) : null,
    d("kaynakci"),
    d("tarih"),
    on ? cevir("preheat {0} °C", santigratsiz(on)) : null,
    ara ? cevir("interpass {0} °C", santigratsiz(ara)) : null,
  ].filter(Boolean).join(" · ");
}

/** Satırın noktası: bir değer şüpheliyse "suphe", hepsi boşsa "bos", değilse "kesin". */
export const weldMapPasoKesinligi = (p: Pick<WeldMapPasoOkumasi, "degerler">): "kesin" | "suphe" | "bos" =>
  p.degerler.some((d) => d.kesinlik === "suphe") ? "suphe" : p.degerler.every((d) => d.kesinlik === "bos") ? "bos" : "kesin";

/**
 * Z14 yer kapısı (sunucuda da var): okunmuş weld map yalnız okumanın yerine (parçanın yeri) dosyalanır. Okuma yoksa, formun yeri weld map
 * değilse ya da seçilmemişken null; güncel okuma weld map okuması değilse (karşılaştırma yok) cümle.
 */
export function weldMapYerEngeli(k: Pick<WeldMapKarti, "okuma" | "yer" | "karsilastirma"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.okuma || hedef?.tur !== "weldmap") return null;
  if (!k.karsilastirma) return cevir(KARSILASTIRMA_YERI_METNI);
  return hedefEsit(k.yer?.yer ?? null, hedef) ? null : cevir(KARSILASTIRMA_YERI_METNI);
}

/** Z14 karar kapısı (T21): kararsız kırmızı ya da "Do not file" kararı varken dosyalanmaz; kapı yoksa null. */
export function weldMapDosyalamaEngeli(k: Pick<WeldMapKarti, "karsilastirma"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.karsilastirma || hedef?.tur !== "weldmap") return null;
  const e = dosyalamaEngeli(k.karsilastirma.uyarilar, false);
  return e ? cevir(DOSYALAMA_ENGEL_METNI[e]) : null;
}

/** Sunucunun kaynak tarihi engel cümlesi (`KAYNAK_TARIHI_METINLERI`); kaynak adı geçen iki cümle kalıpla çevrilir. */
export function weldMapEngelMetni(e: string): string {
  const yok = /^(W\d+) is not a weld of this job\.$/.exec(e);
  if (yok) return cevir("{0} is not a weld of this job.", yok[1]!);
  const dolu = /^(W\d+) already has a weld date; it is not changed\.$/.exec(e);
  if (dolu) return cevir("{0} already has a weld date; it is not changed.", dolu[1]!);
  return cevir(e);
}

/* ------------------------------------------------------------ PWHT grafiği okuması (D-074 Faz 2 · PR 11) ------------------------------------------------------------ */

/** G3: iş seçicisi: aktif adımı PWHT adımı olan işler. */
export const pwhtIsleri = (i: readonly IsSecenegi[]): IsSecenegi[] => i.filter((x) => Boolean(x.aktifAdim && pwhtAdimiMi(x.aktifAdim)));

/** Yerin satırının açıklaması (G15): önerinin kaynağı ya da önerilmeme nedeni. */
export function pwhtNedenMetni(neden: PwhtOneriNedeni | null, kaynak: PwhtOneriKaynagi | null = null): string {
  if (kaynak === "weldmap") return cevir("Proposed from the weld map of the same file.");
  if (kaynak === "kanal") return cevir("Proposed from the channels of the chart.");
  switch (neden) {
    case "kanal_yok": return cevir("No job on the chart could be found in OASIS. Choose the job.");
    case "supheli": return cevir("A riser number, SN or weld on the chart is uncertain. Check it on the page and choose the job.");
    case "adim": return cevir("No job on the chart is at its PWHT step. Choose the job or file as reference.");
    case "birden_cok": return cevir("Several jobs on the chart are at their PWHT step. Choose the job.");
    default: return "—";
  }
}

/** PWHT karşılaştırma notunun ekran cümlesi ("Compared with OASIS" altında; uyarı değildir). */
export function pwhtNotMetni(n: PwhtNotu): string {
  const alan = (a: string) => cevir(pwhtEtiketi(a));
  switch (n.tur) {
    case "suphe":
      return n.kanal === null
        ? cevir("Not compared: chart {0} · {1} is uncertain. Check it on the page.", n.grafik, alan(n.alan))
        : cevir("Not compared: chart {0} channel {1} · {2} is uncertain. Check it on the page.", n.grafik, n.kanal, alan(n.alan));
    case "bicim":
      return n.kanal === null
        ? cevir("Not compared: chart {0} · {1} is not in a form OASIS reads ({2}).", n.grafik, alan(n.alan), n.deger)
        : cevir("Not compared: chart {0} channel {1} · {2} is not in a form OASIS reads ({3}).", n.grafik, n.kanal, alan(n.alan), n.deger);
    case "yer_yok": return cevir("No place: only the values that need no place were compared.");
    case "oneri_yok": return pwhtNedenMetni(n.neden);
    case "kanal_eslesmedi":
      switch (n.neden) {
        case "riser_yok": return cevir("Chart {0} channel {1}: riser {2} is not in OASIS.", n.grafik, n.kanal, n.rn ?? "—");
        case "hat_yok": return cevir("Chart {0} channel {1}: the line of SN {2} is not known on riser {3}.", n.grafik, n.kanal, n.sn ?? "—", n.rn ?? "—");
        case "is_yok": return cevir("Chart {0} channel {1}: no job of riser {2} has weld W{3} and a PWHT step.", n.grafik, n.kanal, n.rn ?? "—", n.weldNo ?? "—");
        case "birden_cok": return cevir("Chart {0} channel {1}: several jobs of riser {2} match.", n.grafik, n.kanal, n.rn ?? "—");
        case "suphe": return pwhtNedenMetni("supheli");
      }
      return "—";
    case "hatlar_yok": return cevir("Line SNs of riser {0} are not in OASIS; the SN was not compared.", n.rn);
    case "hat_disi": return cevir("The SN is not compared for the {0} line.", n.hat);
    case "pw01_bakilmadi": return cevir("Welds missing from the chart (PW-01) are not checked: a channel of this riser is uncertain or its line is not known.");
    case "cihaz_kutukte": return cevir("Recorder {0} is {1} in Registers.", n.no, n.kod);
    case "ozet_yok": return cevir("The chart image of chart {0} gave no digest; it is not shared with other files.", n.grafik);
    case "ndt_isleri": return cevir("Used for NDT reports of {0} jobs: stage against the chart date (NR-01).", n.sayi);
    case "kural": return cevir("Date order against the weld and NDT dates (GEN-14) is not checked: the historical-entry list (K28) waits.");
  }
}

/** Notların cümleleri sırayla, yinelenen cümle bir kez; şüpheli değer notu "check" noktasıyla. */
export const pwhtNotMetinleri = (l: readonly PwhtNotu[]): { metin: string; suphe: boolean }[] =>
  l.reduce<{ metin: string; suphe: boolean }[]>((t, n) => {
    const metin = pwhtNotMetni(n);
    if (!t.some((x) => x.metin === metin)) t.push({ metin, suphe: n.tur === "suphe" });
    return t;
  }, []);

/** Kanalın grafikteki yazısı ("riser 999 · SN 9990999-1 · W1"); boş parçalar atlanır. */
export function pwhtKanalMetni(degerler: readonly OkunanDeger[]): string {
  const d = (alan: string) => degerOf(degerler, alan)?.deger ?? null;
  const riser = d("riser_no");
  const sn = d("hat_sn");
  const w = d("kaynak");
  const no = w ? (/^W?\s*(\d+)$/i.exec(w.trim())?.[1] ?? w) : null;
  if (riser && sn && no) return cevir("riser {0} · SN {1} · W{2}", riser, sn, no);
  return [riser ? `riser ${riser}` : null, sn ? `SN ${sn}` : null, no ? `W${no}` : null].filter(Boolean).join(" · ") || "—";
}

/** Kanalın OASIS'teki sonucu: bu iş · başka iş · OASIS'te bulunamadı. */
export function pwhtKanalSonucu(s: Pick<PwhtKanalSonucu, "durum">): string {
  return s.durum === "bu_is" ? cevir("this job") : s.durum === "baska_is" ? cevir("other job") : cevir("not found in OASIS");
}

/** Okunan sürenin metni: izden okunduysa "about 2.1 h (from the trace)"; değilse "2.0 h"; boşsa "—". */
export const pwhtSureMetni = (sure: string | null, yaklasik: boolean): string =>
  !sure ? "—" : yaklasik ? cevir("about {0} h (from the trace)", sure) : cevir("{0} h", sure);

/** Kaynağın grafikteki hâli ("On the chart"): kanallar · süre · tarih; ikinci grafik "also on {kod} ({süre})"; hiç yoksa "not on the chart". */
export function pwhtKaynakGrafikte(k: Pick<PwhtKartKaynagi, "kanallar" | "sureler">): string {
  if (!k.kanallar.length && !k.sureler.length) return cevir("not on the chart");
  const parcalar: string[] = [];
  if (k.kanallar.length) parcalar.push(cevir("channel {0}", [...new Set(k.kanallar.map((c) => c.kanal))].join(", ")));
  for (const s of k.sureler.filter((x) => x.bu)) parcalar.push([pwhtSureMetni(s.sure, s.yaklasik), s.gun ? tarih(s.gun) : null].filter(Boolean).join(" · "));
  for (const s of k.sureler.filter((x) => !x.bu)) parcalar.push(cevir("also on {0} ({1})", s.kod, pwhtSureMetni(s.sure, s.yaklasik)));
  return parcalar.join(" · ");
}

/** Kaynağın OASIS'teki hâli (G21): PWHT imzasının sabit yazısı aynen; fit-up'ın WPS'inin en çok süresi biliniyorsa yanında. */
export function pwhtKaynakOasis(k: Pick<PwhtKartKaynagi, "oasis" | "wps">): string {
  const o = k.oasis;
  const imza = o ? cevir("PWHT signed: {0} · {1} {2}", o.talimat ?? "—", o.kim ?? "—", o.tarih ? tarih(o.tarih) : "") : cevir("no PWHT sign-off yet");
  return k.wps?.max != null ? `${imza} · ${cevir("WPS {0} maximum {1} h", k.wps.kod, k.wps.max)}` : imza;
}

/** Kaynağın sonucu (Result): bu kaynağın kodları; yoksa "✓ OK". */
export const pwhtKaynakSonucu = (k: Pick<PwhtKartKaynagi, "kodlar">): string => (k.kodlar.length ? k.kodlar.join(" · ") : cevir("✓ OK"));

/** G18 "Use these pages": grafik sayfaları virgülle (her grafik ayrı rapor: "3,4"); grafik yoksa null. */
export const pwhtSayfalari = (k: Pick<PwhtKarti, "grafikler">): string | null =>
  k.grafikler.length ? [...new Set(k.grafikler.map((g) => g.sayfa))].sort((a, b) => a - b).join(",") : null;

/** Okumanın bir grafiği ortak kanıt mı ("Effects of filing" cümlesi). */
export const pwhtOrtakMi = (k: Pick<PwhtKarti, "grafikler"> | null | undefined): boolean => Boolean(k?.grafikler.some((g) => g.ortakKanit));

/** G18 yer kapısı (sunucuda da var): okunmuş PWHT grafiği yalnız okumanın yerine dosyalanır. */
export function pwhtYerEngeli(k: Pick<PwhtKarti, "okuma" | "yer" | "karsilastirma"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.okuma || hedef?.tur !== "pwht") return null;
  if (!k.karsilastirma) return cevir(KARSILASTIRMA_YERI_METNI);
  return hedefEsit(k.yer?.yer ?? null, hedef) ? null : cevir(KARSILASTIRMA_YERI_METNI);
}

/** G18 karar kapısı (T21): kararsız kırmızı ya da "Do not file" kararı varken dosyalanmaz; kapı yoksa null. */
export function pwhtDosyalamaEngeli(k: Pick<PwhtKarti, "karsilastirma"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.karsilastirma || hedef?.tur !== "pwht") return null;
  const e = dosyalamaEngeli(k.karsilastirma.uyarilar, false);
  return e ? cevir(DOSYALAMA_ENGEL_METNI[e]) : null;
}

/* ------------------------------------------------------------ NDT sertifikası okuması (D-074 Faz 3 · PR 14) ------------------------------------------------------------ */

/** NDT sertifikası okuma uçları (M6-3; yetki belgeKutuk): sıraya koy / çıkar, elle okuma excel'i ve "Add to Registers". "Compare again" ortak `OKUMA_UCU.karsilastir`. */
export const NDT_SERTIFIKA_UCU = {
  sira: (id: string) => `/belgeler/${id}/ndt-sertifika/okuma`,
  girdi: (id: string) => `/belgeler/${id}/ndt-sertifika/okuma/girdi`,
  yontem: (id: string) => `/belgeler/${id}/ndt-sertifika/yontem`,
} as const;

const ISO_GUN_DESENI = /^\d{4}-\d{2}-\d{2}$/;
const kesinDeger = (l: readonly OkunanDeger[], alan: string): string | null => {
  const d = degerOf(l, alan);
  return d && d.kesinlik === "kesin" && d.deger?.trim() ? d.deger.trim() : null;
};

/** Yerin satırının açıklaması: önerinin kaynağı ya da önerilmeme nedeni. */
export function ndtSertifikaNedenMetni(neden: NdtSertifikaOneriNedeni | null): string {
  switch (neden) {
    case "kayit_yok": return cevir("No NDT inspector with this name in Registers. A PM or System administrator adds the record first; then choose it.");
    case "birden_cok": return cevir("Several NDT inspectors have this name. Choose the inspector.");
    case "ad_suphe": return cevir("The holder name is uncertain. Check it on the page and choose the inspector.");
    case "ad_yok": return cevir("The holder name was not read. Choose the inspector.");
    default: return cevir("Proposed from the holder name (same name in Registers).");
  }
}

/** Notun alan adı: sertifika değeri ("Certificate number") ya da satır değeri ("Row 2 · Level"). */
const ndtSertifikaNotAlani = (satir: number | null, alan: string) => (satir === null ? cevir(ndtSertifikaEtiketi(alan)) : cevir("Row {0} · {1}", satir, cevir(ndtSertifikaEtiketi(alan))));

/** NDT sertifikası karşılaştırma notunun ekran cümlesi ("Compared with OASIS" altında; uyarı değildir). */
export function ndtSertifikaNotMetni(n: NdtSertifikaNotu): string {
  switch (n.tur) {
    case "suphe": return cevir("Not compared: {0} is uncertain. Check it on the page.", ndtSertifikaNotAlani(n.satir, n.alan));
    case "bicim": return cevir("Not compared: {0} is not in a form OASIS reads ({1}).", ndtSertifikaNotAlani(n.satir, n.alan), n.deger);
    case "oneri_yok": return ndtSertifikaNedenMetni(n.neden);
    case "isveren_yok": return cevir("Scheme SNT-TC-1A without an employer on the certificate.");
    case "sektor_bilinmiyor": return cevir("Sectors could not be compared: {0}.", n.deger);
    case "yontem_disi": return cevir("Not an OASIS method on row {0}: {1}.", n.satir, n.deger);
  }
}

/**
 * "Compared with OASIS" satırları: karşılaştırılanlar (ad kütükle aynı, şema işverene bağlı değil, sektörler kapsıyor) ve notlar; yinelenen cümle bir kez.
 * Karşılaştırılan satırlar uyarı değildir; uyarılar ayrı listededir. `kayitAdi`: yerin inspektörünün Registers'taki adı (kartın yer metni).
 */
export function ndtSertifikaKarsilastirmaSatirlari(k: Pick<NdtSertifikaKarti, "degerler" | "yer" | "karsilastirma">, kayitAdi: string | null): { metin: string; suphe: boolean; karsilastirildi: boolean }[] {
  const l: { metin: string; suphe: boolean; karsilastirildi: boolean }[] = [];
  const ekle = (metin: string, suphe: boolean, karsilastirildi: boolean) => { if (!l.some((x) => x.metin === metin)) l.push({ metin, suphe, karsilastirildi }); };
  if (!k.karsilastirma) return l;
  const kirmizi = k.karsilastirma.uyarilar.some((u) => u.kod === "NDT-09");
  if (k.yer && k.yer.durum !== "yok" && kayitAdi && !kirmizi && kesinDeger(k.degerler, "ad")) ekle(cevir("Holder name matches the register: {0}.", kayitAdi), false, true);
  const sema = kesinDeger(k.degerler, "sema");
  if (sema && ndtSemaOku(sema) === "iso9712") ekle(cevir("Scheme {0}: the certificate is not tied to an employer.", sema), false, true);
  const sektor = kesinDeger(k.degerler, "sektorler");
  if (sektor && ndtSektorKapsami(sektor) === "kapsar") ekle(cevir("Sectors {0} cover welds and tubes.", sektor), false, true);
  for (const n of k.karsilastirma.notlar) ekle(ndtSertifikaNotMetni(n), n.tur === "suphe", false);
  return l;
}

/** Dosyalamadan sonraki yeniden karşılaştırmanın satırı; koşu yoksa null. */
export function ndtSertifikaYenidenMetni(y: NdtSertifikaKarti["yenidenKarsilastirma"]): string | null {
  if (!y) return null;
  const ana = cevir("NDT reports of this inspector compared again after filing: {0} readings, {1} changed ({2}).", y.bakilan, y.degisen, tarihSaat(y.ts));
  return y.hata ? `${ana} ${cevir("{0} could not be compared.", y.hata)}` : ana;
}

/** Yöntem satırının sertifikadaki yazısı: "MT · Level 2 · from 05/06/2098 · until 04/06/2103"; OASIS yöntemi değilse sertifikadaki yazı. */
export function ndtSertifikaSatirMetni(s: Pick<NdtSertifikaKartSatiri, "yontem" | "yontemYazisi" | "seviye" | "baslangic" | "bitis" | "degerler">): string {
  const yontem = s.yontem ?? s.yontemYazisi ?? "—";
  const seviye = s.seviye ?? degerOf(s.degerler, "seviye")?.deger ?? "—";
  return [cevir("{0} · Level {1}", yontem, seviye), s.baslangic ? cevir("from {0}", tarih(s.baslangic)) : null, s.bitis ? cevir("until {0}", tarih(s.bitis)) : null].filter(Boolean).join(" · ");
}

/** Satırın Registers'taki karşılığı ("In Registers"): belge no · yöntem · seviye · bitiş; yoksa "—". */
export function ndtSertifikaKayitMetni(s: Pick<NdtSertifikaKartSatiri, "kayit" | "yontem">): string {
  if (!s.kayit) return "—";
  return [s.kayit.belgeNo ?? "—", s.yontem ?? "—", cevir("Level {0}", s.kayit.seviye ?? "—"), s.kayit.gecerlilikSonu ? cevir("until {0}", tarih(s.kayit.gecerlilikSonu)) : null].filter(Boolean).join(" · ");
}

/** Satırın sonucu (Result): Registers'ta (değerler farklıysa söylenir) · henüz yok · OASIS yöntemi değil · kesin değil. "Add to Registers" düğmesini bölüm çizer. */
export function ndtSertifikaSatirSonucu(s: Pick<NdtSertifikaKartSatiri, "durum" | "farkli">): string {
  switch (s.durum) {
    case "kayitta": return s.farkli ? `${cevir("✓ in Registers")} · ${cevir("Values differ")}` : cevir("✓ in Registers");
    case "yontem_disi": return cevir("not an OASIS method");
    case "kesin_degil": return cevir("not certain: add it on Registers by hand");
    case "dosyalanmadi": case "eklenebilir": return cevir("not in Registers yet");
  }
}

/**
 * M6-16 "Use the reading": dosyalama formunun alanları seçilen yöntem satırının YALNIZ kesin değerleriyle; şüpheli, boş ve OASIS'in okumadığı biçimdeki
 * değerler boş kalır (K29 kör yazma). Sunucuya yazmaz. Anahtarlar `KutukFormu`'nun alanlarıdır.
 */
export function ndtSertifikaFormu(k: Pick<NdtSertifikaKarti, "degerler" | "satirlar">, sira: number): Record<string, string> {
  const s = k.satirlar.find((x) => x.sira === sira);
  const tarihDegeri = kesinDeger(k.degerler, "duzenleme_tarihi");
  return {
    belgeNo: kesinDeger(k.degerler, "sertifika_no") ?? "",
    yontem: s?.yontem ?? "",
    seviye: s?.seviye ?? "",
    tarih: tarihDegeri && ISO_GUN_DESENI.test(tarihDegeri) ? tarihDegeri : "",
    gecerlilikSonu: s?.bitis ?? "",
  };
}

/** Okunmuş NDT sertifikasının yer kapısı (M6-15; sunucuda da var): yalnız okumanın yerine (inspektöre) dosyalanır. */
export function ndtSertifikaYerEngeli(k: Pick<NdtSertifikaKarti, "okuma" | "yer" | "karsilastirma"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.okuma || hedef?.tur !== "kutuk" || hedef.kutuk !== "ndt_inspektor") return null;
  if (!k.karsilastirma) return cevir(KARSILASTIRMA_YERI_METNI);
  return hedefEsit(k.yer?.yer ?? null, hedef) ? null : cevir(KARSILASTIRMA_YERI_METNI);
}

/** Karar kapısı (T21): kararsız kırmızı (NDT-09) ya da "Do not file" kararı varken dosyalanmaz; kapı yoksa null. */
export function ndtSertifikaDosyalamaEngeli(k: Pick<NdtSertifikaKarti, "karsilastirma"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.karsilastirma || hedef?.tur !== "kutuk" || hedef.kutuk !== "ndt_inspektor") return null;
  const e = dosyalamaEngeli(k.karsilastirma.uyarilar, false);
  return e ? cevir(DOSYALAMA_ENGEL_METNI[e]) : null;
}

/* ------------------------------------------------------------ kaynakçı belgesi okuması (D-074 Faz 3 · PR 15) ------------------------------------------------------------ */

/** Kaynakçı belgesi okuma uçları (M7-3; yetki belgeKutuk): sıraya koy / çıkar, elle okuma excel'i ve süreklilik satırının "Add to Registers"ı. "Compare again" ortak `OKUMA_UCU.karsilastir`. */
export const WPQ_UCU = {
  sira: (id: string) => `/belgeler/${id}/wpq/okuma`,
  girdi: (id: string) => `/belgeler/${id}/wpq/okuma/girdi`,
  sureklilik: (id: string) => `/belgeler/${id}/wpq/sureklilik`,
} as const;

/** Yerin satırının açıklaması: önerinin kaynağı ya da önerilmeme nedeni (`eslesti` notu önerinin hangi alanla yapıldığını söyler). */
export function wpqNedenMetni(neden: WpqOneriNedeni | null): string {
  switch (neden) {
    case "kayit_yok": return cevir("No welder with this code or name in Registers. A PM or System administrator adds the record first; then choose it.");
    case "birden_cok": return cevir("Several welders have this name. Choose the welder.");
    case "suphe": return cevir("The welder code or name is uncertain. Check it on the page and choose the welder.");
    case "kod_ad_yok": return cevir("Neither the welder code nor the name was read. Choose the welder.");
    case "kod_ad_farkli": return cevir("The welder code and the name on the document point to different records in Registers. Choose the welder.");
    default: return cevir("Proposed from the welder code (same code in Registers).");
  }
}

/** Notun alan adı: belge değeri ("Test date"), yeterlilik satırı ("Qualification row 2 · WPS") ya da süreklilik satırı ("Continuity row 1 · Date"). */
const wpqNotAlani = (tablo: WpqTablo, satir: number | null, alan: string) =>
  tablo === "belge" || satir === null ? cevir(wpqEtiketi(alan))
    : tablo === "yeterlilik" ? cevir("Qualification row {0} · {1}", satir, cevir(wpqEtiketi(alan))) : cevir("Continuity row {0} · {1}", satir, cevir(wpqEtiketi(alan)));

/** Kaynakçı belgesi karşılaştırma notunun ekran cümlesi ("Compared with OASIS" altında; uyarı değildir). */
export function wpqNotMetni(n: WpqNotu): string {
  switch (n.tur) {
    case "suphe": return cevir("Not compared: {0} is uncertain. Check it on the page.", wpqNotAlani(n.tablo, n.satir, n.alan));
    case "bicim": return cevir("Not compared: {0} is not in a form OASIS reads ({1}).", wpqNotAlani(n.tablo, n.satir, n.alan), n.deger);
    case "gun_ay": return cevir("Day and month order unclear on {0}: {1}. Check the date on the page.", wpqNotAlani(n.tablo, n.satir, n.alan), n.deger);
    case "oneri_yok": return wpqNedenMetni(n.neden);
    case "eslesti":
      if (n.ile === "kod_ad") return cevir("Welder code and name match the register: {0}.", `${n.kod} · ${n.ad}`);
      if (n.ile === "kod") return cevir("Welder code matches the register: {0}.", `${n.kod} · ${n.ad}`);
      return cevir("Welder name matches the register: {0}.", `${n.kod} · ${n.ad}`);
    case "ad_farkli": return cevir("Name on the document differs from the register: {0} / {1}.", n.okunan, n.kayit);
    case "kod_farkli": return cevir("Welder code on the document differs from the register: {0} / {1}.", n.okunan, n.kayit);
    case "standart_disi": return cevir("Standard {0} is not one of the Registers standards; choose it by hand.", n.deger);
    case "proses_disi": return cevir("Process {0} on row {1} is not one OASIS knows (TIG, SMAW, SAW); the weld map does not check the process of this welder.", n.deger, n.satir);
    case "wps_tamam": return cevir("WPS of every qualification row is in Registers.");
    case "sureklilik_gelecek": return cevir("Continuity row {0} is due on {1}; it is checked again when you compare again.", n.satir, tarih(n.tarih));
  }
}

/** "Compared with OASIS" satırları: notlar; yinelenen cümle bir kez. Karşılaştırılan satırlar uyarı değildir; uyarılar ayrı listededir. */
export function wpqKarsilastirmaSatirlari(k: Pick<WpqKarti, "karsilastirma">): { metin: string; suphe: boolean; karsilastirildi: boolean }[] {
  const l: { metin: string; suphe: boolean; karsilastirildi: boolean }[] = [];
  if (!k.karsilastirma) return l;
  for (const n of k.karsilastirma.notlar) {
    const metin = wpqNotMetni(n);
    if (!l.some((x) => x.metin === metin)) l.push({ metin, suphe: n.tur === "suphe" || n.tur === "gun_ay", karsilastirildi: n.tur === "eslesti" || n.tur === "wps_tamam" });
  }
  return l;
}

/** WPQ dosyalandıktan sonraki weld map yeniden karşılaştırmasının satırı; koşu yoksa null. */
export function wpqYenidenMetni(y: WpqKarti["yenidenKarsilastirma"]): string | null {
  if (!y) return null;
  const ana = cevir("Weld map readings of this welder compared again after filing: {0} readings, {1} changed ({2}).", y.bakilan, y.degisen, tarihSaat(y.ts));
  return y.hata ? `${ana} ${cevir("{0} could not be compared.", y.hata)}` : ana;
}

/** Yeterlilik satırının belgedeki yazısı: "{proses} · {wps}"; değer okunmadıysa "—". */
export function wpqYeterlilikMetni(s: Pick<WpqYeterlilikKartSatiri, "proses" | "wps" | "degerler">): string {
  const proses = s.proses ?? degerOf(s.degerler, "proses")?.deger ?? "—";
  const wps = s.wps ?? degerOf(s.degerler, "wps")?.deger ?? "—";
  return `${proses} · ${wps}`;
}

/** Yeterlilik satırının sonucu (Result): WPS Registers'ta mı. */
export function wpqYeterlilikSonucu(s: Pick<WpqYeterlilikKartSatiri, "wpsKayitta">): string {
  return s.wpsKayitta === null ? cevir("no WPS read") : s.wpsKayitta ? cevir("WPS in Registers") : cevir("WPS not in Registers");
}

/** Süreklilik satırının belgedeki yazısı: "{tarih} · signed" / "· not signed"; tarih okunmadıysa "—". */
export function wpqSureklilikMetni(s: Pick<WpqSureklilikKartSatiri, "tarih" | "imza" | "degerler">): string {
  const t = s.tarih ? tarih(s.tarih) : degerOf(s.degerler, "tarih")?.deger ?? "—";
  const imza = s.imza === "imzali" ? cevir("signed") : s.imza === "imzasiz" ? cevir("not signed") : degerOf(s.degerler, "imza")?.deger ?? "—";
  return `${t} · ${imza}`;
}

/** Süreklilik satırının sonucu (Result). "Add to Registers" düğmesini bölüm çizer. */
export function wpqSureklilikSonucu(s: Pick<WpqSureklilikKartSatiri, "durum">): string {
  switch (s.durum) {
    case "kayitta": return cevir("✓ in Registers");
    case "imzasiz": return cevir("not signed: not added");
    case "kesin_degil": return cevir("not certain: add it on Registers by hand");
    case "dosyalanmadi": return cevir("added after filing");
    case "kaldirildi": return cevir("removed in Registers: add it there by hand");
    case "eklenebilir": return cevir("not in Registers yet");
  }
}

/**
 * M7-17 "Use the reading": dosyalama formunun alanları YALNIZ kesin değerlerle; şüpheli, boş ve OASIS'in okumadığı biçimdeki değerler boş kalır (K29 kör yazma).
 * WPQ'da Standard (`kaynakciStandartOku`), Date (test tarihi) ve End of validity (belge düzeyi; yoksa bütün yeterlilik satırlarında aynı bitiş); süreklilik
 * kaydında Date = en yeni imzalı satırın tarihi. Doc no. ve Note boş kalır (okunmaz). Sunucuya yazmaz. Anahtarlar `KutukFormu`'nun alanlarıdır.
 */
export function wpqFormu(k: Pick<WpqKarti, "cins" | "degerler" | "yeterlilikler" | "sureklilik">): Record<string, string> {
  const iso = (v: string | null | undefined) => (v && ISO_GUN_DESENI.test(v) ? v : "");
  if (k.cins === "sureklilik") {
    const imzali = k.sureklilik.filter((s) => s.imza === "imzali" && s.tarih).map((s) => s.tarih!).sort();
    return { tarih: iso(imzali.at(-1)) };
  }
  const bitisler = k.yeterlilikler.map((s) => s.bitis);
  const ortak = bitisler.length > 0 && bitisler.every((b) => b !== null && b === bitisler[0]) ? bitisler[0]! : "";
  return {
    standart: kaynakciStandartOku(kesinDeger(k.degerler, "standart")) ?? "",
    tarih: iso(kesinDeger(k.degerler, "test_tarihi")),
    gecerlilikSonu: iso(kesinDeger(k.degerler, "gecerlilik_sonu")) || iso(ortak),
  };
}

/** Okunmuş kaynakçı belgesinin yer kapısı (M7-16; sunucuda da var): yalnız okumanın yerine (kaynakçıya) dosyalanır. */
export function wpqYerEngeli(k: Pick<WpqKarti, "okuma" | "yer" | "karsilastirma"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.okuma || hedef?.tur !== "kutuk" || hedef.kutuk !== "kaynakci") return null;
  if (!k.karsilastirma) return cevir(KARSILASTIRMA_YERI_METNI);
  return hedefEsit(k.yer?.yer ?? null, hedef) ? null : cevir(KARSILASTIRMA_YERI_METNI);
}

/** Karar kapısı (T21): kararsız kırmızı ya da "Do not file" kararı varken dosyalanmaz (bu türde kırmızı yok; kapı genel kuraldır); kapı yoksa null. */
export function wpqDosyalamaEngeli(k: Pick<WpqKarti, "karsilastirma"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.karsilastirma || hedef?.tur !== "kutuk" || hedef.kutuk !== "kaynakci") return null;
  const e = dosyalamaEngeli(k.karsilastirma.uyarilar, false);
  return e ? cevir(DOSYALAMA_ENGEL_METNI[e]) : null;
}

/* ------------------------------------------------------------ kalibrasyon sertifikası okuması (D-074 Faz 3 · PR 16) ------------------------------------------------------------ */

/** Kalibrasyon sertifikası okuma uçları (M1-3; yetki belgeKutuk): sıraya koy / çıkar, elle okuma excel'i ve cihazın "Add to Registers"ı. "Compare again" ortak `OKUMA_UCU.karsilastir`. */
export const KALIBRASYON_UCU = {
  sira: (id: string) => `/belgeler/${id}/kalibrasyon/okuma`,
  girdi: (id: string) => `/belgeler/${id}/kalibrasyon/okuma/girdi`,
  cihaz: (id: string) => `/belgeler/${id}/kalibrasyon/cihaz`,
} as const;

/** Cihazın yerinin açıklaması: önerinin kaynağı (`ile`: seri no ya da kod) ya da önerilmeme nedeni. */
export function kalibrasyonNedenMetni(neden: KalibrasyonOneriNedeni | null, ile: "seri" | "kod" | null = "seri"): string {
  switch (neden) {
    case "kayit_yok": return cevir("No instrument with this serial number or code in Registers. A PM or System administrator adds the instrument first; then compare again.");
    case "birden_cok": return cevir("Several instruments have this serial number or code. Choose the instrument.");
    case "seri_kod_farkli": return cevir("The serial number and the code point to different instruments. Choose the instrument.");
    case "kod_seri_farkli": return cevir("The instrument with this code has another serial number in Registers. Choose the instrument.");
    case "suphe": return cevir("The serial number and the code are uncertain. Check them on the page and choose the instrument.");
    case "kimlik_yok": return cevir("Neither a serial number nor an instrument code was read. Choose the instrument.");
    default: return ile === "kod" ? cevir("Proposed from the instrument code (same code in Registers).") : cevir("Proposed from the serial number (same serial number in Registers).");
  }
}

/** Kalibrasyon sertifikası karşılaştırma notunun ekran cümlesi ("Compared with OASIS" altında; uyarı değildir). `cihazlar`: eşleşme notunda okunan seri no için. */
export function kalibrasyonNotMetni(n: KalibrasyonNotu, cihazlar: readonly Pick<KalibrasyonKartCihazi, "sira" | "seriNo">[] = []): string {
  const alan = (a: string) => cevir(kalibrasyonEtiketi(a));
  switch (n.tur) {
    case "suphe": return cevir("Device {0}: Not compared: {1} is uncertain. Check it on the page.", n.cihaz, alan(n.alan));
    case "bicim": return cevir("Device {0}: Not compared: {1} is not in a form OASIS reads ({2}).", n.cihaz, alan(n.alan), n.deger);
    case "gun_ay": return cevir("Device {0}: day and month order unclear on {1}: {2}. Check the date on the page.", n.cihaz, alan(n.alan), n.deger);
    case "oneri_yok": return `${cevir("Device {0}", n.cihaz)}: ${kalibrasyonNedenMetni(n.neden)}`;
    case "eslesti":
      return n.ile === "seri"
        ? cevir("Device {0}: serial number matches the register: {1} ({2}).", n.cihaz, cihazlar.find((c) => c.sira === n.cihaz)?.seriNo ?? n.kod, n.kod)
        : cevir("Device {0}: instrument code matches the register: {1}.", n.cihaz, n.kod);
    case "seri_kayitta_yok": return cevir("Device {0}: {1} has no serial number in Registers; matched by its code.", n.cihaz, n.kod);
    case "akredite": return cevir("Device {0}: accredited calibration: {1}.", n.cihaz, n.deger);
    case "bitis_yok":
      return n.kod
        ? cevir("Device {0}: due date not printed. Calibration end of {1} stays as it is; OASIS does not compute one.", n.cihaz, n.kod)
        : cevir("Device {0}: due date not printed. OASIS does not compute one.", n.cihaz);
    case "kisi_cihazsiz": return cevir("The chosen instrument {0} matches no device of the file, so the file cannot be filed there. Choose the instrument of a device, or add the instrument on Registers and use Compare again.", n.anahtar);
    case "aralik_basinc_disi": return cevir("Device {0}: the range unit {1} is not a pressure unit; the test pressure is not checked against it.", n.cihaz, n.birim);
  }
}

/** "Compared with OASIS" satırları: notlar; yinelenen cümle bir kez. Uyarılar ayrı listededir. */
export function kalibrasyonKarsilastirmaSatirlari(k: Pick<KalibrasyonKarti, "karsilastirma" | "cihazlar">): { metin: string; suphe: boolean; karsilastirildi: boolean }[] {
  const l: { metin: string; suphe: boolean; karsilastirildi: boolean }[] = [];
  if (!k.karsilastirma) return l;
  for (const n of k.karsilastirma.notlar) {
    const metin = kalibrasyonNotMetni(n, k.cihazlar);
    if (!l.some((x) => x.metin === metin)) l.push({ metin, suphe: n.tur === "suphe" || n.tur === "gun_ay", karsilastirildi: n.tur === "eslesti" || n.tur === "akredite" });
  }
  return l;
}

/** Dosyalamadan ya da eklemeden sonraki hidrotest ve NDT yeniden karşılaştırmasının satırı; koşu yoksa null. `kod`: dosyalanan aletin kodu. */
export function kalibrasyonYenidenMetni(y: KalibrasyonKarti["yenidenKarsilastirma"], kod?: string | null): string | null {
  if (!y) return null;
  const ana = cevir("Hydrotest and NDT readings that name {0} compared again after filing: {1} readings, {2} changed ({3}).", kod ?? cevir("this instrument"), y.bakilan, y.degisen, tarihSaat(y.ts));
  return y.hata ? `${ana} ${cevir("{0} could not be compared.", y.hata)}` : ana;
}

/** Cihazın sertifikadaki yazısı: "{seri} · {sertifika no}"; cinsi kalibrasyon değilse cinsin adı. */
export function kalibrasyonCihazMetni(c: Pick<KalibrasyonKartCihazi, "cins" | "seriNo" | "sertifikaNo">): string {
  if (c.cins && c.cins !== "kalibrasyon") return cevir(KALIBRASYON_CINSLERI[c.cins]);
  return [c.seriNo, c.sertifikaNo].filter(Boolean).join(" · ") || "—";
}

/** Cihazın sonucu (Result). "Add to Registers" düğmesini bölüm çizer; dosyalanmamış satırda kartın yerindeki cihaz "file this one"dır. */
export function kalibrasyonCihazSonucu(c: Pick<KalibrasyonKartCihazi, "durum" | "yer">, hedef: GelenHedef | null): string {
  switch (c.durum) {
    case "kayitta": return cevir("✓ in Registers");
    case "cins_disi": return cevir("not a calibration certificate: not added");
    case "yer_yok": return cevir("no instrument in Registers: not added");
    case "dosyalanmadi": return hedef && hedefEsit(c.yer.yer, hedef) ? cevir("file this one") : cevir("added after filing");
    case "kesin_degil": return cevir("not certain: add it on Registers by hand");
    case "eklenebilir": return cevir("not in Registers yet");
  }
}

const sayfaAraligi = (s: { bas: number; son: number }) => (s.bas === s.son ? String(s.bas) : `${s.bas}-${s.son}`);

/**
 * M1-16 "Use the reading": seçilen cihazın YALNIZ kesin değerleriyle dosyalama formunun alanları (Doc no., Lab, Date, Calibration end); şüpheli, boş ve OASIS'in okumadığı
 * biçimdeki değerler boş kalır (K29 kör yazma). `sayfa`: dosyada birden çok cihaz varsa ya da cihazın aralığı PDF'in tamamı değilse cihazın sayfaları ("Pages"); yoksa null.
 * Sunucuya yazmaz. Anahtarlar `KutukFormu`'nun alanlarıdır.
 */
export function kalibrasyonFormu(k: Pick<KalibrasyonKarti, "cihazlar" | "okuma">, sira: number): { alanlar: Record<string, string>; sayfa: string | null } {
  const c = k.cihazlar.find((x) => x.sira === sira);
  if (!c) return { alanlar: {}, sayfa: null };
  const iso = (v: string | null) => (v && ISO_GUN_DESENI.test(v) ? v : "");
  const tamPdf = k.cihazlar.length === 1 && c.sayfalar.bas === 1 && (k.okuma?.sayfaSayisi ?? c.sayfalar.son) === c.sayfalar.son;
  return {
    alanlar: {
      belgeNo: kesinDeger(c.degerler, "sertifika_no") ?? "", duzenleyen: kesinDeger(c.degerler, "laboratuvar") ?? "",
      tarih: iso(kesinDeger(c.degerler, "kalibrasyon_tarihi")), gecerlilikSonu: iso(kesinDeger(c.degerler, "bitis")),
    },
    sayfa: tamPdf ? null : sayfaAraligi(c.sayfalar),
  };
}

/** Kartın yerindeki (formun Record'u) cihaz: cinsi kalibrasyon ve yeri `hedef`; yoksa null. */
const hedefCihazi = (k: Pick<KalibrasyonKarti, "cihazlar"> | null | undefined, hedef: GelenHedef | null) =>
  (hedef?.tur === "kutuk" && hedef.kutuk === "alet" ? k?.cihazlar.find((c) => c.yer.durum !== "yok" && hedefEsit(c.yer.yer, hedef)) : null) ?? null;

/**
 * M1-18 (a): formun o anki Date ve Calibration end değerleriyle D-049'un Calibration end'e etkisi (sunucunun `tarihKurali` hesabı, `kalibrasyonTarihEtkisi`). Formun Record'u
 * dosyanın bir cihazının aleti değilse ya da aletin kaydı yoksa null.
 */
export function kalibrasyonEtkisi(k: Pick<KalibrasyonKarti, "cihazlar"> | null | undefined, hedef: GelenHedef | null, alanlar: Record<string, string>): { kod: string; once: string | null; sonra: string | null } | null {
  const c = hedefCihazi(k, hedef);
  if (!c?.kayit) return null;
  const e = kalibrasyonTarihEtkisi(c.kayit, { tarih: alanlar.tarih?.trim() || null, gecerlilikSonu: alanlar.gecerlilikSonu?.trim() || null });
  return { kod: c.kayit.kod, once: e.once, sonra: e.sonra };
}

/** M1-18: D-049 etkisinin cümlesi ("{1} now, {2} after filing" ya da "stays"); `ek`: Documents dosyalaması ya da "Add to Registers". Tarih gg/aa/yyyy, boş "—". */
export function kalibrasyonEtkiMetni(e: { kod: string; once: string | null; sonra: string | null }, ek: "dosyalama" | "ekleme"): string {
  const once = e.once ? tarih(e.once) : "—";
  if (e.once === e.sonra) return ek === "dosyalama" ? cevir("Calibration end of {0}: {1} now, stays {1} after filing.", e.kod, once) : cevir("Calibration end of {0}: {1} now, stays {1} after adding.", e.kod, once);
  const sonra = e.sonra ? tarih(e.sonra) : "—";
  return ek === "dosyalama" ? cevir("Calibration end of {0}: {1} now, {2} after filing.", e.kod, once, sonra) : cevir("Calibration end of {0}: {1} now, {2} after adding.", e.kod, once, sonra);
}

/** M1-18 (b): "Add to Registers"ın Calibration end'e etkisi, cihazın okunan kesin değerleriyle; aletin kaydı yoksa null. */
export function kalibrasyonEklemeEtkisi(c: Pick<KalibrasyonKartCihazi, "kayit" | "degerler">): string | null {
  if (!c.kayit) return null;
  const iso = (v: string | null) => (v && ISO_GUN_DESENI.test(v) ? v : null);
  const e = kalibrasyonTarihEtkisi(c.kayit, { tarih: iso(kesinDeger(c.degerler, "kalibrasyon_tarihi")), gecerlilikSonu: iso(kesinDeger(c.degerler, "bitis")) });
  return kalibrasyonEtkiMetni({ kod: c.kayit.kod, once: e.once, sonra: e.sonra }, "ekleme");
}

/**
 * Okunmuş kalibrasyon sertifikasının yer kapısı (M1-15; sunucunun `kalibrasyonKapisi` ile aynı kural): okunmuş ve sırada olmayan satırda form bir cihazın aletini
 * göstermeli. Hiçbir cihazın yeri yoksa da (çok cihazlı dosyada eşleşmeyen alet, `kisi_cihazsiz`) yer metni döner; sunucu bu yere dosyalamayı reddeder. Satır sıradayken,
 * okunurken ya da okunamadıyken sunucu yer kapısına bakmaz, burada da bakılmaz.
 */
export function kalibrasyonYerEngeli(k: Pick<KalibrasyonKarti, "okuma" | "cihazlar" | "karsilastirma" | "is"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.okuma || hedef?.tur !== "kutuk" || hedef.kutuk !== "alet") return null;
  if (k.is?.durum) return null;
  if (!k.karsilastirma) return cevir(KARSILASTIRMA_YERI_METNI);
  return k.cihazlar.some((c) => hedefEsit(c.yer.yer, hedef)) ? null : cevir(KARSILASTIRMA_YERI_METNI);
}

/**
 * Karar kapısı (T21, M1-15): formun yerindeki cihazların ve parçasız uyarılarda kararsız kırmızı ya da "Do not file" kararı varken dosyalanmaz; başka cihazın kırmızısı
 * bu cihazı durdurmaz. Yerde cihaz yoksa bütün uyarılar sayılır (sunucunun kapısıyla aynı); kapı yoksa null.
 */
export function kalibrasyonDosyalamaEngeli(k: Pick<KalibrasyonKarti, "cihazlar" | "karsilastirma"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.karsilastirma || hedef?.tur !== "kutuk" || hedef.kutuk !== "alet") return null;
  const yerdekiler = k.cihazlar.filter((c) => hedefEsit(c.yer.yer, hedef));
  const uyarilar = [...(yerdekiler.length ? yerdekiler : k.cihazlar).flatMap((c) => c.uyarilar), ...k.karsilastirma.uyarilar];
  const e = dosyalamaEngeli(uyarilar, false);
  return e ? cevir(DOSYALAMA_ENGEL_METNI[e]) : null;
}

/* ------------------------------------------------------------ sarf belgesi okuması (D-074 Faz 3 · PR 17) ------------------------------------------------------------ */

/** Sarf belgesi okuma uçları (M8-3; yetki belgeKutuk): sıraya koy / çıkar, elle okuma excel'i ve "Record on the lot". "Compare again" ortak `OKUMA_UCU.karsilastir`. */
export const SARF_UCU = {
  sira: (id: string) => `/belgeler/${id}/sarf/okuma`,
  girdi: (id: string) => `/belgeler/${id}/sarf/okuma/girdi`,
  kayit: (id: string) => `/belgeler/${id}/sarf/kayit`,
} as const;

/** Yerin satırının açıklaması: önerinin kaynağı ya da önerilmeme nedeni (`lot`: okunan lot). */
export function sarfNedenMetni(neden: SarfOneriNedeni | null, lot: string | null = null): string {
  switch (neden) {
    case "lot_yok": return cevir("No lot was read. Choose the lot.");
    case "suphe": return cevir("The lot is uncertain. Check it on the page and choose the lot.");
    case "kayit_yok": return cevir("No lot {0} in Registers. A PM or System administrator adds the lot first; then compare again.", lot ?? "—");
    case "birden_cok": return cevir("Several lots in Registers have this lot number. Choose the lot.");
    case "pasif": return cevir("Lot {0} is inactive in Registers. Choose it yourself if it is right.", lot ?? "—");
    default: return cevir("Proposed from the lot (same lot in Registers).");
  }
}

/** Sarf belgesi karşılaştırma notunun ekran cümlesi ("Compared with OASIS" altında; uyarı değildir). */
export function sarfNotMetni(n: SarfNotu): string {
  const alan = (a: string) => cevir(sarfEtiketi(a));
  switch (n.tur) {
    case "suphe": return cevir("Not compared: {0} is uncertain. Check it on the page.", alan(n.alan));
    case "bicim": return cevir("Not compared: {0} is not in a form OASIS reads ({1}).", alan(n.alan), n.deger);
    case "gun_ay": return cevir("Day and month order unclear on {0}: {1}. Check the date on the page.", alan(n.alan), n.deger);
    case "oneri_yok": return sarfNedenMetni(n.neden, n.lot);
    case "eslesti": return cevir("Lot matches the register: {0}.", n.lot);
    case "lot_farkli": return cevir("The chosen lot {0} differs from the lot on the document: {1}.", n.kayit, n.okunan);
    case "sinif_tamam": return cevir("AWS classification matches the register: {0}.", n.deger);
    case "uretici_farkli": return cevir("Manufacturer differs from the Brand of lot {2}: {0} on the document, {1} in Registers.", n.okunan, n.kayit, n.lot);
    case "cap_farkli": return cevir("Diameter differs from Registers: {0} mm on the certificate, {1} mm on lot {2}. Registers is not changed.", String(n.okunan), String(n.kayit), n.lot);
    case "teslim_farkli": return cevir("Received on differs from Registers: {0} on the form, {1} on lot {2}. Registers is not changed.", tarih(n.okunan), tarih(n.kayit), n.lot);
    case "ret": return cevir("The receiving form marks the lot rejected. Received on is not recorded from it.");
    case "karsi_tamam": return n.cins === "kabul" ? cevir("Lot, heat and product number match the filed receiving form.") : cevir("Lot, heat and product number match the filed certificate.");
    case "karsi_yok": return n.cins === "kabul"
      ? cevir("No read receiving form is filed on this lot; lot, heat and product number are not compared (SARF-06).")
      : cevir("No read certificate is filed on this lot; lot, heat and product number are not compared (SARF-06).");
  }
}

/** "Compared with OASIS" satırları: notlar; yinelenen cümle bir kez. Karşılaştırılan satırlar uyarı değildir; uyarılar ayrı listededir. */
export function sarfKarsilastirmaSatirlari(k: Pick<SarfKarti, "karsilastirma">): { metin: string; suphe: boolean; karsilastirildi: boolean }[] {
  const l: { metin: string; suphe: boolean; karsilastirildi: boolean }[] = [];
  if (!k.karsilastirma) return l;
  for (const n of k.karsilastirma.notlar) {
    const metin = sarfNotMetni(n);
    if (!l.some((x) => x.metin === metin)) l.push({ metin, suphe: n.tur === "suphe" || n.tur === "gun_ay", karsilastirildi: n.tur === "eslesti" || n.tur === "sinif_tamam" || n.tur === "karsi_tamam" });
  }
  return l;
}

/** Dosyalamadan sonraki yeniden karşılaştırmanın satırı (o lotun açık sarf belgesi okumaları); koşu yoksa null. */
export function sarfYenidenMetni(y: SarfKarti["yenidenKarsilastirma"], lot?: string | null): string | null {
  if (!y) return null;
  const ana = cevir("Open readings of lot {0} compared again after filing: {1} readings, {2} changed ({3}).", lot ?? cevir("this lot"), y.bakilan, y.degisen, tarihSaat(y.ts));
  return y.hata ? `${ana} ${cevir("{0} could not be compared.", y.hata)}` : ana;
}

/** "Record on the lot" satırının değeri: Received on gün biçiminde, Diameter "{0} mm"; değer yoksa "—". */
export function sarfKayitDegeri(alan: SarfKayitAlani, v: string | null): string {
  if (!v) return "—";
  return alan === "teslim_tarihi" ? tarih(v) : cevir("{0} mm", v);
}

/** "Record on the lot" satırının sonucu (Result). Düğmeyi bölüm çizer (`yazilabilir`). */
export function sarfKayitMetni(s: Pick<SarfKayitSatiri, "durum" | "kayitta" | "alan" | "onay" | "engel">): string {
  switch (s.durum) {
    case "dosyalanmadi": return cevir("recorded after filing");
    case "kesin_degil": return cevir("not certain: not recorded");
    case "ret": return cevir("the form marks the lot rejected: not recorded");
    case "lot_farkli": return cevir("the document names another lot: not recorded");
    case "engel": return s.engel ? cevir(s.engel) : cevir("The reading changed; refresh the page.");
    case "kaydedildi": return s.onay ? cevir("Recorded by {0} on {1}", s.onay.kim, tarihSaat(s.onay.ts)) : cevir("✓ in Registers");
    case "kayit_yok": return cevir("lot not in Registers: not recorded");
    case "kayitta": return cevir("✓ in Registers");
    case "farkli": return cevir("differs: Registers keeps {0}", sarfKayitDegeri(s.alan, s.kayitta));
    case "yazilabilir": return cevir("Record on the lot");
  }
}

/**
 * M8-20 "Use the reading": dosyalama formunun alanları YALNIZ kesin değerlerle; şüpheli, boş ve OASIS'in okumadığı biçimdeki değerler boş kalır (K29 kör yazma).
 * Sertifikada Doc no. (sertifika no), Manufacturer / supplier (üretici) ve Date (sertifika tarihi); kabul formunda Date (teslim tarihi). PO no. doldurulmaz. Sunucuya
 * yazmaz. Anahtarlar `KutukFormu`'nun alanlarıdır.
 */
export function sarfFormu(k: Pick<SarfKarti, "cins" | "degerler">): Record<string, string> {
  const iso = (v: string | null | undefined) => (v && ISO_GUN_DESENI.test(v) ? v : "");
  if (k.cins === "kabul") return { tarih: iso(kesinDeger(k.degerler, "teslim_tarihi")) };
  return { belgeNo: kesinDeger(k.degerler, "sertifika_no") ?? "", duzenleyen: kesinDeger(k.degerler, "uretici") ?? "", tarih: iso(kesinDeger(k.degerler, "tarih")) };
}

/**
 * Okunmuş sarf belgesinin yer kapısı (M8-16; sunucuda da var): yalnız okumanın yerine (lota) dosyalanır. Satır sıradayken, okunurken ya da okunamadıyken sunucu yer
 * kapısına bakmaz, burada da bakılmaz.
 */
export function sarfYerEngeli(k: Pick<SarfKarti, "okuma" | "yer" | "karsilastirma" | "is"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.okuma || hedef?.tur !== "kutuk" || hedef.kutuk !== "sarf") return null;
  if (k.is?.durum) return null;
  if (!k.karsilastirma) return cevir(KARSILASTIRMA_YERI_METNI);
  return hedefEsit(k.yer?.yer ?? null, hedef) ? null : cevir(KARSILASTIRMA_YERI_METNI);
}

/** Karar kapısı (T21, M8-16): kararsız kırmızı ya da "Do not file" kararı varken dosyalanmaz; kapı yoksa null. */
export function sarfDosyalamaEngeli(k: Pick<SarfKarti, "karsilastirma"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.karsilastirma || hedef?.tur !== "kutuk" || hedef.kutuk !== "sarf") return null;
  const e = dosyalamaEngeli(k.karsilastirma.uyarilar, false);
  return e ? cevir(DOSYALAMA_ENGEL_METNI[e]) : null;
}

/* ------------------------------------------------------------ WPS belgesi okuması (D-074 Faz 3 · PR 18) ------------------------------------------------------------ */

/** WPS belgesi okuma uçları (M9-3; yetki belgeKutuk): sıraya koy / çıkar, elle okuma excel'i ve "Mark as superseded". "Compare again" ortak `OKUMA_UCU.karsilastir`. */
export const WPS_UCU = {
  sira: (id: string) => `/belgeler/${id}/wps/okuma`,
  girdi: (id: string) => `/belgeler/${id}/wps/okuma/girdi`,
  eskiSurum: (id: string) => `/belgeler/${id}/wps/eski-surum`,
} as const;

/**
 * Yerin satırının açıklaması: önerinin kaynağı ya da önerilmeme nedeni. `deger`: okunan no (PQR'da `birden_cok` iken WPS kodları); `pqrNo`: PQR'ın okunan no'su; `kod`: önerilen
 * WPS (PQR önerisinde).
 */
export function wpsNedenMetni(neden: WpsOneriNedeni | null, deger: string | null = null, cins: WpsCinsi = "wps", pqrNo: string | null = null, kod: string | null = null): string {
  const pqr = cins === "pqr";
  switch (neden) {
    case "no_yok": return pqr ? cevir("No PQR number was read. Choose the WPS.") : cevir("No WPS number was read. Choose the WPS.");
    case "suphe": return pqr ? cevir("The PQR number is uncertain. Check it on the page and choose the WPS.") : cevir("The WPS number is uncertain. Check it on the page and choose the WPS.");
    case "kayit_yok": return cevir("No WPS {0} in Registers. A PM or System administrator adds the WPS first; then compare again.", deger ?? "—");
    case "birden_cok": return pqr ? cevir("Several read WPSs name PQR {0}: {1}. Choose the WPS.", pqrNo ?? "—", deger ?? "—") : cevir("Several WPS records in Registers have this number. Choose the WPS.");
    case "pasif": return cevir("WPS {0} is inactive in Registers. Choose it yourself if it is right.", deger ?? "—");
    case "ref_yok": return cevir("No read WPS names PQR {0}. Choose the WPS.", deger ?? pqrNo ?? "—");
    default: return pqr ? cevir("Proposed from the WPS that names this PQR: {0}.", kod ?? "—") : cevir("Proposed from the WPS number (same WPS in Registers).");
  }
}

/** Notun alan adı: belge düzeyi değer ya da satırın tablosu ve sırası ("Filler 2 · Class"). */
const wpsAlanAdi = (n: { alan: string; satir?: { tablo: "dolgu" | "pqr"; sira: number } }) =>
  n.satir ? `${n.satir.tablo === "dolgu" ? cevir("Filler {0}", n.satir.sira) : cevir("PQR {0}", n.satir.sira)} · ${cevir(wpsBelgesiEtiketi(n.alan))}` : cevir(wpsBelgesiEtiketi(n.alan));

/** WPS belgesi karşılaştırma notunun ekran cümlesi ("Compared with OASIS" altında; uyarı değildir). */
export function wpsNotMetni(n: WpsNotu, cins: WpsCinsi = "wps", pqrNo: string | null = null): string {
  switch (n.tur) {
    case "suphe": return cevir("Not compared: {0} is uncertain. Check it on the page.", wpsAlanAdi(n));
    case "bicim": return cevir("Not compared: {0} is not in a form OASIS reads ({1}).", wpsAlanAdi(n), n.deger);
    case "oneri_yok": return wpsNedenMetni(n.neden, n.deger, cins, pqrNo);
    case "eslesti": return cevir("WPS matches the register: {0}.", n.kod);
    case "kod_farkli": return cevir("The chosen WPS {0} differs from the WPS number on the document: {1}.", n.kayit, n.okunan);
    case "pqr_wps": return cevir("The read WPS {0} names this PQR.", n.kod);
    case "pqr_tamam": return cevir("Supporting PQR {0} is in Registers.", n.no);
    case "tanikli": return cevir("PQR stamp: Witnessed.");
    case "proses_bilinmiyor": return cevir("Processes not compared: {0} is not a process OASIS knows.", n.deger);
    case "req_okunmuyor": return cevir("Measurement ranges of WPS {0} in Registers cannot be read; ranges and preheat were not compared.", n.kod);
  }
}

/** "Compared with OASIS" satırları: notlar; yinelenen cümle bir kez. Karşılaştırılan satırlar uyarı değildir; uyarılar ayrı listededir. */
export function wpsKarsilastirmaSatirlari(k: Pick<WpsBelgesiKarti, "karsilastirma" | "cins" | "degerler">): { metin: string; suphe: boolean; karsilastirildi: boolean }[] {
  const l: { metin: string; suphe: boolean; karsilastirildi: boolean }[] = [];
  if (!k.karsilastirma) return l;
  const pqrNo = kesinDeger(k.degerler, "pqr_no");
  for (const n of k.karsilastirma.notlar) {
    const metin = wpsNotMetni(n, k.cins, pqrNo);
    if (!l.some((x) => x.metin === metin)) {
      l.push({ metin, suphe: n.tur === "suphe", karsilastirildi: n.tur === "eslesti" || n.tur === "pqr_wps" || n.tur === "pqr_tamam" || n.tur === "tanikli" });
    }
  }
  return l;
}

/** Dosyalamadan ya da eski sürüm işaretinden sonraki yeniden karşılaştırmanın satırı (o WPS'i anan okumalar); koşu yoksa null. */
export function wpsYenidenMetni(y: WpsBelgesiKarti["yenidenKarsilastirma"], kod?: string | null): string | null {
  if (!y) return null;
  const ana = cevir("Readings that name WPS {0} compared again after filing: {1} readings, {2} changed ({3}).", kod ?? cevir("this WPS"), y.bakilan, y.degisen, tarihSaat(y.ts));
  return y.hata ? `${ana} ${cevir("{0} could not be compared.", y.hata)}` : ana;
}

/** "Differences from Registers" satırının sonucu. */
export function wpsFarkSonucMetni(s: WpsFarkSonucu): string {
  switch (s) {
    case "ayni": return cevir("same");
    case "farkli": return cevir("differs");
    case "kayit_bos": return cevir("Registers has none");
    case "karsilastirilmadi": return cevir("not compared");
  }
}
/** Sonucun etiket tonu (farklı kırmızı WPS-03 / WPS-01'dir). */
export const wpsFarkTonu = (s: WpsFarkSonucu): Ton => (s === "ayni" ? "ok" : s === "farkli" ? "bad" : "neutral");

/** "Older versions on this WPS" satırının işaret metni ("Superseded · kim · gün"); işaretsizse null. */
export function wpsEskiSurumMetni(x: Pick<WpsEskiSurum, "isaretli">): string | null {
  return x.isaretli ? cevir("Superseded · {0} · {1}", x.isaretli.kim, tarih(x.isaretli.ts.slice(0, 10))) : null;
}

/**
 * M9-18 "Use the reading": dosyalama formunun Doc no.'su YALNIZ kesin değerle (WPS'te WPS no, PQR'da PQR no); şüpheli ve boş değer boş kalır (K29 kör yazma). Dolgu onayında
 * doldurulacak alan yoktur. Sunucuya yazmaz. Anahtar `KutukFormu`'nun alanıdır.
 */
export function wpsFormu(k: Pick<WpsBelgesiKarti, "cins" | "degerler">): Record<string, string> {
  if (k.cins === "wps") return { belgeNo: kesinDeger(k.degerler, "wps_no") ?? "" };
  if (k.cins === "pqr") return { belgeNo: kesinDeger(k.degerler, "pqr_no") ?? "" };
  return {};
}

/**
 * Okunmuş WPS belgesinin yer kapısı (M9-17; sunucuda da var): yalnız okumanın yerine (WPS'e) dosyalanır. Satır sıradayken, okunurken ya da okunamadıyken sunucu yer kapısına
 * bakmaz, burada da bakılmaz.
 */
export function wpsYerEngeli(k: Pick<WpsBelgesiKarti, "okuma" | "yer" | "karsilastirma" | "is"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.okuma || hedef?.tur !== "kutuk" || hedef.kutuk !== "wps") return null;
  if (k.is?.durum) return null;
  if (!k.karsilastirma) return cevir(KARSILASTIRMA_YERI_METNI);
  return hedefEsit(k.yer?.yer ?? null, hedef) ? null : cevir(KARSILASTIRMA_YERI_METNI);
}

/** Karar kapısı (T21, M9-17): kararsız kırmızı ya da "Do not file" kararı varken dosyalanmaz; kapı yoksa null. */
export function wpsDosyalamaEngeli(k: Pick<WpsBelgesiKarti, "karsilastirma"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.karsilastirma || hedef?.tur !== "kutuk" || hedef.kutuk !== "wps") return null;
  const e = dosyalamaEngeli(k.karsilastirma.uyarilar, false);
  return e ? cevir(DOSYALAMA_ENGEL_METNI[e]) : null;
}

/* ------------------------------------------------------------ packing list okuması (D-074 Faz 4 · PR 20) ------------------------------------------------------------ */

/** Packing list okuma uçları (M2-3; yetki belgeKutuk): sıraya koy / çıkar, elle okuma excel'i, "Open stock package" (PM ya da sistem yöneticisi) ve "Add the list". "Compare again" ortak `OKUMA_UCU.karsilastir`. */
export const TESLIM_UCU = {
  sira: (id: string) => `/belgeler/${id}/teslim/okuma`,
  girdi: (id: string) => `/belgeler/${id}/teslim/okuma/girdi`,
  paket: (id: string) => `/belgeler/${id}/teslim/paket`,
  liste: (id: string) => `/belgeler/${id}/teslim/liste`,
} as const;

/** Kalemin yerinin kısa cümlesi: öneri ya da önerilmeme nedeni. */
export function teslimNedenMetni(n: TeslimOneriNedeni | null): string {
  switch (n) {
    case "kayit_yok": return cevir("no package yet");
    case "katalogda_yok": return cevir("not in the stock catalogue");
    case "alindi": return cevir("already received: not proposed");
    case "celiski":
    case "birden_cok":
    case "iz_benzer": return cevir("two packages: not proposed");
    case "pn_yok": return cevir("part number not certain: check it on the page");
    case "kimliksiz": return cevir("no lot or serial number: open the package on Registers");
    case "sn_tekrar": return cevir("serial number repeated on the list: not proposed");
    default: return cevir("proposed");
  }
}

/** Kalemin sonucu (Result). "Open stock package" ve "Add the list" düğmelerini bölüm çizer; dosyalanmamış satırda kartın yerindeki kalem "file the list here"dir. */
export function teslimDurumMetni(k: Pick<TeslimKartKalemi, "durum" | "yer" | "onay" | "engel">, hedef: GelenHedef | null = null): string {
  switch (k.durum) {
    case "kapali": return cevir("row closed");
    case "pn_yok": return cevir("part number not certain: check it on the page");
    case "katalogda_yok": return cevir("not in the stock catalogue");
    case "alindi": return cevir("already received: not proposed");
    case "belirsiz": return cevir("two packages: not proposed");
    case "sn_tekrar": return cevir("serial number repeated on the list: not proposed");
    case "engel": return k.engel && k.engel !== DOSYALAMA_ENGEL_METNI.kirmizi ? cevir(k.engel) : cevir("red alert waits for a decision");
    case "liste_var": return cevir("✓ list on the package");
    case "dosyalanmadi": return hedef && hedefEsit(k.yer.yer, hedef) ? cevir("file the list here") : cevir("added after filing");
    case "eklenebilir": return cevir("added after filing");
    case "kimliksiz": return cevir("no lot or serial number: open the package on Registers");
    case "kesin_degil": return cevir("a value is not certain: open the package on Registers");
    case "birim_bilinmiyor": return cevir("unit not known: open the package on Registers");
    case "birim_farkli": return cevir("unit differs from the stock item: open the package on Registers");
    case "acildi": return cevir("opened: {0}", k.onay?.yazilan ?? "—");
    case "acilabilir": return cevir("no package yet");
  }
}

/**
 * Kalemde "Open stock package" düğmesi (tarih kutusuyla) çizilir mi: kalem `acilabilir` ve sunucu eylemi `paketAc` (M2-17). Kapanmış (`salt`) kart da dosyalanmış satırdır;
 * düğme orada da sunucunun eylemiyle çizilir (satır dosyalanmışsa liste aynı adımda yeni pakete bağlanır). "Add the list" de böyle çizilir.
 */
export const teslimPaketAcilabilir = (c: Pick<TeslimKartKalemi, "durum">, k: { eylemler: Pick<TeslimKarti["eylemler"], "paketAc"> }): boolean =>
  c.durum === "acilabilir" && k.eylemler.paketAc;

/** Sonuç hücresinin "Added by …" satırı: yalnız kalemin "Add the list" onayı (TESLIM_LISTE_ALANI) varken; paketi açanın onayı listeyi ekleyen sayılmaz. */
export const teslimEkleyen = (c: Pick<TeslimKartKalemi, "durum" | "onay">): { kim: string; ts: string } | null =>
  c.durum === "liste_var" && c.onay?.alan === TESLIM_LISTE_ALANI ? { kim: c.onay.kim, ts: c.onay.ts } : null;

/** Geliş tarihi kutusunun üst sınırı: bugün, Europe/Istanbul takvim günü (sunucunun "gelecekte değil" kapısıyla aynı gün). */
export const teslimBugun = (an: Date = new Date()): string => istanbulGunu(an);

/** Packing list karşılaştırma notunun ekran cümlesi ("Compared with OASIS" altında; uyarı değildir). */
export function teslimNotMetni(n: TeslimNotu): string {
  const alan = (a: string) => cevir(teslimEtiketi(a));
  switch (n.tur) {
    case "suphe":
      if (n.kalem === null) return cevir("Not compared: {0} is uncertain. Check it on the page.", alan(n.alan));
      return n.alan === "pn" ? cevir("Line {0}: Part number is uncertain. Check it on the page.", n.kalem) : cevir("Line {0}: {1}", n.kalem, cevir("Not compared: {0} is uncertain. Check it on the page.", alan(n.alan)));
    case "bicim": return cevir("Not compared: {0} is not in a form OASIS reads ({1}).", alan(n.alan), n.deger);
    case "gun_ay": return cevir("Day and month order unclear on {0}: {1}. Check the date on the page.", alan(n.alan), n.deger);
    case "birlesti": return cevir("Line {0}: lines {1} of the list have the same part number and lot; counted as one line.", n.kalem, n.satirlar.join(", "));
    case "ft_m": return cevir("Line {0}: the list writes FT; the stock item counts in m. {1} ft = {2} m.", n.kalem, n.ft, n.m);
    case "birim_bilinmiyor": return cevir("Line {0}: unit {1} is not one OASIS knows; quantity not compared.", n.kalem, n.birim);
    case "birim_farkli": return cevir("Line {0}: unit {1} differs from the unit of the stock item ({2}); quantity not compared.", n.kalem, n.okunan, n.katalog);
    case "sn_tekrar": return cevir("Line {0}: serial number {1} appears more than once on the list.", n.kalem, n.seri);
    case "sn_sayisi": return cevir("Line {0}: {1} serial numbers for quantity {2}.", n.kalem, n.sayi, n.miktar);
    case "eslesti":
      return n.ile === "lot" ? cevir("Line {0}: lot {1} matches {2}.", n.kalem, n.deger, n.pkg) : cevir("Line {0}: serial numbers match {1} ({2}).", n.kalem, n.pkg, n.deger);
    case "celiski": return cevir("Line {0}: the lot is on {1} and the serial numbers are on {2}. OASIS does not choose; choose the package yourself.", n.kalem, n.lotPkg, n.seriPkg);
    case "birden_cok": return cevir("Line {0}: several packages match: {1}. Choose the package yourself.", n.kalem, n.pkgler.join(", "));
    case "iz_benzer": return cevir("Line {0}: heat / lot / SN of {1} contains this value but is written differently. Choose the package yourself if it is right.", n.kalem, n.pkgler.join(", "));
    case "kimliksiz": return cevir("Line {0}: no lot or serial number on the line.", n.kalem);
    case "ayni_liste": return cevir("Line {0}: {1} already holds packing list {2} (another copy of this list).", n.kalem, n.pkg, n.liste);
    case "kisi_iz_farkli": return cevir("Line {0}: the chosen package {1} has heat / lot / SN {2}; the list names another lot or serial number.", n.kalem, n.pkg, n.iz || "—");
    case "kisi_kalemsiz": return cevir("The chosen package {0} is not a line of this list.", n.pkg);
    case "po_ayni": return cevir("Line {0}: customer PO {1} is the PO of {2}.", n.kalem, n.po, n.pkg);
    case "po_bos": return cevir("Line {0}: {1} has no PO; the package is not changed.", n.kalem, n.pkg);
    case "miktar_ayni": return cevir("Line {0}: quantity {1} = {2} on {3}.", n.kalem, n.liste, n.paket, n.pkg);
  }
}

/** "Compared with OASIS" satırları: notlar; yinelenen cümle bir kez. Uyarılar ayrı listededir. */
export function teslimKarsilastirmaSatirlari(k: Pick<TeslimKarti, "karsilastirma">): { metin: string; suphe: boolean; karsilastirildi: boolean }[] {
  const l: { metin: string; suphe: boolean; karsilastirildi: boolean }[] = [];
  if (!k.karsilastirma) return l;
  for (const n of k.karsilastirma.notlar) {
    const metin = teslimNotMetni(n);
    if (!l.some((x) => x.metin === metin)) {
      l.push({ metin, suphe: n.tur === "suphe" || n.tur === "gun_ay", karsilastirildi: n.tur === "eslesti" || n.tur === "po_ayni" || n.tur === "miktar_ayni" || n.tur === "ayni_liste" });
    }
  }
  return l;
}

/** Dosyalamadan, paket açmadan ya da liste eklemeden sonraki yeniden karşılaştırmanın satırı; koşu yoksa null. */
export function teslimYenidenMetni(y: TeslimKarti["yenidenKarsilastirma"]): string | null {
  if (!y) return null;
  const ana = cevir("Open packing list readings that name the same part numbers compared again: {0} readings, {1} changed ({2}).", y.bakilan, y.degisen, tarihSaat(y.ts));
  return y.hata ? `${ana} ${cevir("{0} could not be compared.", y.hata)}` : ana;
}

/** Yeni paket önerisinin cümlesi: PN · miktar ve katalog birimi · heat / lot / SN · PO. */
export function teslimOneriMetni(o: TeslimPaketOnerisi): string {
  const miktar = `${o.gelenMiktar} ${o.birim}`;
  return o.poNo ? cevir("new package: {0} · {1} · {2} · PO {3}", o.pn, miktar, o.iz ?? "—", o.poNo) : cevir("new package: {0} · {1} · {2} · no PO", o.pn, miktar, o.iz ?? "—");
}

/** Kalemin listedeki miktarı ("120 FT"); okunamadıysa "—". */
export const teslimMiktarMetni = (k: Pick<TeslimKartKalemi, "miktarMetni">): string => k.miktarMetni ?? "—";

/**
 * M2-20 "Use the reading": YALNIZ kesin liste no'su ile dosyalama formunun Doc no.'su; şüpheli ve boş değer boş kalır (K29 kör yazma). Sunucuya yazmaz. Anahtar `KutukFormu`'nun
 * alanıdır. Sayfalar ayrı: `teslimSayfalari`.
 */
export function teslimFormu(k: Pick<TeslimKarti, "degerler">): Record<string, string> {
  return { belgeNo: kesinDeger(k.degerler, "liste_no") ?? "" };
}
/** Liste PDF'in bir kısmıysa listenin sayfaları ("3" ya da "3-4"); PDF'in tamamıysa ya da aralık bilinmiyorsa null. */
export function teslimSayfalari(k: Pick<TeslimKarti, "okuma">): string | null {
  const s = k.okuma?.sayfalar;
  if (!s || (s.bas === 1 && s.son === k.okuma!.sayfaSayisi)) return null;
  return s.bas === s.son ? String(s.bas) : `${s.bas}-${s.son}`;
}

/**
 * Formun hedefi bir stok paketinin packing list'i mi (packing list kapılarının ön koşulu). Sunucu `teslimKapisi`'ni yalnız satırın bugünkü türü packing list iken koşar; türü
 * değiştirilmiş satırda eski okumanın kaydı kalsa da kapı çalışmaz (PR 22 incelemesi: CoC'ye çevrilen satırda düğme kilitli kalıyordu).
 */
const teslimHedefi = (hedef: GelenHedef | null): hedef is Extract<GelenHedef, { tur: "kutuk" }> =>
  hedef?.tur === "kutuk" && hedef.kutuk === "stok_paket" && hedef.belgeTuru === "teslim";

/**
 * Okunmuş packing list'in yer kapısı (M2-19; sunucunun `teslimKapisi` ile aynı kural): okunmuş ve sırada olmayan satırda form bir kalemin paketini göstermeli. Satır sıradayken,
 * okunurken ya da okunamadıyken sunucu yer kapısına bakmaz, burada da bakılmaz.
 */
export function teslimYerEngeli(k: Pick<TeslimKarti, "okuma" | "kalemler" | "karsilastirma" | "is"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.okuma || !teslimHedefi(hedef)) return null;
  if (k.is?.durum) return null;
  if (!k.karsilastirma) return cevir(KARSILASTIRMA_YERI_METNI);
  return k.kalemler.some((c) => hedefEsit(c.yer.yer, hedef)) ? null : cevir(KARSILASTIRMA_YERI_METNI);
}

/**
 * Karar kapısı (T21, M2-19): formun paketindeki kalemlerin ve parçasız uyarılarda kararsız kırmızı ya da "Do not file" kararı varken dosyalanmaz; başka kalemin kırmızısı bu
 * paketi durdurmaz. Yerde kalem yoksa bütün uyarılar sayılır (sunucunun kapısıyla aynı); kapı yoksa null.
 */
export function teslimDosyalamaEngeli(k: Pick<TeslimKarti, "kalemler" | "karsilastirma"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.karsilastirma || !teslimHedefi(hedef)) return null;
  const yerdekiler = k.kalemler.filter((c) => hedefEsit(c.yer.yer, hedef));
  const uyarilar = [...(yerdekiler.length ? yerdekiler : k.kalemler).flatMap((c) => c.uyarilar), ...k.karsilastirma.uyarilar];
  const e = dosyalamaEngeli(uyarilar, false);
  return e ? cevir(DOSYALAMA_ENGEL_METNI[e]) : null;
}

/* ------------------------------------------------------------ malzeme sertifikası okuması (D-074 Faz 4 · PR 21) ------------------------------------------------------------ */

/**
 * Malzeme sertifikası okuma uçları (M3-3; yetki belgeKutuk): sıraya koy / çıkar, elle okuma excel'i, "Add to package" ve "Record on the package" (PM ya da sistem yöneticisi).
 * "Compare again" ortak `OKUMA_UCU.karsilastir`.
 */
export const MALZEME_UCU = {
  sira: (id: string) => `/belgeler/${id}/malzeme/okuma`,
  girdi: (id: string) => `/belgeler/${id}/malzeme/okuma/girdi`,
  ekle: (id: string) => `/belgeler/${id}/malzeme/ekle`,
  kayit: (id: string) => `/belgeler/${id}/malzeme/kayit`,
} as const;

/** Dosyanın cinsinin satırı ("File"): kapaktan çıkan kip (M3-5). */
export function malzemeCinsMetni(c: MalzemeDosyaCinsi): string {
  switch (c) {
    case "tek": return cevir("one certificate (no book cover)");
    case "kitap": return cevir("certificate book: MANUFACTURING RECORD BOOK · RISER SPARES on the cover");
    case "datapack": return cevir("datapack: TAG or Scope of Work: Overhauled on the cover");
    case "oem_mrb": return cevir("OEM MRB: MANUFACTURING RECORD BOOK without RISER SPARES on the cover");
    case "belirsiz": return cevir("cover not certain: check it on the page");
  }
}

/** Sertifikanın kısa cümlesi: PN · EN 10204 türü · No. · lot anahtarı (kesin değerler; okunmayan "—"). */
export function malzemeSertifikaMetni(s: Pick<MalzemeKartSertifikasi, "pn" | "tur" | "sertifikaNo" | "lotAnahtari">): string {
  return cevir("{0} · EN 10204 {1} · No. {2} · lot key {3}", s.pn ?? "—", s.tur ?? "—", s.sertifikaNo ?? "—", s.lotAnahtari ?? "—");
}

/** Sertifikanın yerinin kısa cümlesi: öneri ya da önerilmeme nedeni. */
export function malzemeNedenMetni(n: MalzemeOneriNedeni | null): string {
  switch (n) {
    case "katalogda_yok": return cevir("not in the stock catalogue");
    case "kimliksiz": return cevir("no heat, lot or lot key: not proposed");
    case "birden_cok": return cevir("two packages: not proposed");
    case "kayit_yok": return cevir("no package with this heat, lot or lot key");
    default: return cevir("proposed");
  }
}

/** Sertifikanın sonucu (Result; M3-20). "Add to package" düğmesini bölüm çizer; dosyalanmamış satırda kartın yerindeki sertifika "file the certificate here"dir. */
export function malzemeDurumMetni(c: Pick<MalzemeKartSertifikasi, "durum" | "yer" | "engel">, hedef: GelenHedef | null = null): string {
  switch (c.durum) {
    case "kapali": return cevir("row closed");
    case "yer_yok": return cevir("no package: file it on Registers by hand");
    case "pakette": return cevir("✓ on the package");
    case "dosyalanmadi": return hedef && hedefEsit(c.yer.yer, hedef) ? cevir("file the certificate here") : cevir("added after filing");
    case "tur_yok": return cevir("type not certain: add it on Registers");
    case "engel": return c.engel && c.engel !== DOSYALAMA_ENGEL_METNI.kirmizi ? cevir(c.engel) : cevir("red alert waits for a decision");
    case "eklenebilir": return cevir("added after filing");
  }
}

/** "Record on the package" satırının cümlesi (M3-22): paketin alanının bugünkü durumu. */
export function malzemeKayitMetni(s: MalzemeKayitSatiri, pkg: string): string {
  if (s.onay && (s.durum === "kaydedildi" || s.durum === "kayitta")) return cevir("recorded: {0} by {1}, {2}", s.onay.yazilan, s.onay.kim, tarihSaat(s.onay.ts));
  switch (s.durum) {
    case "dosyalanmadi": return cevir("Record after the certificate is on the package.");
    case "kaydedildi": return cevir("recorded: {0} by {1}, {2}", s.onay?.yazilan ?? "—", s.onay?.kim ?? "—", s.onay ? tarihSaat(s.onay.ts) : "—");
    case "kayitta": return cevir("already on the package: {0}", s.kayitli ?? "—");
    case "farkli": return cevir("the package has {0}; it does not change", s.kayitli ?? "—");
    case "kesin_degil": return cevir("no certain value on the certificate");
    case "engel": return s.engel && s.engel !== DOSYALAMA_ENGEL_METNI.kirmizi ? cevir(s.engel) : cevir("red alert waits for a decision");
    case "yazilabilir":
      return s.alan === "heat" ? cevir("Heat / lot / SN of {0}: empty.", pkg) : cevir("PO of {0}: empty. Customer PO on the certificate: {1}.", pkg, s.adaylar[0] ?? "—");
  }
}

/** Kitabın sayfa haritası satırının "Read" hücresi. */
export function malzemeHaritaMetni(h: Pick<MalzemeHaritaSatiri, "durum" | "sertifikalar">): string {
  switch (h.durum) {
    case "okundu": return h.sertifikalar.map((n) => cevir("certificate {0}", n)).join(", ");
    case "katalogda_yok": return cevir("not read: part number not in the stock catalogue");
    case "okunmadi": return cevir("not read: no certificate of this part number was read");
    case "kesin_degil": return cevir("part number not certain: check it on the page");
  }
}

/** Malzeme sertifikası karşılaştırma notunun ekran cümlesi ("Compared with OASIS" altında; uyarı değildir). */
export function malzemeNotMetni(n: MalzemeNotu): string {
  const alan = (a: string) => cevir(malzemeEtiketi(a));
  const sert = (s: number, m: string) => cevir("Certificate {0}: {1}", s, m);
  switch (n.tur) {
    case "suphe": {
      const m = cevir("Not compared: {0} is uncertain. Check it on the page.", alan(n.alan));
      return n.sertifika === null ? m : sert(n.sertifika, m);
    }
    case "bicim": {
      const m = cevir("Not compared: {0} is not in a form OASIS reads ({1}).", alan(n.alan), n.deger);
      return n.sertifika === null ? m : sert(n.sertifika, m);
    }
    case "kapak_belirsiz": return cevir("cover not certain: check it on the page");
    case "tanik_yok": return cevir("Certificate {0}: EN 10204 3.2 printed but no witness signature: Material certificate (EN 10204 3.1).", n.sertifika);
    case "tur_yok": return cevir("Certificate {0}: no EN 10204 type on the certificate.", n.sertifika);
    case "eslesti":
      return n.eslesme === "tam"
        ? cevir("Certificate {0}: {1} matches {2} ({3}).", n.sertifika, n.deger, n.pkg, n.iz || "—")
        : cevir("Certificate {0}: {1} is in the heat / lot / SN of {2} ({3}), written differently.", n.sertifika, n.deger, n.pkg, n.iz || "—");
    case "pn_bos_iz": return cevir("Certificate {0}: {1} is the only package of {2} without heat / lot / SN.", n.sertifika, n.pkg, n.pn);
    case "birden_cok": return cevir("Certificate {0}: several packages match: {1}. Choose the package yourself.", n.sertifika, n.pkgler.join(", "));
    case "katalogda_yok": return cevir("Certificate {0}: part number {1} is not in the stock catalogue.", n.sertifika, n.pn);
    case "kimliksiz": return cevir("Certificate {0}: no heat, mill lot, lot key or part number was read.", n.sertifika);
    case "kayit_yok": return cevir("Certificate {0}: no package holds a heat, mill lot or lot key of the certificate.", n.sertifika);
    case "kisi_iz": return cevir("Certificate {0}: the chosen package {1} has heat / lot / SN {2}; see the heat alert.", n.sertifika, n.pkg, n.iz || "—");
    case "kisi_sertifikasiz": return cevir("The chosen package {0} is not a certificate of this file.", n.pkg);
    case "iz_ayni": return cevir("Certificate {0}: heat / lot / SN of {1} holds the certificate.", n.sertifika, n.pkg);
    case "iz_bos": return cevir("Certificate {0}: {1} has no heat / lot / SN; a heat can be recorded on the package.", n.sertifika, n.pkg);
    case "po_ayni": return cevir("Certificate {0}: customer PO {1} is the PO of {2}.", n.sertifika, n.po, n.pkg);
    case "po_bos": return cevir("Certificate {0}: {1} has no PO; customer PO {2} can be recorded on the package.", n.sertifika, n.pkg, n.po);
    case "dosya_adi_ayni": return cevir("Certificate {0}: the file name holds heat {1}.", n.sertifika, n.parca);
    case "miktar_icinde": return cevir("Certificate {0}: {1} on the packages that hold it, {2} on the certificate.", n.sertifika, n.toplam, n.miktar);
    case "miktar_karsilastirilmadi": return cevir("Certificate {0}: quantity not compared (a value is not certain or the unit differs from the stock item).", n.sertifika);
    case "anahtar_ayni": return cevir("Certificate {0}: lot key {1} = packing list lot on {2}.", n.sertifika, n.anahtar, n.pkg);
    case "liste_okunmamis": return cevir("Certificate {0}: no read packing list on {1}; lot key not compared.", n.sertifika, n.pkg);
    case "sonuc_icinde": return cevir("Certificate {0}: {1} results inside the printed limits.", n.sertifika, n.sayi);
    case "sonuc_karsilastirilmadi": return cevir("Certificate {0}: result line R{1} not compared (a value is not certain).", n.sertifika, n.satir);
    case "indeks_okunmadi": return cevir("Index line {0}: {1} is in the stock catalogue but no certificate of it was read.", n.satir, n.pn);
  }
}

/** "Compared with OASIS" satırları: notlar; yinelenen cümle bir kez. Uyarılar ayrı listededir. */
export function malzemeKarsilastirmaSatirlari(k: Pick<MalzemeKarti, "karsilastirma">): { metin: string; suphe: boolean; karsilastirildi: boolean }[] {
  const l: { metin: string; suphe: boolean; karsilastirildi: boolean }[] = [];
  if (!k.karsilastirma) return l;
  for (const n of k.karsilastirma.notlar) {
    const metin = malzemeNotMetni(n);
    if (!l.some((x) => x.metin === metin)) {
      l.push({
        metin, suphe: n.tur === "suphe" || n.tur === "kapak_belirsiz",
        karsilastirildi: ["eslesti", "pn_bos_iz", "iz_ayni", "po_ayni", "dosya_adi_ayni", "miktar_icinde", "anahtar_ayni", "sonuc_icinde"].includes(n.tur),
      });
    }
  }
  return l;
}

/** Dosyalamadan, "Add to package"ten ya da "Record on the package"tan sonraki yeniden karşılaştırmanın satırı; koşu yoksa null. */
export function malzemeYenidenMetni(y: MalzemeKarti["yenidenKarsilastirma"]): string | null {
  if (!y) return null;
  const ana = cevir("Open material certificate readings of the same packages compared again: {0} readings, {1} changed ({2}).", y.bakilan, y.degisen, tarihSaat(y.ts));
  return y.hata ? `${ana} ${cevir("{0} could not be compared.", y.hata)}` : ana;
}

/**
 * M3-23 "Use the reading": seçilen sertifikanın YALNIZ kesin sertifika no'su ile dosyalama formunun Doc no.'su; şüpheli ve boş değer boş kalır (K29 kör yazma). `sayfa`: dosyada
 * birden çok sertifika varsa ya da sertifikanın aralığı PDF'in tamamı değilse sertifikanın sayfaları ("Pages"); yoksa null. Sunucuya yazmaz. Anahtar `KutukFormu`'nun alanıdır.
 */
export function malzemeFormu(k: Pick<MalzemeKarti, "sertifikalar" | "okuma">, sira: number): { alanlar: Record<string, string>; sayfa: string | null } {
  const c = k.sertifikalar.find((x) => x.sira === sira);
  if (!c) return { alanlar: {}, sayfa: null };
  const tamPdf = k.sertifikalar.length === 1 && c.sayfalar.bas === 1 && (k.okuma?.sayfaSayisi ?? c.sayfalar.son) === c.sayfalar.son;
  return { alanlar: { belgeNo: kesinDeger(c.degerler, "sertifika_no") ?? "" }, sayfa: tamPdf ? null : malzemeAralikMetni(c.sayfalar) };
}

/**
 * Formun hedefi bir stok paketinin malzeme sertifikası mı (3.1 ya da 3.2; malzeme sertifikası kapılarının ön koşulu). Sunucu `malzemeKapisi`'ni yalnız satırın bugünkü türü malzeme
 * sertifikası iken koşar; türü değiştirilmiş satırda eski okumanın kaydı kalsa da kapı çalışmaz (PR 22 incelemesi).
 */
const stokPaketiHedefi = (hedef: GelenHedef | null): hedef is Extract<GelenHedef, { tur: "kutuk" }> =>
  hedef?.tur === "kutuk" && hedef.kutuk === "stok_paket" && (hedef.belgeTuru === "en10204_31" || hedef.belgeTuru === "en10204_32");

/**
 * Okunmuş malzeme sertifikasının yer kapısı (M3-19; sunucunun `malzemeKapisi` ile aynı kural): okunmuş ve sırada olmayan satırda form bir sertifikanın paketini göstermeli. Hiçbir
 * sertifikanın yeri yoksa (datapack, OEM MRB ya da eşleşmeyen paket, `kisi_sertifikasiz`) yer metni döner; sunucu bu yere dosyalamayı reddeder. Satır sıradayken, okunurken ya da
 * okunamadıyken sunucu yer kapısına bakmaz, burada da bakılmaz.
 */
export function malzemeYerEngeli(k: Pick<MalzemeKarti, "okuma" | "sertifikalar" | "karsilastirma" | "is"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.okuma || !stokPaketiHedefi(hedef)) return null;
  if (k.is?.durum) return null;
  if (!k.karsilastirma) return cevir(KARSILASTIRMA_YERI_METNI);
  return k.sertifikalar.some((c) => c.yer.durum !== "yok" && hedefEsit(c.yer.yer, hedef)) ? null : cevir(KARSILASTIRMA_YERI_METNI);
}

/**
 * Sayfa kapısı (M3-19; sunucunun kapısının aynası): çok sertifikalı dosyada formun Pages'i verilmişse formun paketindeki sertifikalardan birinin aralığına eşit olmalı. `sayfalar`
 * formun Partial / Pages alanının ayrıştırılmış hâlidir (Partial kapalıysa ikisi de null).
 */
export function malzemeSayfaEngeli(
  k: Pick<MalzemeKarti, "sertifikalar"> | null | undefined, hedef: GelenHedef | null, sayfalar: { bas: number | null; son: number | null },
): string | null {
  if (!k || k.sertifikalar.length <= 1 || !stokPaketiHedefi(hedef) || sayfalar.bas === null) return null;
  const yerdekiler = k.sertifikalar.filter((c) => c.yer.durum !== "yok" && hedefEsit(c.yer.yer, hedef));
  if (!yerdekiler.length) return null;
  return yerdekiler.some((c) => c.sayfalar.bas === sayfalar.bas && c.sayfalar.son === sayfalar.son) ? null : cevir(MALZEME_SAYFA_METNI);
}

/**
 * Karar kapısı (T21, M3-19): formun paketindeki sertifikaların ve parçasız uyarılarda kararsız kırmızı ya da "Do not file" kararı varken dosyalanmaz; başka sertifikanın kırmızısı bu
 * paketi durdurmaz. Yerde sertifika yoksa bütün uyarılar sayılır (sunucunun kapısıyla aynı); kapı yoksa null.
 */
export function malzemeDosyalamaEngeli(k: Pick<MalzemeKarti, "sertifikalar" | "karsilastirma"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.karsilastirma || !stokPaketiHedefi(hedef)) return null;
  const yerdekiler = k.sertifikalar.filter((c) => c.yer.durum !== "yok" && hedefEsit(c.yer.yer, hedef));
  const uyarilar = [...(yerdekiler.length ? yerdekiler : k.sertifikalar).flatMap((c) => c.uyarilar), ...k.karsilastirma.uyarilar];
  const e = dosyalamaEngeli(uyarilar, false);
  return e ? cevir(DOSYALAMA_ENGEL_METNI[e]) : null;
}

/** Formun Pages alanından aralık ("97-100" ya da "97"); Partial kapalıysa ya da biçim dışıysa ikisi de null. */
export function malzemeFormSayfalari(s: { kismi: boolean; sayfalar: string }): { bas: number | null; son: number | null } {
  const a = s.kismi ? sayfaAraligiOku(s.sayfalar) : null;
  return { bas: a?.bas ?? null, son: a?.son ?? null };
}

/* ------------------------------------------------------------ CoC okuması (D-074 Faz 4 · PR 22) ------------------------------------------------------------ */

/** CoC okuma uçları (M4-3; yetki belgeKutuk): sıraya koy / çıkar, elle okuma excel'i ve "Add to package". "Compare again" ortak `OKUMA_UCU.karsilastir`. */
export const UYGUNLUK_UCU = {
  sira: (id: string) => `/belgeler/${id}/uygunluk/okuma`,
  girdi: (id: string) => `/belgeler/${id}/uygunluk/okuma/girdi`,
  ekle: (id: string) => `/belgeler/${id}/uygunluk/ekle`,
} as const;

/** Kalemin yerinin kısa cümlesi: öneri ya da önerilmeme nedeni. */
export function uygunlukNedenMetni(n: UygunlukOneriNedeni | null): string {
  switch (n) {
    case "pn_yok": return cevir("part number not certain: check it on the page");
    case "katalogda_yok": return cevir("not in the stock catalogue");
    case "celiski":
    case "birden_cok":
    case "iz_benzer": return cevir("two packages: not proposed");
    case "kimliksiz": return cevir("no lot or serial number: not proposed");
    case "kayit_yok": return cevir("no package with this lot or serial number");
    default: return cevir("proposed");
  }
}

/** Kalemin sonucu (Result). "Add to package" düğmesini bölüm çizer; dosyalanmamış satırda kartın yerindeki kalem "file the CoC here"dir. */
export function uygunlukDurumMetni(k: Pick<UygunlukKartKalemi, "durum" | "yer" | "engel">, hedef: GelenHedef | null = null): string {
  switch (k.durum) {
    case "kapali": return cevir("row closed");
    case "yer_yok": return uygunlukNedenMetni(k.yer.neden);
    case "engel": return k.engel && k.engel !== DOSYALAMA_ENGEL_METNI.kirmizi ? cevir(k.engel) : cevir("red alert waits for a decision");
    case "pakette": return cevir("✓ CoC on the package");
    case "dosyalanmadi": return hedef && hedefEsit(k.yer.yer, hedef) ? cevir("file the CoC here") : cevir("added after filing (“Add to package”)");
    case "eklenebilir": return cevir("added after filing (“Add to package”)");
  }
}

/** Sonuç hücresinin "Added by …" satırı: yalnız kalemin "Add to package" onayı varken. */
export const uygunlukEkleyen = (c: Pick<UygunlukKartKalemi, "durum" | "onay">): { kim: string; ts: string } | null =>
  c.durum === "pakette" && c.onay ? { kim: c.onay.kim, ts: c.onay.ts } : null;

/** CoC karşılaştırma notunun ekran cümlesi ("Compared with OASIS" altında; uyarı değildir). `cocPo`: CoC'nin kesin müşteri PO'su (po_farkli cümlesi için). */
export function uygunlukNotMetni(n: UygunlukNotu, cocPo: string | null = null): string {
  const alan = (a: string) => cevir(uygunlukEtiketi(a));
  switch (n.tur) {
    case "suphe":
      if (n.kalem === null) return cevir("Not compared: {0} is uncertain. Check it on the page.", alan(n.alan));
      return n.alan === "pn" ? cevir("Line {0}: Part number is uncertain. Check it on the page.", n.kalem) : cevir("Line {0}: {1}", n.kalem, cevir("Not compared: {0} is uncertain. Check it on the page.", alan(n.alan)));
    case "eslesti":
      return n.ile === "lot" ? cevir("Line {0}: lot {1} matches {2}.", n.kalem, n.deger, n.pkg) : cevir("Line {0}: serial numbers match {1} ({2}).", n.kalem, n.pkg, n.deger);
    case "celiski": return cevir("Line {0}: the lot is on {1} and the serial numbers are on {2}. OASIS does not choose; choose the package yourself.", n.kalem, n.lotPkg, n.seriPkg);
    case "birden_cok": return cevir("Line {0}: several packages match: {1}. Choose the package yourself.", n.kalem, n.pkgler.join(", "));
    case "iz_benzer": return cevir("Line {0}: heat / lot / SN of {1} contains this value but is written differently. Choose the package yourself if it is right.", n.kalem, n.pkgler.join(", "));
    case "kimliksiz": return cevir("Line {0}: no lot or serial number on the line.", n.kalem);
    case "kisi_iz_farkli": return cevir("Line {0}: the chosen package {1} has heat / lot / SN {2}; the CoC names another lot or serial number.", n.kalem, n.pkg, n.iz || "—");
    case "kisi_kalemsiz": return cevir("The chosen package {0} is not a line of this CoC.", n.pkg);
    case "liste_ayni": return cevir("Line {0}: same lot and serial numbers as the packing list of {1}.", n.kalem, n.pkg);
    case "liste_okunmamis": return cevir("Line {0}: the packing list of {1} is not read; lot and serial numbers not compared.", n.kalem, n.pkg);
    case "po_ayni": return cevir("Customer PO {0} is the PO of {1}.", n.po, n.pkgler.join(", "));
    case "po_farkli": return cevir("Line {0}: {1} has PO {2}; the CoC has {3}.", n.kalem, n.pkg, n.po, cocPo ?? "—");
    case "po_yok": return cevir("No customer PO on the CoC; the orders of the packages are not compared.");
    case "tur_yok": return cevir("No EN 10204 type printed on the CoC.");
  }
}

/** "Compared with OASIS" satırları: notlar; yinelenen cümle bir kez. Uyarılar ayrı listededir. */
export function uygunlukKarsilastirmaSatirlari(k: Pick<UygunlukKarti, "karsilastirma" | "degerler">): { metin: string; suphe: boolean; karsilastirildi: boolean }[] {
  const l: { metin: string; suphe: boolean; karsilastirildi: boolean }[] = [];
  if (!k.karsilastirma) return l;
  const cocPo = kesinDeger(k.degerler, "musteri_po");
  for (const n of k.karsilastirma.notlar) {
    const metin = uygunlukNotMetni(n, cocPo);
    if (!l.some((x) => x.metin === metin)) l.push({ metin, suphe: n.tur === "suphe", karsilastirildi: n.tur === "eslesti" || n.tur === "po_ayni" || n.tur === "liste_ayni" });
  }
  return l;
}

/** Dosyalamadan ya da "Add to package"ten sonraki yeniden karşılaştırmanın satırı (`teslimYenidenMetni` aynen); koşu yoksa null. */
export const uygunlukYenidenMetni = (y: UygunlukKarti["yenidenKarsilastirma"]): string | null => teslimYenidenMetni(y);

/** Kalemin CoC'deki kimliği: "{pn} · lot {lot} · SN {seriler}" (olmayan parçalar atlanır). */
export function uygunlukKalemMetni(c: Pick<UygunlukKartKalemi, "pn" | "lot" | "seriMetni">): string {
  return [c.pn ?? "—", ...(c.lot ? [cevir("lot {0}", c.lot)] : []), ...(c.seriMetni ? [cevir("SN {0}", c.seriMetni)] : [])].join(" · ");
}

/** `Certificate type` değerinin ekran yazısı: none → "none printed", öteki "EN 10204 {tür}". */
export const uygunlukTurMetni = (v: string | null | undefined): string => (!v ? "—" : v.trim().toLowerCase() === "none" ? cevir("none printed") : cevir("EN 10204 {0}", v.trim()));

/** M4-17 "Use the reading": YALNIZ kesin CoC no'su ile dosyalama formunun Doc no.'su; şüpheli ve boş değer boş kalır (K29). Sunucuya yazmaz. Sayfalar ayrı: `uygunlukSayfalari`. */
export function uygunlukFormu(k: Pick<UygunlukKarti, "degerler">): Record<string, string> {
  return { belgeNo: kesinDeger(k.degerler, "coc_no") ?? "" };
}
/** CoC PDF'in bir kısmıysa CoC'nin sayfaları ("7" ya da "7-8"); PDF'in tamamıysa ya da aralık bilinmiyorsa null. */
export function uygunlukSayfalari(k: Pick<UygunlukKarti, "okuma">): string | null {
  const s = k.okuma?.sayfalar;
  if (!s || (s.bas === 1 && s.son === k.okuma!.sayfaSayisi)) return null;
  return s.bas === s.son ? String(s.bas) : `${s.bas}-${s.son}`;
}

/** Formun hedefi bir stok paketinin CoC'si mi. */
const cocHedefi = (h: GelenHedef | null): h is Extract<GelenHedef, { tur: "kutuk" }> => h?.tur === "kutuk" && h.kutuk === "stok_paket" && h.belgeTuru === "coc";

/**
 * Okunmuş CoC'nin yer kapısı (M4-17; sunucunun `uygunlukKapisi` ile aynı kural): okunmuş ve sırada olmayan satırda form bir kalemin paketini göstermeli. Satır sıradayken, okunurken
 * ya da okunamadıyken sunucu yer kapısına bakmaz, burada da bakılmaz. Kart null ya da hedef CoC paketi değilse null (packing list ve malzeme dalları da yalnız kendi türlerinde çalışır).
 */
export function uygunlukYerEngeli(k: Pick<UygunlukKarti, "okuma" | "kalemler" | "karsilastirma" | "is"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.okuma || !cocHedefi(hedef)) return null;
  if (k.is?.durum) return null;
  if (!k.karsilastirma) return cevir(KARSILASTIRMA_YERI_METNI);
  return k.kalemler.some((c) => hedefEsit(c.yer.yer, hedef)) ? null : cevir(KARSILASTIRMA_YERI_METNI);
}

/**
 * Karar kapısı (T21, M4-17): formun paketindeki kalemlerin ve parçasız uyarılarda kararsız kırmızı ya da "Do not file" kararı varken dosyalanmaz. Yerde kalem yoksa bütün uyarılar
 * sayılır (sunucunun kapısıyla aynı); kapı yoksa null.
 */
export function uygunlukDosyalamaEngeli(k: Pick<UygunlukKarti, "kalemler" | "karsilastirma"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.karsilastirma || !cocHedefi(hedef)) return null;
  const yerdekiler = k.kalemler.filter((c) => hedefEsit(c.yer.yer, hedef));
  const uyarilar = [...(yerdekiler.length ? yerdekiler : k.kalemler).flatMap((c) => c.uyarilar), ...k.karsilastirma.uyarilar];
  const e = dosyalamaEngeli(uyarilar, false);
  return e ? cevir(DOSYALAMA_ENGEL_METNI[e]) : null;
}

/* ------------------------------------------------------------ PO okuması (D-074 Faz 4 · PR 23) ------------------------------------------------------------ */

/** PO okuma uçları (M5-3; yetki belgeKutuk, serviste yalnız PM ve sistem yöneticisi): sıraya koy / çıkar, elle okuma excel'i ve "Add to package". "Compare again" ortak `OKUMA_UCU.karsilastir`. */
export const SATIN_ALMA_UCU = {
  sira: (id: string) => `/belgeler/${id}/satin-alma/okuma`,
  girdi: (id: string) => `/belgeler/${id}/satin-alma/okuma/girdi`,
  ekle: (id: string) => `/belgeler/${id}/satin-alma/ekle`,
} as const;

/** PO satırının yerinin kısa cümlesi: öneri ya da önerilmeme nedeni. */
export function satinAlmaNedenMetni(n: SatinAlmaOneriNedeni | null): string {
  switch (n) {
    case "po_yok": return cevir("PO number not certain: not proposed");
    case "pn_yok": return cevir("part number not certain: check it on the page");
    case "katalogda_yok": return cevir("not in the stock catalogue");
    case "son_ek": return cevir("differs only by suffix: not proposed");
    case "birden_cok": return cevir("several packages carry this PO: not proposed");
    case "kayit_yok": return cevir("no package with this PO");
    default: return cevir("proposed");
  }
}

/** PO satırının sonucu (Result). "Add to package" düğmesini bölüm çizer; dosyalanmamış satırda kartın yerindeki satır "file the PO here"dir. */
export function satinAlmaDurumMetni(k: Pick<SatinAlmaKartSatiri, "durum" | "yer" | "engel">, hedef: GelenHedef | null = null): string {
  switch (k.durum) {
    case "kapali": return cevir("row closed");
    case "yer_yok": return satinAlmaNedenMetni(k.yer.neden);
    case "engel": return k.engel && k.engel !== DOSYALAMA_ENGEL_METNI.kirmizi ? cevir(k.engel) : cevir("red alert waits for a decision");
    case "pakette": return cevir("✓ PO on the package");
    case "dosyalanmadi": return hedef && hedefEsit(k.yer.yer, hedef) ? cevir("file the PO here") : cevir("added after filing (“Add to package”)");
    case "eklenebilir": return cevir("added after filing (“Add to package”)");
  }
}

/** Sonuç hücresinin "Added by …" satırı: yalnız satırın "Add to package" onayı varken. */
export const satinAlmaEkleyen = (c: Pick<SatinAlmaKartSatiri, "durum" | "onay">): { kim: string; ts: string } | null =>
  c.durum === "pakette" && c.onay ? { kim: c.onay.kim, ts: c.onay.ts } : null;

/** PO karşılaştırma notunun ekran cümlesi ("Compared with OASIS" altında; uyarı değildir). `po_farkli_kalir` TES-03'ün altında çizilir, burada boş döner. */
export function satinAlmaNotMetni(n: SatinAlmaNotu): string {
  const alan = (a: string) => cevir(satinAlmaEtiketi(a));
  const miktar = (v: number | null, birim: string) => (v === null ? "—" : `${v} ${birim}`);
  switch (n.tur) {
    case "suphe":
      if (n.satir === null) return cevir("Not compared: {0} is uncertain. Check it on the page.", alan(n.alan));
      return n.alan === "pn" ? cevir("Line {0}: Part number is uncertain. Check it on the page.", n.satir) : cevir("Line {0}: {1}", n.satir, cevir("Not compared: {0} is uncertain. Check it on the page.", alan(n.alan)));
    case "eslesti":
      return n.ile === "po" ? cevir("Line {0}: {1} carries this PO (PO no. {2}).", n.satir, n.pkg, n.deger)
        : n.ile === "belge" ? cevir("Line {0}: {1} already has this PO as a document ({2}).", n.satir, n.pkg, n.deger)
          : cevir("Line {0}: the read packing list {2} of {1} names this PO.", n.satir, n.pkg, n.deger);
    case "birden_cok": return cevir("Line {0}: several packages carry this PO: {1}. Choose the package yourself.", n.satir, n.pkgler.join(", "));
    case "kisi_bagsiz": return cevir("Line {0}: the chosen package {1} does not carry this PO yet.", n.satir, n.pkg);
    case "kisi_satirsiz": return cevir("The chosen package {0} is not a line of this PO.", n.pkg);
    case "po_ayni": return cevir("Line {0}: {1} has the same PO no.", n.satir, n.pkg);
    case "po_bos": return cevir("Line {0}: {1} has no PO no.; it stays empty.", n.satir, n.pkg);
    case "po_farkli_kalir": return cevir("The PO no. of {0} stays {1}.", n.pkg, n.po);
    case "teslim_toplami": return cevir("{0}: delivered {1} on read packing lists, {2} in stock packages; ordered {3}.", n.pn, miktar(n.liste, n.birim), miktar(n.paket, n.birim), miktar(n.siparis, n.birim));
    case "siparis_yok": return cevir("{0}: ordered quantity or unit not certain; delivery not compared.", n.pn);
    case "liste_miktari_yok": return cevir("{0}: a read packing list of this PO has an uncertain quantity or an unknown unit; its total is not compared.", n.pn);
    case "po_bagsiz": return cevir("Line {0}: packages of the same part number without a PO: {1}. OASIS does not propose them; choose the package yourself if it is from this PO.", n.satir, n.pkgler.join(", "));
    case "po02_tarihsiz": return cevir("Order date not certain or day and month order unclear; the packages without a PO are not checked (PO-02).");
    case "liste_once": return cevir("Packing list {0} is dated {1}, before the order date {2}.", n.liste ?? "—", n.tarih, n.siparis);
    case "fiyat_yok": return cevir("No prices printed on the PO. The row stays visible to the PM and the System administrator only.");
    case "po_yok": return cevir("No certain PO number; no package is proposed and nothing is compared with the packages.");
  }
}

/** "Compared with OASIS" satırları: notlar (TES-03'ün altında çizilen `po_farkli_kalir` hariç); yinelenen cümle bir kez. Uyarılar ayrı listededir. */
export function satinAlmaKarsilastirmaSatirlari(k: Pick<SatinAlmaKarti, "karsilastirma">): { metin: string; suphe: boolean; karsilastirildi: boolean }[] {
  const l: { metin: string; suphe: boolean; karsilastirildi: boolean }[] = [];
  if (!k.karsilastirma) return l;
  const karsilastirilmadi = new Set(["suphe", "po_yok", "siparis_yok", "liste_miktari_yok", "po02_tarihsiz", "kisi_bagsiz", "kisi_satirsiz", "po_bagsiz"]);
  for (const n of k.karsilastirma.notlar) {
    if (n.tur === "po_farkli_kalir") continue;
    const metin = satinAlmaNotMetni(n);
    if (!l.some((x) => x.metin === metin)) l.push({ metin, suphe: karsilastirilmadi.has(n.tur), karsilastirildi: !karsilastirilmadi.has(n.tur) });
  }
  return l;
}

/** TES-03 satırının altındaki cümle ("The PO no. of {0} stays {1}."): satırın `po_farkli_kalir` notu; yoksa null. */
export function satinAlmaPoKalirMetni(k: Pick<SatinAlmaKarti, "karsilastirma">, sira: number): string | null {
  const n = k.karsilastirma?.notlar.find((x): x is Extract<SatinAlmaNotu, { tur: "po_farkli_kalir" }> => x.tur === "po_farkli_kalir" && x.satir === sira);
  return n ? satinAlmaNotMetni(n) : null;
}

/** PO satırının PO'daki kimliği: "PO line {po_satiri} · {pn} · {miktar}" (olmayan parçalar atlanır). */
export function satinAlmaSatirMetni(c: Pick<SatinAlmaKartSatiri, "poSatiri" | "pn" | "miktarMetni">): string {
  return [...(c.poSatiri ? [cevir("PO line {0}", c.poSatiri)] : []), c.pn ?? "—", ...(c.miktarMetni ? [c.miktarMetni] : [])].join(" · ");
}

/** `Document kind` değerinin ekran yazısı. */
export const satinAlmaCinsMetni = (v: string | null | undefined): string => {
  const c = satinAlmaCinsiOku(v);
  return c ? cevir(c) : "—";
};
/** `Prices printed` değerinin ekran yazısı. */
export const satinAlmaFiyatMetni = (v: string | null | undefined): string => {
  const f = satinAlmaFiyatOku(v);
  return f ? cevir(f) : "—";
};
/** `Order date`ın ekran yazısı: basıldığı gibi yazılmışsa ve Value'dan farklıysa "{0} (as written)", değilse Value. */
export function satinAlmaTarihMetni(d: Pick<OkunanDeger, "deger" | "yazildigi"> | null | undefined): string {
  if (!d?.deger) return "—";
  return d.yazildigi && d.yazildigi.trim() !== d.deger.trim() ? `${d.deger} · ${cevir("{0} (as written)", d.yazildigi.trim())}` : d.deger;
}

/** Okuma kesin olarak commercial invoice mi (kartın "Before you file" cümlesi; M5-19). */
export const satinAlmaFaturaMi = (k: Pick<SatinAlmaKarti, "degerler"> | null | undefined): boolean => satinAlmaCinsiOku(kesinDeger(k?.degerler ?? [], "belge_cinsi")) === "commercial invoice";

/** M5-23 "Use the reading": YALNIZ kesin PO no'su ile dosyalama formunun Doc no.'su (invoice'ta boş); şüpheli ve boş değer boş kalır (K29). Sunucuya yazmaz. Sayfalar ayrı: `satinAlmaSayfalari`. */
export function satinAlmaFormu(k: Pick<SatinAlmaKarti, "degerler">): Record<string, string> {
  return { belgeNo: satinAlmaFaturaMi(k) ? "" : kesinDeger(k.degerler, "po_no") ?? "" };
}
/** PO PDF'in bir kısmıysa PO'nun sayfaları ("6" ya da "6-9"); PDF'in tamamıysa ya da aralık bilinmiyorsa null. */
export function satinAlmaSayfalari(k: Pick<SatinAlmaKarti, "okuma">): string | null {
  const s = k.okuma?.sayfalar;
  if (!s || (s.bas === 1 && s.son === k.okuma!.sayfaSayisi)) return null;
  return s.bas === s.son ? String(s.bas) : `${s.bas}-${s.son}`;
}

/** Formun hedefi bir stok paketinin PO'su mu. */
const poHedefi = (h: GelenHedef | null): h is Extract<GelenHedef, { tur: "kutuk" }> => h?.tur === "kutuk" && h.kutuk === "stok_paket" && h.belgeTuru === "po";

/**
 * Okunmuş PO'nun yer kapısı (M5-23; sunucunun `satinAlmaKapisi` ile aynı kural): okunmuş ve sırada olmayan satırda form bir PO satırının paketini göstermeli (commercial invoice ve
 * sıfır satırlı okuma hiçbir paketi göstermez). Satır sıradayken, okunurken ya da okunamadıyken sunucu yer kapısına bakmaz, burada da bakılmaz. Kart null ya da hedef PO paketi değilse null.
 */
export function satinAlmaYerEngeli(k: Pick<SatinAlmaKarti, "okuma" | "satirlar" | "karsilastirma" | "is"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.okuma || !poHedefi(hedef)) return null;
  if (k.is?.durum) return null;
  if (!k.karsilastirma) return cevir(KARSILASTIRMA_YERI_METNI);
  return k.satirlar.some((c) => hedefEsit(c.yer.yer, hedef)) ? null : cevir(KARSILASTIRMA_YERI_METNI);
}

/**
 * Karar kapısı (T21, M5-23): formun paketindeki satırların ve parçasız uyarılarda kararsız kırmızı ya da "Do not file" kararı varken dosyalanmaz. Yerde satır yoksa bütün uyarılar
 * sayılır (sunucunun kapısıyla aynı); kapı yoksa null.
 */
export function satinAlmaDosyalamaEngeli(k: Pick<SatinAlmaKarti, "satirlar" | "karsilastirma"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.karsilastirma || !poHedefi(hedef)) return null;
  const yerdekiler = k.satirlar.filter((c) => hedefEsit(c.yer.yer, hedef));
  const uyarilar = [...(yerdekiler.length ? yerdekiler : k.satirlar).flatMap((c) => c.uyarilar), ...k.karsilastirma.uyarilar];
  const e = dosyalamaEngeli(uyarilar, false);
  return e ? cevir(DOSYALAMA_ENGEL_METNI[e]) : null;
}

/* ------------------------------------------------------------ boya raporu okuması (D-074 Faz 5 · PR 25) ------------------------------------------------------------ */

/** Boya raporu okuma uçları (M14-3; yetki evrak): sıraya koy / çıkar, elle okuma excel'i, DFT kolonunun riseri ve "Also file for {b}". "Compare again" ortak `OKUMA_UCU.karsilastir`. */
export const BOYA_UCU = {
  sira: (id: string) => `/belgeler/${id}/boya/okuma`,
  girdi: (id: string) => `/belgeler/${id}/boya/okuma/girdi`,
  dftSec: (id: string) => `/belgeler/${id}/boya/dft-riser`,
  ikinci: (id: string) => `/belgeler/${id}/boya/ikinci`,
} as const;

/** Yerin bulunamama nedeni (kart cümlesi). */
export function boyaNedenMetni(n: BoyaOneriNedeni | null): string {
  switch (n) {
    case "bos": return cevir("nothing on the report shows the riser: choose it");
    case "supheli": return cevir("riser number not certain: check it on the page");
    case "sn_baska": return cevir("the line SNs belong to several risers: choose the riser");
    default: return cevir("proposed");
  }
}

/** "Where it goes" cümlesi (M14-8, M14-9): öneri, kişinin seçimi ya da bekleme. Bekleme riseri kuyruğa girmişse "use Compare again" (yazım yok). */
export function boyaYerMetni(k: Pick<BoyaOkumaKarti, "yer">): string {
  const y = k.yer;
  if (!y) return "";
  const rn = y.yer?.tur === "boya" ? y.yer.rn : "";
  switch (y.durum) {
    case "kisi": return cevir("Your choice: {0}.", rn);
    case "oneri": return y.kapsam.length > 1 && y.kapsam[0] === rn
      ? cevir("Proposed: {0}, the lower riser number of the two in the assembly queue.", rn)
      : cevir("Proposed: {0}, the riser of this report in the assembly queue.", rn);
    case "adim_bekliyor": return y.bekleme?.simdiKuyrukta
      ? cevir("{0} is now in the assembly queue: use Compare again.", y.bekleme.rn)
      : cevir("Waiting for the step: {0} is not in the assembly queue yet. The file stays here and is not filed. When {0} is sent to assembly, use Compare again.", y.bekleme?.rn ?? "");
    case "riser_bekliyor": return cevir("Waiting for its riser: {0} is not in OASIS yet.", y.bekleme?.rn ?? "");
    case "yok": return boyaNedenMetni(y.neden);
  }
}

/** Kapsamın cümlesi (iki riserli raporda; sıra anlam taşımaz). */
export const boyaKapsamMetni = (kapsam: readonly string[]): string | null =>
  kapsam.length === 2 ? cevir("Covers {0} and {1} (the order of the numbers means nothing)", kapsam[0]!, kapsam[1]!) : null;

/** Final önerisinin cümlesi (M14-10; yalnız öneri). */
export function boyaFinalOneriMetni(o: BoyaFinalOnerisi): string {
  switch (o.neden) {
    case "en_yeni_son_kat": return cevir("final: the newest topcoat report read for {0} ({1})", o.rn, cevir("this report"));
    case "son_kat_yok": return cevir("not final: no topcoat on this report");
    case "daha_yeni": return cevir("not final: a newer topcoat report was read for {0} ({1}, {2})", o.rn, o.kod ?? "—", o.tarih ?? "—");
    case "ayni_gun": return cevir("no suggestion: another topcoat report of {0} has the same date ({1})", o.rn, o.kod ?? "—");
    case "tarih_yok": return cevir("no suggestion: the report date is not certain");
  }
}
/** Dosyalama formunun altındaki öneri cümlesi (final sorusu seçimsiz kalır). */
export function boyaFormOneriMetni(o: BoyaFinalOnerisi | null | undefined): string | null {
  if (!o || o.oneri === null) return null;
  return o.oneri === "final"
    ? cevir("Reading: suggested final for {0} (the newest topcoat report read for this riser). OASIS does not choose it.", o.rn)
    : cevir("Reading: suggested not final for {0}. OASIS does not choose it.", o.rn);
}

const BOYA_HAT_ADI: Record<string, string> = { Choke: "Choke", Kill: "Kill", Booster: "Booster", Hydraulic: "Hydraulic" };

/** Karşılaştırma notunun ekran cümlesi ("Compared with OASIS" altında; uyarı değildir). */
export function boyaNotMetni(n: BoyaNotu): string {
  const alan = (a: string) => cevir(boyaOkumaEtiketi(a));
  switch (n.tur) {
    case "suphe": return n.satir === null
      ? cevir("Not compared: {0} is uncertain. Check it on the page.", alan(n.alan))
      : cevir("{0} row {1}: {2}", n.tablo === "Coats" ? cevir("Coats") : "DFT", n.satir, cevir("Not compared: {0} is uncertain. Check it on the page.", alan(n.alan)));
    case "bicim": return cevir("Not compared: {0} has no digits ({1}).", alan(n.alan), n.deger);
    case "sn_riseri": return cevir("The line SNs point to {0}.", n.rn);
    case "ikinci_yok": return cevir("Second riser {0} is not in OASIS: the report is filed only here.", n.sayi);
    case "ayni_sn": return cevir("{0} written on {1}: compared with the {2} line only.", n.sn, n.hatlar.map((h) => BOYA_HAT_ADI[h] ?? h).join(", "), BOYA_HAT_ADI[n.hat] ?? n.hat);
    case "ikinci_riser_hatti": return cevir("{0} is the {1} line of {2}, the other riser of this report.", n.sn, BOYA_HAT_ADI[n.hat] ?? n.hat, n.rn);
    case "hatlar_yok": return cevir("Not compared: OASIS knows no line SN of {0} yet.", n.rn);
    case "onceki_kat": return cevir("Earlier read report of {0} for {1}: {2}, batches {3}.", n.kod, cevir(n.kat), n.tarih, n.parti);
    case "parti_ayni": return cevir("Same batch as the earlier read report ({0}).", n.kod);
    case "tarihsiz": return cevir("Batches not compared: the report date is not certain.");
    case "dft_tutarsiz": return cevir("DFT column {0}: minimum above average.", n.etiket ?? String(n.sira));
    case "dft_secildi": return cevir("DFT column {0} assigned to {1} by {2}.", n.sira, n.rn, n.kim);
    case "rapor_no_tarihi_ayni": return cevir("The date in the report number is the printed date.");
  }
}

/** "Compared with OASIS" satırları (PR 23 kalıbı): karşılaştırılmayanlar ayrı işaretli; yinelenen cümle bir kez. */
export function boyaKarsilastirmaSatirlari(k: Pick<BoyaOkumaKarti, "karsilastirma">): { metin: string; suphe: boolean; karsilastirildi: boolean }[] {
  const l: { metin: string; suphe: boolean; karsilastirildi: boolean }[] = [];
  if (!k.karsilastirma) return l;
  const karsilastirilmadi = new Set(["suphe", "bicim", "tarihsiz", "hatlar_yok", "ikinci_yok"]);
  for (const n of k.karsilastirma.notlar) {
    const metin = boyaNotMetni(n);
    if (!l.some((x) => x.metin === metin)) l.push({ metin, suphe: karsilastirilmadi.has(n.tur), karsilastirildi: !karsilastirilmadi.has(n.tur) });
  }
  return l;
}

/** DOCUMENT değerinin ekran yazısı: form, evet/hayır ve tarihler (As written varsa). */
export function boyaDegerMetni(alan: string, d: Pick<OkunanDeger, "deger" | "yazildigi"> | null | undefined): string {
  if (!d?.deger) return "—";
  if (alan === "form") {
    const f = boyaFormOku(d.deger);
    return f === "daily report" ? cevir("daily technical service report") : f === "application form" ? cevir("coating application form (GOE)") : d.deger;
  }
  if (alan === "imza" || alan === "test_bolumu") {
    const e = evetHayirOku(d.deger);
    return e ? cevir(e) : d.deger;
  }
  if (alan === "rapor_tarihi" || alan === "rapor_no_tarihi") {
    return d.yazildigi && d.yazildigi.trim() !== d.deger.trim() ? `${d.deger} · ${cevir("{0} (as written)", d.yazildigi.trim())}` : d.deger;
  }
  return d.deger;
}

/** Kartta çizilen DOCUMENT değerleri: günlük raporda hat SN'leri ve test bölümü çizilmez. */
export function boyaKartAlanlari(k: Pick<BoyaOkumaKarti, "degerler">): OkunanDeger[] {
  const gunluk = boyaFormOku(kesinDeger(k.degerler, "form")) === "daily report";
  const gizli = new Set(["hat_sn_choke", "hat_sn_kill", "hat_sn_booster", "hat_sn_hydraulic", "test_bolumu"]);
  return k.degerler.filter((d) => !(gunluk && gizli.has(d.alan)));
}

/** DFT kolonunun durum cümlesi (Riser · Result). */
export function boyaKolonMetni(c: BoyaDftKolonu | null): string {
  if (!c) return "—";
  switch (c.durum) {
    case "etiketsiz": return c.rn ?? "—";
    case "cift": return cevir("{0} (by its label)", c.rn ?? "—");
    case "secildi": return cevir("{0} (chosen by {1})", c.rn ?? "—", c.secim?.kim ?? "—");
    case "secilmedi": return cevir("names {0}, outside the pair", c.etiketSayisi ?? "—");
    case "supheli": return cevir("not checked until you choose the riser");
  }
}

/** "Also file for {b}" bölümünün durum cümlesi (M14-28). */
export function boyaIkinciMetni(d: BoyaIkinciDurumu, rn: string | null, sayi: string | null = null): string {
  switch (d) {
    case "kapali": return cevir("The row is closed. Nothing is filed from it.");
    case "yok": return "";
    case "ikinci_yok": return cevir("Second riser {0} is not in OASIS: the report is filed only here.", sayi ?? "—");
    case "engel": return cevir("The reading changed; compare again before filing it for the second riser.");
    case "eklendi": return cevir("This report is already a coating report of {0}.", rn ?? "—");
    case "dosyalanmadi": return cevir("Second riser: {0} · after filing: “Also file for {0}”", rn ?? "—");
    case "kuyrukta_degil": return cevir("{0} is not in the assembly queue. File it for {0} when it is sent to assembly.", rn ?? "—");
    case "eklenebilir": return cevir("This report also covers {0} (BY-04). File the same PDF and pages for {0} too:", rn ?? "—");
  }
}

/** "Use the reading" (M14-30): önerilen ya da kişinin yeri, yalnız kuyruktayken; değilse boş. Final alanı yoktur (form seçimsiz açar). */
export function boyaFormu(k: Pick<BoyaOkumaKarti, "yer">): { rn: string } {
  const y = k.yer;
  if (!y || (y.durum !== "oneri" && y.durum !== "kisi") || y.yer?.tur !== "boya") return { rn: "" };
  return { rn: y.yer.rn };
}
/** Rapor PDF'in bir kısmıysa raporun sayfaları ("6" ya da "6-9"); PDF'in tamamıysa ya da aralık bilinmiyorsa null. */
export function boyaSayfalari(k: Pick<BoyaOkumaKarti, "okuma">): string | null {
  const s = k.okuma?.sayfalar;
  if (!s || (s.bas === 1 && s.son === k.okuma!.sayfaSayisi)) return null;
  return s.bas === s.son ? String(s.bas) : `${s.bas}-${s.son}`;
}

/**
 * Okunmuş boya raporunun yer kapısı (M14-27; sunucunun `boyaYerDenetle` ile aynı kural): okunmuş ve sırada olmayan satırda form okumanın yerini (riserini) göstermeli; final hedefin parçası
 * değildir (`hedefEsit` boya dalı). Kart null ya da hedef boya değilse null.
 */
export function boyaYerEngeli(k: Pick<BoyaOkumaKarti, "okuma" | "yer" | "karsilastirma" | "is"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.okuma || hedef?.tur !== "boya") return null;
  if (k.is?.durum) return null;
  if (!k.karsilastirma) return cevir(KARSILASTIRMA_YERI_METNI);
  return hedefEsit(k.yer?.yer ?? null, hedef) ? null : cevir(KARSILASTIRMA_YERI_METNI);
}

/** Karar kapısı (T21, M14-27): parçanın ve parçasız uyarıların kararsız kırmızısı ya da "Do not file" kararı varken dosyalanmaz. */
export function boyaDosyalamaEngeli(k: Pick<BoyaOkumaKarti, "karsilastirma"> | null | undefined, hedef: GelenHedef | null): string | null {
  if (!k?.karsilastirma || hedef?.tur !== "boya") return null;
  const e = dosyalamaEngeli(k.karsilastirma.uyarilar, false);
  return e ? cevir(DOSYALAMA_ENGEL_METNI[e]) : null;
}

/* ------------------------------------------------------------ yükleme öncesi denetim ------------------------------------------------------------ */

export const MB = 1024 * 1024;
/** Dosya seçicisinin kabul ettiği uzantılar (Word saklanır, GEN-16 ile dosyalanmaz; asıl karar sunucuda baytlardan). */
export const KABUL_UZANTILARI = ".pdf,.jpg,.jpeg,.png,.xlsx,.xls,.csv,.doc,.docx,.docm,.rtf,.odt";
const UZANTI = /\.(?:pdf|jpe?g|png|xlsx|xls|csv|doc|docx|docm|rtf|odt)$/i;

/** Yüklemeden önce: 100 MB'tan büyük ya da uzantısı kabul edilmeyen dosyanın cümlesi; uygunsa null. */
export function yuklemeOnDenetimi(f: { name: string; size: number }): string | null {
  if (f.size > GELEN_YUKLEME_SINIRI_MB * MB) return cevir("{0} is larger than 100 MB. Larger files are uploaded on their own screen: MRB intake, Registers and Project documents take up to 200 MB.", f.name);
  if (!UZANTI.test(f.name)) return cevir("This file type is not accepted: {0}. Upload PDF, JPG, PNG or the excel of a converter type.", f.name);
  return null;
}

/**
 * Aktarmadan önce: dosya hedef kapının kendi sınırından büyükse İNGİLİZCE cümle (J24, R9); değilse null. Son deneme olarak saklanır ve
 * gösterimde sözlük kalıbıyla çevrilir (inceleme bulgusu, U-073: önceden çevrilmiş metin saklanıyordu; Türkçe kipte yazılan son deneme
 * İngilizce kipteki kişiye Türkçe görünüyordu).
 */
export function hedefSinirHatasi(tur: string | null, ad: string, boyut: number): string | null {
  const t = turTanimi(tur);
  if (!t?.sinirMb || boyut <= t.sinirMb * MB) return null;
  return kalipDoldur("{0} is larger than {1} MB, the limit of {2}.", [ad, String(t.sinirMb), t.ad]);
}

/** Yükleme turunun sonu: "{0} uploaded · {1} refused". */
export const yuklemeOzeti = (yuklenen: number, reddedilen: number): string => cevir("{0} uploaded · {1} refused", yuklenen, reddedilen);
export const yuklemeIlerlemesi = (sira: number, toplam: number, ad: string): string => cevir("Uploading {0} of {1}: {2}", sira, toplam, ad);

/* ------------------------------------------------------------ hedef formu ------------------------------------------------------------ */

/** D-074 Faz 2 (K7): hidrotest sertifikasının sonucu; "" = seçilmedi (dosya adı "reject" diyor). */
export type HtSonuc = "" | "kabul" | "ret";
/** Dosya adından ilk değer: ad "reject" diyorsa boş, değilse kabul (bugünkü davranış). Ad yalnız ipucudur, seçim yapmaz. */
export const ilkHtSonucu = (ad: string | null | undefined): HtSonuc => (htRetAdiMi(ad) ? "" : "kabul");

/** "File by hand" formunun alanları (tür değişince sıfırlanır). */
export interface HedefFormu {
  rn: string;
  hat: string;
  tamirId: string;
  bomId: string;
  /** Project documents: "proje" · "is_emri:<no>" · "riser" */
  kapsam: string;
  kutukAnahtar: string;
  sn: string;
  /** Dönüştürücü: eşli excel satırı (gelen satırı kimliği) */
  ekId: string | null;
  /** Hidrotest: "kabul" | "ret" | "" (seçilmedi; dosya adı "reject" diyor, D-074 K7) */
  htSonuc: HtSonuc;
  /** Boya: "evet" | "hayir" | "" (seçilmedi; D-074 Faz 5 · PR 24) */
  boyaFinal: BoyaFinalSecimi;
}
export const BOS_FORM: HedefFormu = { rn: "", hat: "", tamirId: "", bomId: "", kapsam: "", kutukAnahtar: "", sn: "", ekId: null, htSonuc: "kabul", boyaFinal: "" };

const RN = /^R\d{3}$/;
/** Riser yazımı: "r107" → "R107", "107" → "R107" (inceleme bulgusu: tablette yalnız sayı yazılıyor); boşsa "". */
export const rnYaz = (s: string): string => {
  const r = s.trim().toUpperCase();
  return /^\d{3}$/.test(r) ? `R${r}` : r;
};

/**
 * Saklı hedeften formun ilk değeri (kişi önerilen yeri gördüğü gibi açar). `ad` dosyanın adı: hidrotest sonucu saklı hedefte yoksa
 * addan ilk değer alır (D-074 K7; ad "reject" diyorsa seçim boş).
 */
export function formHedeften(h: GelenHedef | null, ipucu: GelenIpucu | null = null, ad: string | null = null): HedefFormu {
  const f: HedefFormu = { ...BOS_FORM, rn: ipucu?.rn ?? "", sn: ipucu?.sn ?? "", htSonuc: ilkHtSonucu(ad) };
  if (!h) return f;
  switch (h.tur) {
    case "ht": return { ...f, rn: h.rn, hat: h.hat, htSonuc: h.ret ? "ret" : "kabul" };
    case "hat_ndt": return { ...f, rn: h.rn, hat: h.hat };
    case "boya": return { ...f, rn: h.rn, boyaFinal: h.final === true ? "evet" : h.final === false ? "hayir" : "" };
    case "proje": return { ...f, kapsam: h.kapsam === "is_emri" ? `is_emri:${h.anahtar ?? ""}` : h.kapsam, rn: h.kapsam === "riser" ? (h.anahtar ?? "") : f.rn };
    case "adim_raporu": case "pwht": case "weldmap": return { ...f, tamirId: h.tamirId };
    case "urun_geldi": return { ...f, tamirId: h.tamirId, bomId: h.bomId };
    case "kutuk": return { ...f, kutukAnahtar: h.anahtar };
    case "donusturucu": return { ...f, rn: h.rn ?? f.rn, sn: h.sn ?? f.sn, ekId: h.ekId ?? null };
  }
}

/**
 * Formdan hedef (tamam değilse null). Riser ve hat listedekilerden olmalı; iş ve malzeme satırı seçicideki gibi; dönüştürücüde
 * riser (MRB'de SN) dosya adından okunamıyorsa kişi yazar.
 */
export function hedefKur(tur: string | null, f: HedefFormu, o: { isler?: readonly IsSecenegi[]; riserler?: readonly string[]; adRn?: string | null; adSn?: string | null } = {}): GelenHedef | null {
  const t = turTanimi(tur);
  if (!t?.hedef) return null;
  const rn = rnYaz(f.rn);
  const riserVar = (r: string) => RN.test(r) && (!o.riserler || o.riserler.includes(r));
  const is = o.isler?.find((x) => x.tamirId === f.tamirId) ?? null;
  switch (t.hedef) {
    case "ht":
      // D-074 K7: sonuç seçilmeden (dosya adı "reject" diyor) hedef kurulmaz.
      return riserVar(rn) && (BASINC_TESTI_HATLARI as readonly string[]).includes(f.hat) && f.htSonuc !== ""
        ? { tur: "ht", rn, hat: f.hat as (typeof BASINC_TESTI_HATLARI)[number], ...(f.htSonuc === "ret" ? { ret: true as const } : {}) }
        : null;
    case "hat_ndt":
      return riserVar(rn) && (SET_HATLARI as readonly string[]).includes(f.hat) ? { tur: "hat_ndt", rn, hat: f.hat as (typeof SET_HATLARI)[number] } : null;
    case "boya":
      // D-074 Faz 5 · PR 24 (B6): "Final coating report" seçilmeden hedef kurulmaz.
      return riserVar(rn) && f.boyaFinal !== "" ? { tur: "boya", rn, final: f.boyaFinal === "evet" } : null;
    case "proje": {
      const belgeTuru = t.proje!;
      if (f.kapsam === "riser") return riserVar(rn) ? { tur: "proje", kapsam: "riser", anahtar: rn, belgeTuru } : null;
      if (f.kapsam === "proje") return { tur: "proje", kapsam: "proje", anahtar: null, belgeTuru };
      if (f.kapsam.startsWith("is_emri:") && f.kapsam.length > "is_emri:".length) return { tur: "proje", kapsam: "is_emri", anahtar: f.kapsam.slice("is_emri:".length), belgeTuru };
      return null;
    }
    case "adim_raporu":
      return is?.raporAlir && is.aktifAdim ? { tur: "adim_raporu", tamirId: is.tamirId, adim: is.aktifAdim } : null;
    // D-074 Faz 2 · PR 11 (G3): işin aktif PWHT adımı.
    case "pwht":
      return is?.aktifAdim && pwhtAdimiMi(is.aktifAdim) ? { tur: "pwht", tamirId: is.tamirId, adim: is.aktifAdim } : null;
    case "weldmap":
      return is ? { tur: "weldmap", tamirId: is.tamirId } : null;
    case "urun_geldi": {
      const b = is?.bom.find((x) => x.id === f.bomId && x.durum === "siparis_verildi");
      return is && b ? { tur: "urun_geldi", tamirId: is.tamirId, bomId: b.id, bomSira: b.sira } : null;
    }
    case "kutuk":
      return f.kutukAnahtar ? { tur: "kutuk", kutuk: t.kutuk!, anahtar: f.kutukAnahtar, belgeTuru: t.belgeTuru! } : null;
    case "donusturucu": {
      const aile = t.donusturucu!.aile;
      if (aile === "mrb") {
        // Yazılan ama SN olarak okunamayan değer (ör. "1306722") eksiktir; önceden sessizce dosya adındaki SN'e dönüyordu.
        const sn = f.sn.trim() ? mrbSnBul(f.sn.trim()) : null;
        if (f.sn.trim() && !sn) return null;
        return sn || o.adSn ? { tur: "donusturucu", aile, sn: sn ?? null, ekId: f.ekId } : null;
      }
      if (rn && !riserVar(rn)) return null;
      return rn || o.adRn ? { tur: "donusturucu", aile, rn: rn || null, ekId: f.ekId } : null;
    }
  }
}

/**
 * Toplu pencerenin dosya adından okuduğu riser ya da SN (kapı da adı okur): Disposition / Rework `raporDosyaBul`, FM-0011
 * `sokumRnBul`, FM-0012 `montajRnBul`, MRB `mrbSnBul`. Kişi başkasını seçmedikçe istekte riser gitmez.
 */
export function adDegerleri(aile: DonusturucuAilesi, ad: string): { rn: string | null; sn: string | null } {
  switch (aile) {
    case "mrb": return { rn: null, sn: mrbSnBul(ad) };
    case "disposition": case "rework": return { rn: raporDosyaBul(ad).rn, sn: null };
    case "sokum": return { rn: sokumRnBul(ad), sn: null };
    case "montaj": return { rn: montajRnBul(ad), sn: null };
  }
}

/** Hedefin sırasız, boş alansız yazımı (sunucunun sakladığı JSON alan sırası ve boş alanları farklı olabilir). */
const kanonik = (h: GelenHedef | null): string =>
  h ? JSON.stringify(Object.entries(h).filter(([, v]) => v !== null && v !== undefined && v !== "").sort(([a], [b]) => a.localeCompare(b))) : "null";
/** İki hedef aynı yer mi (önerilen yerin yeniden yazılıp yazılmayacağı; alan sırası ve boş alanlar fark etmez). */
export const ayniHedef = (a: GelenHedef | null, b: GelenHedef | null): boolean => kanonik(a) === kanonik(b);

/** Coating seçicisi: assembly sırasındaki riserler (D-074 Faz 5 · PR 24: boya raporu olan da; birden çok rapor tutulur). */
export const boyaRiserleri = (r: readonly SeciciRiseri[]): SeciciRiseri[] => r.filter((x) => x.kuyrukta);
/** Adım raporu seçicisi: aktif adımı rapor isteyen işler. */
export const raporIsleri = (i: readonly IsSecenegi[]): IsSecenegi[] => i.filter((x) => x.raporAlir && x.aktifAdim);
/** Product arrived seçicisi: "ordered" malzeme satırı olan işler. */
export const urunIsleri = (i: readonly IsSecenegi[]): IsSecenegi[] => i.filter((x) => x.bom.some((b) => b.durum === "siparis_verildi"));
/** İşin seçici etiketi: "R107 · Choke · Weld repair". */
export const isEtiketi = (i: Pick<IsSecenegi, "riserRn" | "hat" | "is">): string => [i.riserRn, i.hat, i.is].join(" · ");

/** Adımın imzalayanı sorulur mu (riser işinin NDT adımı) ve raporun yöntemleri (yeterlilik uyarısı). */
export const adimImzasi = (i: Pick<IsSecenegi, "aktifAdim" | "grup"> | null): { sorulur: boolean; yontemler: ReturnType<typeof adimYontemleri> } => ({
  sorulur: Boolean(i && imzalayanSorulurMu(i.aktifAdim, i.grup)),
  yontemler: adimYontemleri(i?.aktifAdim),
});
export const sertlikAdimiMi = (adim: string | null | undefined): boolean => Boolean(adim && /Hardness/.test(adim));

/**
 * Hardness adımının değerleri ucun kuralıyla (planlama.controller `rapor`; inceleme bulgusu, U-073): weld map PDF'i olan işte üçü de boş
 * kalabilir; değilse üçü de sayı olmalı; işin kaynakları varsa Weld no. seçilmeli. Eksikse ucun İngilizce cümlesi, tamamsa null.
 */
export function sertlikHatasi(is: Pick<IsSecenegi, "aktifAdim" | "weldMapVar" | "weldler"> | null, d: { abm1: string; weld: string; abm2: string; weldId?: string | null }): string | null {
  if (!is || !sertlikAdimiMi(is.aktifAdim)) return null;
  const degerler = [d.abm1, d.weld, d.abm2].map((v) => v.trim());
  if (degerler.every((v) => v === "") && is.weldMapVar) return null;
  if (degerler.some((v) => v === "" || !Number.isFinite(Number(v.replace(",", "."))))) return "All three Hardness values must be entered.";
  if (is.weldler.length && !d.weldId) return "Choose the weld (Weld no.) for the hardness values.";
  return null;
}

/**
 * Tür seçimi satırı kişiden gizler mi (inceleme bulgusu, U-073: kaydetmeden önce sorulur). Kişi satırın yükleyenlerindense yükleyen
 * sayılır (`benim`). Dönüş: gizleyecekse yeni türün sınıfı, gizlemeyecekse null.
 */
export function gizleyenSinif(ben: { id: string; rol: Parameters<typeof gelenGorunumu>[0]["rol"] }, s: Pick<GelenSatiri, "benim">, tur: string | null): GelenSinifi | null {
  const g = gelenGorunumu(ben, { yukleyenId: s.benim ? ben.id : "", ekYukleyenler: [], tur });
  return g === "tam" ? null : gelenSinifi(tur);
}

/**
 * Satır kişiden gizlendiğinde (ya da gizlenecekken) görünme cümlesi, sınıfa göre: kişisel GEN-07, fiyatlı GEN-08, kütük belgesi ve
 * türsüz / "Other" kendi cümlesi (inceleme bulgusu, U-073: önceden fiyatlı dışında her sınıfa GEN-07 "Personal data" yazılıyordu).
 */
export function gorunmeCumlesi(sinif: GelenSinifi | null | undefined): string {
  switch (sinif) {
    case "fiyat": return cevir("Prices: visible to PM and System administrator only.");
    case "kisisel": return cevir("Personal data: visible to PM and System administrator only.");
    case "kutuk": return cevir("Registers documents: visible to the uploader, the Quality Lead, PM and System administrator.");
    default: return cevir("Files without a type: visible to the uploader, the Quality Lead, the Field Inspector, PM and System administrator.");
  }
}

/** Kütüğün belge alanları: Doc no. ve kütüğün kolonlarından türün alanları (`belgeAlanlari`: süreklilikte Date, Note; alette kalibrasyon dışında Lab, Date). */
export function kutukAlanlari(kutuk: BelgeKutugu, belgeTuru: string): { alan: string; etiket: string }[] {
  const alanlar = belgeAlanlari(kutuk, belgeTuru);
  return [{ alan: "belgeNo", etiket: "Doc no." }, ...BELGE_KOLONLARI[kutuk].filter((k) => alanlar.includes(k.alan))];
}

/* ------------------------------------------------------------ "Effects of filing", "What the gate does" ------------------------------------------------------------ */

export interface EtkiBaglami {
  /** Hidrotest: hattın daha önce bir (kabul edilmiş) sertifikası var. */
  htVar?: boolean;
  /** Hidrotest: sonuç "Rejected" seçili (D-074 K7). */
  htRet?: boolean;
  /** Hidrotest: riser Finishing kuyruğunda (HT-10 yalnız kuyruktaki riserler için üretilir). */
  kuyrukta?: boolean;
  /** Finishing NDT: hatta "No record available" beyanı var. */
  kayitYok?: boolean;
  /** Adım raporu: aktif adımın raporu var. */
  adimRaporuVar?: boolean;
  /** Adım raporu: Partial aralık sayısı (D-074 Faz 2; her aralık ayrı rapor). */
  aralikSayisi?: number;
  /** Adım raporu: Hardness adımı. */
  sertlik?: boolean;
  /** Weld map: işin weld map PDF'i var. */
  weldMapVar?: boolean;
  /** Product arrived: malzeme satırının PN'i. */
  pn?: string | null;
  /** D-074 Faz 2 · PR 9: okunmuş NDT raporunda formun yerine düşmeyen raporların sıraları ("2-4", "2, 4"); boş ya da yoksa cümle yok. */
  ndtDisarida?: string;
  /** D-074 Faz 2 · PR 10: weld map okunmuş (kaynak tarihleri dosyalamadan sonra kaydedilir, Z14). */
  weldMapOkundu?: boolean;
  /** D-074 Faz 2 · PR 11 (G18): okunmuş PWHT grafiğinin bir grafiği ortak kanıt. */
  pwhtOrtak?: boolean;
  /** D-074 Faz 3 · PR 14: Registers kaydının görünen adı (NDT inspektörü); yoksa "this inspector". D-074 Faz 3 · PR 15: kaynakçıda kodu; yoksa "this welder". */
  kayitAdi?: string;
  /** D-074 Faz 3 · PR 15: satır kaynakçı belgesi olarak okunmuş (süreklilik satırları dosyalamadan sonra eklenir; WPQ'da weld map'ler yeniden karşılaştırılır). */
  wpqOkundu?: boolean;
  /** D-074 Faz 3 · PR 16: satır kalibrasyon sertifikası olarak okunmuş (aletin hidrotest ve NDT okumaları dosyalamadan sonra yeniden karşılaştırılır). */
  kalibrasyonOkundu?: boolean;
  /** D-074 Faz 3 · PR 16: okumada birden çok cihaz var (öteki cihazlar dosyalamadan sonra tek tek eklenir). */
  kalibrasyonCokCihaz?: boolean;
  /** D-074 Faz 3 · PR 16 (M1-18): formun değerleriyle D-049'un Calibration end'e etkisi (`kalibrasyonEtkisi`); formun aleti dosyanın bir cihazı değilse null. */
  kalibrasyonEtkisi?: { kod: string; once: string | null; sonra: string | null } | null;
  /** D-074 Faz 3 · PR 17: satır sarf belgesi olarak okunmuş (lotun değeri dosyalamadan sonra "Record on the lot" ile; o lotun açık okumaları yeniden karşılaştırılır). */
  sarfOkundu?: boolean;
  /** D-074 Faz 3 · PR 17: formun Record'undaki lot; yoksa "this lot". */
  sarfLot?: string | null;
  /** D-074 Faz 3 · PR 18: satır WPS belgesi olarak okunmuş (eski sürüm dosyalamadan sonra işaretlenir; o WPS'i anan okumalar yeniden karşılaştırılır). */
  wpsOkundu?: boolean;
  /** D-074 Faz 3 · PR 18: formun WPS'i; yoksa "this WPS". */
  wpsKod?: string | null;
  /** D-074 Faz 4 · PR 20: satır packing list olarak okunmuş (liste öteki paketlere dosyalamadan sonra eklenir; aynı PN'lerin açık okumaları yeniden karşılaştırılır). */
  teslimOkundu?: boolean;
  /** D-074 Faz 4 · PR 20: formun Record'undaki paketin PKG no'su; yoksa "this package". */
  teslimPkg?: string | null;
  /** D-074 Faz 4 · PR 21: satır malzeme sertifikası olarak okunmuş (öteki sertifikalar dosyalamadan sonra eklenir; heat ve PO kişi onayıyla; açık okumalar yeniden karşılaştırılır). */
  malzemeOkundu?: boolean;
  /** D-074 Faz 4 · PR 21: formun Record'undaki paketin PKG no'su ve PN'i; yoksa "this package" / "this part number". */
  malzemePkg?: string | null;
  malzemePn?: string | null;
  /** D-074 Faz 4 · PR 22: satır CoC olarak okunmuş (öteki kalemlerin paketlerine dosyalamadan sonra eklenir; aynı PN'lerin açık packing list okumaları yeniden karşılaştırılır). */
  uygunlukOkundu?: boolean;
  /** D-074 Faz 4 · PR 22: formun Record'undaki paketin PKG no'su; yoksa "this package". */
  uygunlukPkg?: string | null;
  /** D-074 Faz 4 · PR 23: satır PO olarak okunmuş (öteki satırların paketlerine dosyalamadan sonra eklenir; paketlerin PO no'su değişmez). */
  satinAlmaOkundu?: boolean;
  /** D-074 Faz 4 · PR 23: formun Record'undaki paketin PKG no'su; yoksa "this package". */
  satinAlmaPkg?: string | null;
  /** Boya (D-074 Faz 5 · PR 24): "Final coating report" seçimi, riserin bugünkü finalinin adı, assembly raporu var mı, riser. */
  boyaFinal?: BoyaFinalSecimi;
  boyaMevcutFinal?: string | null;
  /** D-074 Faz 5 · PR 25: okumanın ikinci riseri (dosyalamadan sonra "Also file for {b}"). */
  boyaIkinci?: string | null;
  asmVar?: boolean;
  rn?: string;
}

/** Dosyalamanın etkileri ("Effects of filing"), düğmeden önce; bugünkü yolun yaptıkları (yalnız durumu söyleyenler). */
export function etkiler(tur: string | null, b: EtkiBaglami = {}): string[] {
  const t = turTanimi(tur);
  if (!t?.hedef) return [];
  switch (t.hedef) {
    case "kutuk":
      if (t.kutuk === "alet" && t.belgeTuru === "kalibrasyon") {
        const d049 = cevir("The record's {0} becomes the end date of the newest certificate (D-049). A date typed by hand is replaced.", cevir("Calibration end"));
        // D-074 Faz 3 · PR 16 (M1-17 … M1-19): eski ve yeni Calibration end yan yana; öteki cihazlar dosyalamadan sonra tek tek; aletin okumaları yeniden karşılaştırılır.
        if (!b.kalibrasyonOkundu) return [d049];
        return [
          d049,
          ...(b.kalibrasyonEtkisi ? [kalibrasyonEtkiMetni(b.kalibrasyonEtkisi, "dosyalama")] : []),
          ...(b.kalibrasyonCokCihaz ? [cevir("The other devices of the file are added after filing, one by one (“Add to Registers”).")] : []),
          cevir("Then the hydrotest and NDT readings that name {0} are compared again (open Documents rows and audit readings). No test, report or record changes.", b.kalibrasyonEtkisi?.kod ?? b.kayitAdi ?? cevir("this instrument")),
        ];
      }
      if (t.kutuk === "kaynakci" && t.belgeTuru === "wpq") {
        const d049 = cevir("The record's {0} becomes the end date of the newest certificate (D-049). A date typed by hand is replaced.", cevir("End of validity"));
        // D-074 Faz 3 · PR 15 (M7-18, M7-21): okunmuş WPQ'da süreklilik satırları dosyalamadan sonra tek tek; ardından kaynakçının weld map okumaları yeniden karşılaştırılır.
        if (!b.wpqOkundu) return [d049];
        return [
          d049,
          cevir("Signed continuity rows of the document are added after filing, one by one (“Add to Registers”)."),
          cevir("Then the weld map readings of welder {0} are compared again (open Documents rows and audit readings). No weld, pass or record changes.", b.kayitAdi ?? cevir("this welder")),
        ];
      }
      // D-074 Faz 3 · PR 17 (M8-18, M8-19): okunmuş sarf belgesinde lotun değeri dosyalamadan sonra kişinin onayıyla; o lotun açık sarf belgesi okumaları yeniden karşılaştırılır.
      if (t.kutuk === "sarf" && (t.belgeTuru === "en10204_31" || t.belgeTuru === "kabul_formu") && b.sarfOkundu) {
        const lot = b.sarfLot ?? cevir("this lot");
        return [
          t.belgeTuru === "en10204_31"
            ? cevir("After filing, the diameter on the certificate can be recorded on lot {0} on this card (“Record on the lot”), only while the lot has no diameter.", lot)
            : cevir("After filing, the receiving date can be recorded as Received on of lot {0} on this card (“Record on the lot”), only while the lot has none.", lot),
          cevir("Then the open readings of the certificates and receiving forms of lot {0} are compared again (SARF-06). No record changes.", lot),
        ];
      }
      // D-074 Faz 3 · PR 18 (M9-19, M9-22): okunmuş WPS belgesinde eski sürüm dosyalamadan sonra kartta işaretlenir; o WPS'i anan okumalar yeniden karşılaştırılır.
      if (t.kutuk === "wps" && (t.belgeTuru === "wps" || t.belgeTuru === "pqr" || t.belgeTuru === "dolgu_onayi") && b.wpsOkundu) {
        const kod = b.wpsKod ?? cevir("this WPS");
        const weldMap = cevir("Then the open weld map readings that name WPS {0} (SARF-03, WPS-06; open Documents rows and audit readings) and the open WPS, PQR and filler approval readings of {0} are compared again. No record changes.", kod);
        if (t.belgeTuru === "wps") return [cevir("After filing, an older WPS document of {0} can be marked superseded on this card, one by one (PM or System administrator).", kod), weldMap];
        if (t.belgeTuru === "pqr") {
          return [
            cevir("After filing, an older version of this PQR on {0} can be marked superseded on this card (PM or System administrator).", kod),
            cevir("Then the open WPS, PQR and filler approval readings of {0} are compared again (WPS-04). No record changes.", kod),
          ];
        }
        // Liste yarım kurulmaz (wps-dolgu-listesi.ts): okunmamış güncel satır varken WPS listeye girmez; cümle bu koşulu söyler.
        return [cevir("After filing, the classes and trade names of this sheet join the filler list of WPS {0} only when that WPS has a read WPS document and all its current WPS documents and filler approvals are read.", kod), weldMap];
      }
      // D-074 Faz 4 · PR 20 (M2-17, M2-18, M2-21): okunmuş packing list bir kalemin paketine dosyalanır; öteki paketlere tek tek eklenir; yeni paket yalnız PM ya da sistem yöneticisiyle.
      if (t.kutuk === "stok_paket" && t.belgeTuru === "teslim" && b.teslimOkundu) {
        return [
          cevir("The list is filed on stock package {0}. After filing, it is added to the package of each other line one by one (“Add the list”).", b.teslimPkg ?? cevir("this package")),
          cevir("A line without a package gets a new stock package only when a PM or System administrator opens it on this card (“Open stock package”) and types the arrival date."),
          cevir("Then the open packing list readings that name the same part numbers are compared again (TES-02). No package changes."),
        ];
      }
      // D-074 Faz 4 · PR 21 (M3-20, M3-22, M3-24): okunmuş malzeme sertifikası bir sertifikasının paketine dosyalanır; öteki sertifikalar tek tek eklenir; heat ve PO kişi onayıyla.
      if (t.kutuk === "stok_paket" && (t.belgeTuru === "en10204_31" || t.belgeTuru === "en10204_32") && b.malzemeOkundu) {
        return [
          cevir("The certificate is filed on stock package {0} as {1}. After filing, the other certificates of the file are added to their packages one by one (“Add to package”).", b.malzemePkg ?? cevir("this package"), cevir(BELGE_TURU_ADI.stok_paket[t.belgeTuru] ?? t.belgeTuru)),
          cevir("After filing, a PM or System administrator can record the heat and the customer PO of the certificate on the package on this card (“Record on the package”), only while the package has none."),
          cevir("Then the open material certificate and packing list readings of {0} are compared again (MTL-03, TES-04). No package changes.", b.malzemePn ?? cevir("this part number")),
        ];
      }
      // D-074 Faz 4 · PR 22 (M4-18, M4-20): okunmuş CoC bir kalemin paketine dosyalanır; öteki paketlere tek tek eklenir; aynı PN'lerin açık packing list okumaları yeniden karşılaştırılır.
      if (t.kutuk === "stok_paket" && t.belgeTuru === "coc" && b.uygunlukOkundu) {
        return [
          cevir("The CoC is filed on stock package {0}. After filing, it is added to the package of each other line one by one (“Add to package”).", b.uygunlukPkg ?? cevir("this package")),
          cevir("Then the open packing list readings that name the same part numbers are compared again (TES-04). No package changes."),
        ];
      }
      // D-074 Faz 4 · PR 23 (M5-24, M5-25): okunmuş PO bir satırın paketine dosyalanır; öteki paketlere tek tek eklenir; paketlerin PO no'su değişmez.
      if (t.kutuk === "stok_paket" && t.belgeTuru === "po" && b.satinAlmaOkundu) {
        return [
          cevir("The PO is filed on stock package {0}. After filing, it is added to the package of each other line one by one (“Add to package”).", b.satinAlmaPkg ?? cevir("this package")),
          cevir("The PO no. of a package and the package itself do not change."),
        ];
      }
      if (t.kutuk === "kaynakci" && t.belgeTuru === "sureklilik" && b.wpqOkundu) return [cevir("Signed continuity rows of the document are added after filing, one by one (“Add to Registers”).")];
      // D-074 Faz 3 · PR 14 (M6-16 … M6-18): tek satır eklenir; öteki yöntem satırları dosyalamadan sonra tek tek; ardından NDT raporları yeniden karşılaştırılır.
      if (t.kutuk === "ndt_inspektor" && t.belgeTuru === "ndt_sertifika") {
        const ad = b.kayitAdi ?? cevir("this inspector");
        return [
          cevir("A new NDT certificate row is added to {0} with the method and level you choose.", ad),
          cevir("The other method rows of the certificate are added after filing, one by one (“Add to Registers”)."),
          cevir("Then the NDT reports signed by {0} are compared again (open Documents rows and audit readings). No report, step or record changes.", ad),
        ];
      }
      return [];
    case "hat_ndt":
      return [
        ...(b.kayitYok ? [cevir("Filing clears “No record available” on this line.")] : []),
        // D-074 Faz 2 · PR 9 (N30): okunmuş dosyanın öteki raporları bu yerle dosyalanmaz.
        ...(b.ndtDisarida ? [disaridaMetni(b.ndtDisarida)] : []),
      ];
    case "ht":
      // D-074 K7: reddedilmiş sertifika hattın sertifikası sayılmaz (HT-09 cümlesi etki satırı olarak).
      if (b.htRet) {
        return [
          cevir("Rejected certificate: filed as rejected, not counted for the line."),
          cevir("Finishing lists it under the line as “HT rejected”; the Dashboard and Riser Documentation do not count it."),
          // HT-10 yalnız Finishing kuyruğundaki riserde açıktır; kuyrukta olmayan riserde cümle söylenmez.
          ...(b.kuyrukta && !b.htVar ? [cevir("HT-10 stays open on this line until an accepted certificate is filed.")] : []),
        ];
      }
      return b.htVar ? [cevir("Finishing shows the newest hydrotest certificate of the line; older ones stay in the record.")] : [];
    // D-074 Faz 5 · PR 24: etkiler final seçimine ve riserin hâline göre (bugünkü tek cümle kalktı).
    case "boya": return [
      ...boyaEtkileri({ rn: b.rn ?? "", secim: b.boyaFinal ?? "", mevcutFinalAd: b.boyaMevcutFinal ?? null, asmVar: Boolean(b.asmVar) }),
      // D-074 Faz 5 · PR 25 (M14-28): iki riserli raporda ikinci riser dosyalamadan sonra kişinin onayıyla.
      ...(b.boyaIkinci ? [cevir("Filed for {0}. After filing, “Also file for {1}” files the same PDF and pages for {1}; you choose Final or Not final for {1} there.", b.rn ?? "", b.boyaIkinci)] : []),
    ];
    case "adim_raporu":
      return [
        // D-074 Faz 2: yeni rapor adımın rapor listesine eklenir; Partial'da her aralık ayrı rapordur.
        ...(b.adimRaporuVar ? [cevir("The step already has a report. This report is added to the step's reports; the earlier report stays and still counts.")] : []),
        ...((b.aralikSayisi ?? 0) > 1 ? [cevir("{0} page ranges: each is filed as a separate report of this step.", String(b.aralikSayisi))] : []),
        ...(b.sertlik ? [cevir("The values replace earlier values for this weld.")] : []),
        ...(b.ndtDisarida ? [disaridaMetni(b.ndtDisarida)] : []),
      ];
    // D-074 Faz 2 · PR 11 (G18): PWHT grafiği adım raporu yolundan; PWHT imzası değişmez; ortak grafik kopya değildir.
    case "pwht":
      return [
        ...(b.adimRaporuVar ? [cevir("The step already has a report. This report is added to the step's reports; the earlier report stays and still counts.")] : []),
        ...((b.aralikSayisi ?? 0) > 1 ? [cevir("{0} page ranges: each is filed as a separate report of this step.", String(b.aralikSayisi))] : []),
        cevir("The PWHT sign-off on the Weld map screen does not change."),
        ...(b.pwhtOrtak ? [cevir("The same chart is evidence for the other jobs on it; each is filed from its own file. It is not a copy.")] : []),
      ];
    case "weldmap":
      return [
        ...(b.weldMapVar ? [cevir("The new weld map replaces the current one; the old file is kept.")] : []),
        cevir("The welding step can close without passes."),
        // D-074 Faz 2 · PR 10 (Z14): dosyalama kaynak tarihini yazmaz; kayıt dosyalamadan sonra, kaynak başına.
        ...(b.weldMapOkundu ? [cevir("Weld dates are not written by filing. After filing, the Quality Lead or the PM can record each weld's date from this reading, one by one.")] : []),
      ];
    case "urun_geldi": return b.pn ? [cevir("Opens a new stock package for {0} and marks the material row certified.", b.pn)] : [];
    default: return [];
  }
}

/** Dönüştürücü kapısının yaptıkları ("What the gate does"); yalnız PDF satırında. `yer`: riser ya da "SN …". */
export function kapiMetni(aile: DonusturucuAilesi, yer: string, excelVar: boolean): string[] {
  switch (aile) {
    case "disposition": return [cevir("Files the PDF as {0}'s Disposition report and puts it in the converter queue. Field steps not done yet are written “not performed” now, and a riser waiting for Receiving skips it.", yer)];
    case "rework": return [cevir("Files the PDF as {0}'s Rework report and puts it in the converter queue; it is read only after the disposition input exists. A PDF with its excel is refused while the disposition input is missing.", yer)];
    case "sokum":
      return excelVar
        ? [cevir("Opens a closed disassembly record for {0} from the PDF and its excel; the riser moves to the Field list. A riser waiting for Receiving skips it.", yer)]
        : [cevir("Opens a waiting disassembly record for {0} and puts it in the converter queue. A riser waiting for Receiving skips it.", yer)];
    case "montaj": return [cevir("Opens a waiting assembly record for {0} (archive path) and puts it in the converter queue. A riser in the Finishing queue is refused: its report is uploaded in Finishing.", yer)];
    case "mrb": return [cevir("If {0} has no MRB, opens a new MRB record and puts it in the converter queue. A different PDF or an existing content excel is never replaced.", yer)];
  }
}

/** Birden çok riserlı dosyanın tek riser penceresi (bulk kapılar tam dosya alır, §3.9.4). */
export function tekRiserPenceresi(aile: DonusturucuAilesi, rn: string | null): { ad: string; yol: string } {
  switch (aile) {
    case "disposition": return { ad: cevir("Field list"), yol: "/saha" };
    case "rework": return { ad: cevir("Inspection verification"), yol: rn ? `/dogrulama/${rn}` : "/dogrulama" };
    case "sokum": return { ad: cevir("Disassembly"), yol: "/sokum" };
    case "mrb": return { ad: "MRB intake", yol: "/mrb" };
    case "montaj": return { ad: cevir("Finishing"), yol: rn ? `/assembly/${rn}` : "/assembly" };
  }
}

/* ------------------------------------------------------------ aktarma istekleri ------------------------------------------------------------ */

/** Formun aktarmaya giden alanları: sayfalar, imzalayan alanları (`imzalayanAlanlari`), Hardness değerleri. */
export interface AktarimFormu {
  sayfa: SayfaSecimi;
  imzalayan?: Record<string, string>;
  sertlik?: { abm1: string; weld: string; abm2: string; birim: string; weldId?: string | null } | null;
  /** Boya: ekranın gördüğü finalin dokumanId'si ("" = final yok; D-074 Faz 5 · PR 24 B7). */
  boyaOncekiFinal?: string;
}

/**
 * Bugünkü ucun isteği: yol ve iş ekranının gönderdiği form alanları (`dosyaYukle(yol, dosya, alanlar)`). Registers (servis),
 * Project documents (iki adım: `projeIstegi`) ve dönüştürücü (`donusturucuIstegi`) burada değil.
 * - ht: Finishing "Upload HT report" (Planlama.tsx) · hat_ndt: Finishing NDT penceresi (imzalayanlar ya da imzalayanOnay) ·
 *   boya: Finishing Coating (PDF değilse sayfa alanı yok; D-074 Faz 5 · PR 24: `final` ve final ise `oncekiFinal`) · adim_raporu: Component "Upload Report PDF" (Hardness değerleri, weldId,
 *   imzalayan) · pwht: aynı uç, yalnız sayfalar (D-074 Faz 2 · PR 11) · weldmap: Weld map PDF · urun_geldi: Component "Product arrived (upload 3.1)".
 */
export function aktarimIstegi(h: GelenHedef, f: AktarimFormu, bicim: string = "pdf"): { yol: string; alanlar: Record<string, string> } | null {
  const sayfa = bicim === "pdf" ? sayfaAlanlari(f.sayfa) : {};
  switch (h.tur) {
    case "ht": return { yol: `/planlama/set/${h.rn}/ht/${h.hat}`, alanlar: { ...sayfa, ...(h.ret ? { ret: "true" } : {}) } };
    case "hat_ndt": return { yol: `/assembly/${h.rn}/ndt/${h.hat}`, alanlar: { ...sayfa, ...(f.imzalayan ?? {}) } };
    case "boya": return { yol: `/assembly/${h.rn}/rapor/boya`, alanlar: { ...sayfa, ...(h.final === undefined ? {} : { final: h.final ? "true" : "false" }), ...(h.final ? { oncekiFinal: f.boyaOncekiFinal ?? "" } : {}) } };
    case "adim_raporu": {
      const s = f.sertlik;
      const sertlik = s ? { abm1: s.abm1, weld: s.weld, abm2: s.abm2, birim: s.birim, ...(s.weldId ? { weldId: s.weldId } : {}) } : {};
      return { yol: `/planlama/komponent/${h.tamirId}/rapor`, alanlar: { ...sertlik, ...sayfa, ...(f.imzalayan ?? {}) } };
    }
    // D-074 Faz 2 · PR 11 (G3): bugünkü adım raporu ucu; PWHT adımında imzalayan ve sertlik yok.
    case "pwht": return { yol: `/planlama/komponent/${h.tamirId}/rapor`, alanlar: sayfa };
    case "weldmap": return { yol: `/weldmap/${h.tamirId}/pdf`, alanlar: sayfa };
    case "urun_geldi": return { yol: `/planlama/komponent/${h.tamirId}/bom/${h.bomSira}/geldi`, alanlar: sayfa };
    default: return null;
  }
}

/** Dönüştürücü devrinin girdisi: satırın dosyaları ve kişinin seçtiği / dosya adındaki riser ya da SN. */
export interface DevirGirdisi<D extends DosyaBenzeri> {
  pdf: D | null;
  excel: D | null;
  /** Dosya adından okunan riser / SN (kapı da adı okur). */
  adRn: string | null;
  adSn: string | null;
  /** Kişinin seçtiği riser / SN (boş: dosya adındaki). */
  rn: string | null;
  sn: string | null;
}

export type DevirSatiri<D extends DosyaBenzeri> =
  | { aile: "mrb"; satir: mrbToplu.TopluSatir<D> }
  | { aile: "disposition" | "rework"; satir: raporToplu.RaporSatiri<D> }
  | { aile: "sokum"; satir: sokumToplu.SokumSatiri<D> }
  | { aile: "montaj"; satir: montajToplu.MontajSatiri<D> };

/**
 * Toplu pencerenin satırı (D-060 … D-068): Documents aynı satırı kurar ki istek pencereninkiyle aynı olsun. Riser (MRB'de SN) yalnız
 * kişi dosya adındakinden başkasını seçtiyse gönderilir (pencerelerde de öyle: "sunucuya yalnız bu gider").
 */
export function devirSatiri<D extends DosyaBenzeri>(aile: DonusturucuAilesi, g: DevirGirdisi<D>): DevirSatiri<D> {
  const ortak = { id: 1, pdf: g.pdf, excel: g.excel, durum: "bekliyor" as const, sonuc: null, hata: null };
  if (aile === "mrb") {
    const girilenSn = g.sn && g.sn !== g.adSn ? g.sn : null;
    return { aile, satir: { ...ortak, sn: g.adSn, girilenSn } };
  }
  const secilenRn = g.rn && g.rn !== g.adRn ? g.rn : null;
  const satir = { ...ortak, rn: g.adRn, secilenRn };
  if (aile === "disposition" || aile === "rework") return { aile, satir };
  if (aile === "sokum") return { aile, satir };
  return { aile, satir };
}

/** Kapının isteği: `dosyaYukle(yol, dosya, alanlar, ekDosyalar, dosyaAlan)` (pencerelerin `istekParcalari`'ndan). */
export function donusturucuIstegi<D extends DosyaBenzeri>(d: DevirSatiri<D>): { yol: string; dosya: D; dosyaAlan: string; alanlar: Record<string, string>; ekDosyalar: Record<string, D> } {
  switch (d.aile) {
    case "mrb": {
      const p = mrbToplu.istekParcalari(d.satir);
      return { yol: "/mrb/yukle", dosya: p.pdf, dosyaAlan: "dosya", alanlar: p.alanlar, ekDosyalar: p.ekDosyalar };
    }
    case "disposition":
    case "rework":
      return { yol: raporToplu.TOPLU_UCU[d.aile], ...raporToplu.istekParcalari(d.satir) };
    case "sokum":
      return { yol: "/sokum/toplu", ...sokumToplu.istekParcalari(d.satir) };
    case "montaj":
      return { yol: montajToplu.TOPLU_UCU, ...montajToplu.istekParcalari(d.satir) };
  }
}

/** Gönderimin ham sonucu (dört pencerenin ortak biçimi). */
export type Gonderim = { tur: "yanit"; govde: unknown } | { tur: "hata"; status: number; govde: unknown; mesaj: string } | { tur: "ag" };

export interface KapiGorunumu {
  etiketler: { metin: string; ton: Ton }[];
  aciklama: string | null;
  notlar: { metin: string; ton: "ink-2" | "warn" | "ink-3" }[];
  /** FM-0012: riser Finishing kuyruğunda; rapor Finishing'de yüklenir ("Open on Finishing"). */
  akis: boolean;
}

/** Kapının yanıtı penceresinin satır cümlesiyle ("queued", "input attached", "not changed", "needs its PDF", ret cümlesi). */
export function kapiGorunumu<D extends DosyaBenzeri>(d: DevirSatiri<D>, g: Gonderim): KapiGorunumu {
  switch (d.aile) {
    case "mrb": {
      const sn = d.satir.girilenSn ?? d.satir.sn;
      const s = { ...d.satir, ...mrbToplu.sonucuIsle(g as mrbToplu.Gonderim, sn) };
      const v = mrbToplu.satirGorunumu(s);
      return { etiketler: v.etiketler, aciklama: v.aciklama?.metin ?? null, notlar: v.uyarilar.map((metin) => ({ metin, ton: "warn" as const })), akis: false };
    }
    case "disposition":
    case "rework": {
      const s = { ...d.satir, ...raporToplu.sonucuIsle(g as raporToplu.Gonderim) };
      const v = raporToplu.satirGorunumu(d.aile, s);
      return { etiketler: v.etiketler, aciklama: v.aciklama?.metin ?? null, notlar: v.notlar, akis: false };
    }
    case "sokum": {
      const s = { ...d.satir, ...sokumToplu.sonucuIsle(g as sokumToplu.Gonderim) };
      const v = sokumToplu.satirGorunumu(s);
      return { etiketler: v.etiketler, aciklama: v.aciklama?.metin ?? null, notlar: v.notlar, akis: false };
    }
    case "montaj": {
      const s = { ...d.satir, ...montajToplu.sonucuIsle(g as montajToplu.Gonderim) };
      const v = montajToplu.satirGorunumu(s);
      return { etiketler: v.etiketler, aciklama: v.aciklama?.metin ?? null, notlar: v.notlar, akis: s.hata?.kaynak === "akis" };
    }
  }
}

/* ------------------------------------------------------------ dosyalama akışı ------------------------------------------------------------ */

/** Hata gövdesinin cümlesi (`{hata}` ya da `{message}`); yoksa null. */
export function govdeCumlesi(govde: unknown): string | null {
  const g = govde && typeof govde === "object" ? (govde as { hata?: unknown; message?: unknown }) : null;
  if (g && typeof g.hata === "string") return g.hata;
  if (g && typeof g.message === "string") return g.message;
  return null;
}

/** Hatanın sunucudaki İngilizce cümlesi (son deneme İngilizce saklanır, gösterimde çevrilir); yoksa iletisi. */
export function sunucuCumlesi(e: unknown): string {
  return govdeCumlesi((e as { govde?: unknown } | null)?.govde) ?? (e instanceof Error ? e.message : String(e));
}

/** Akışın dış bağımlılıkları (testte sahte): JSON isteği, çok parçalı yükleme, saklı dosyanın alınması. */
export interface AkisBaglantisi {
  post: <T>(yol: string, govde?: unknown) => Promise<T>;
  yukle: <T>(yol: string, dosya: File, alanlar?: Record<string, string>, ekDosyalar?: Record<string, File>, dosyaAlan?: string) => Promise<T>;
  getir: (d: AktarimDosyasi) => Promise<File>;
}

export type AkisSonucu = { tur: "dosyalandi"; yanit: YazimYaniti } | { tur: "reddedildi"; mesaj: string };

/** Hattın aynı dosyasını ikinci kez alan NDT ucu 400 der ("maybe filed"): akış yine kanıtı sordurur (§1.3). */
const ayniNdtDosyasi = (h: GelenHedef, e: unknown) => h.tur === "hat_ndt" && (e as { status?: number } | null)?.status === 400;

/** Aktarma sürerken rezervasyonun yenilenme aralığı (rezervasyon 10 dakika). */
export const UZATMA_ARALIGI_MS = 4 * 60 * 1000;

/**
 * Aktarmayı rezervasyonu yenileyerek yürütür (inceleme bulgusu, U-073): dosya kapıya gitmeden hemen önce ve gönderim sürdükçe her dört
 * dakikada `dosyala-uzat`. Yavaş bağlantıda büyük bir dosya 10 dakikayı aşınca rezervasyon düşüyor, başkası aynı dosyayı yeniden
 * aktarabiliyordu. Yenileme hatası aktarmayı durdurmaz (sunucu işaretlerken yine rezervasyona bakar).
 */
async function uzatarak<T>(b: AkisBaglantisi, p: string, f: () => Promise<T>): Promise<T> {
  const uzat = () => b.post(`${p}/dosyala-uzat`).catch(() => undefined);
  await uzat();
  const z = setInterval(() => void uzat(), UZATMA_ARALIGI_MS);
  try {
    return await f();
  } finally {
    clearInterval(z);
  }
}

/**
 * "Confirm and file" (aktarma yolu, §1.2): dosyala-basla → (kanıt zaten varsa biter) → saklı dosya → bugünkü uç (Project documents'ta
 * yükle + bağ) → dosyalandi. Uç reddederse rezervasyon kapının İngilizce cümlesiyle bırakılır ve cümle döner. Hedefin kendi boyut
 * sınırı aşılırsa dosya gönderilmez.
 */
export async function aktarimlaDosyala(
  b: AkisBaglantisi,
  satir: Pick<GelenSatiri, "id" | "tur" | "boyut" | "bicim">,
  hedef: GelenHedef,
  form: AktarimFormu & { proje?: (dokumanId: string) => { govde: unknown; hata: string | null } },
): Promise<AkisSonucu> {
  const p = `/belgeler/${satir.id}`;
  const basla = await b.post<BaslaYaniti>(`${p}/dosyala-basla`, { hedef });
  if ("zatenDosyali" in basla) return { tur: "dosyalandi", yanit: { satir: basla.satir } };
  const birak = async (mesaj: string) => {
    await b.post(`${p}/dosyala-birak`, { mesaj }).catch(() => undefined);
    return { tur: "reddedildi" as const, mesaj };
  };
  const sinir = hedefSinirHatasi(satir.tur, basla.ad, satir.boyut);
  if (sinir) return birak(sinir);
  try {
    const dosya = await b.getir(basla);
    const sonuc = await uzatarak(b, p, async () => {
      if (hedef.tur === "proje") {
        const y = await b.yukle<{ id: string; ad: string; toplam: number }>("/dosya-belge/yukle", dosya, { tur: hedef.belgeTuru });
        const g = form.proje?.(y.id);
        if (!g || g.hata) return birak(g?.hata ?? "Choose where the file belongs.");
        await b.post("/dosya-belge", g.govde);
      } else {
        const ist = aktarimIstegi(hedef, form, satir.bicim);
        if (!ist) return birak("Choose where the file belongs.");
        await b.yukle(ist.yol, dosya, ist.alanlar);
      }
      return null;
    });
    if (sonuc) return sonuc;
  } catch (e) {
    if (ayniNdtDosyasi(hedef, e)) {
      const y = await b.post<YazimYaniti>(`${p}/dosyalandi`).catch(() => null);
      if (y) return { tur: "dosyalandi", yanit: y };
    }
    return birak(sunucuCumlesi(e));
  }
  return { tur: "dosyalandi", yanit: await b.post<YazimYaniti>(`${p}/dosyalandi`) };
}

/** "Send to converter" akışının sonucu: kapının görünümü ve satırın işaretlenip işaretlenmediği. */
export type DevirSonucu =
  | { tur: "zaten"; yanit: YazimYaniti }
  | { tur: "gonderildi"; kapi: KapiGorunumu; isaret: (YazimYaniti & { isaretlenen: string[]; bulunamayan: string[] }) | null; mesaj: string | null };

/**
 * "Send to converter" (§3.9): dosyala-basla (eşli excel birlikte rezerve edilir) → saklı dosyalar → toplu kapı (pencerenin
 * alanlarıyla) → kapı kabul ettiyse donusturucu (sunucu her satırı kendi kanıtıyla işaretler). Kapı reddederse ya da hiçbir satır
 * işaretlenmezse rezervasyon kapının cümlesiyle bırakılır; satır açık kalır ve kart kapının cümlesini gösterir.
 */
export async function devirle(
  b: AkisBaglantisi,
  satir: Pick<GelenSatiri, "id" | "tur" | "bicim" | "boyut">,
  hedef: Extract<GelenHedef, { tur: "donusturucu" }>,
  ad: { rn: string | null; sn: string | null },
): Promise<DevirSonucu> {
  const p = `/belgeler/${satir.id}`;
  const basla = await b.post<BaslaYaniti>(`${p}/dosyala-basla`, { hedef });
  if ("zatenDosyali" in basla) return { tur: "zaten", yanit: { satir: basla.satir } };
  const birak = (mesaj: string) => b.post(`${p}/dosyala-birak`, { mesaj }).catch(() => undefined);
  const sinir = hedefSinirHatasi(satir.tur, basla.ad, satir.boyut);
  const kapiBos: KapiGorunumu = { etiketler: [], aciklama: null, notlar: [], akis: false };
  if (sinir) {
    await birak(sinir);
    return { tur: "gonderildi", kapi: kapiBos, isaret: null, mesaj: sinir };
  }
  let dosya: File;
  let ek: File | null = null;
  try {
    dosya = await b.getir(basla);
    if (basla.ek) ek = await b.getir(basla.ek);
  } catch (e) {
    const m = sunucuCumlesi(e);
    await birak(m);
    return { tur: "gonderildi", kapi: kapiBos, isaret: null, mesaj: m };
  }
  // Eşli excel yalnız PDF satırında olur (J10); excel satırı kapıya tek başına gider.
  const pdfMi = satir.bicim === "pdf";
  const d = devirSatiri(hedef.aile, { pdf: pdfMi ? dosya : null, excel: pdfMi ? ek : dosya, adRn: ad.rn, adSn: ad.sn, rn: hedef.rn ?? null, sn: hedef.sn ?? null });
  const ist = donusturucuIstegi(d);
  let g: Gonderim;
  try {
    g = { tur: "yanit", govde: await uzatarak(b, p, () => b.yukle(ist.yol, ist.dosya, ist.alanlar, ist.ekDosyalar, ist.dosyaAlan)) };
  } catch (e) {
    const status = (e as { status?: unknown } | null)?.status;
    g = typeof status === "number" ? { tur: "hata", status, govde: (e as { govde?: unknown }).govde ?? null, mesaj: sunucuCumlesi(e) } : { tur: "ag" };
  }
  const kapi = kapiGorunumu(d, g);
  if (g.tur !== "yanit") {
    const m = g.tur === "hata" ? (govdeCumlesi(g.govde) ?? g.mesaj) : mrbToplu.AG_HATASI;
    await birak(m);
    return { tur: "gonderildi", kapi, isaret: null, mesaj: m };
  }
  try {
    const isaret = await b.post<YazimYaniti & { isaretlenen: string[]; bulunamayan: string[] }>(`${p}/donusturucu`);
    return { tur: "gonderildi", kapi, isaret, mesaj: null };
  } catch (e) {
    // Kapı yanıtladı ama hiçbir satıra kayıt düşmedi ("not changed", "needs its PDF"): kart kapının satır cümlesini gösterir. Son denemeyi
    // ve rezervasyonun bırakılmasını sunucunun `donusturucu` ucu kendi İngilizce cümlesiyle yazdı (inceleme bulgusu, U-073: önceden
    // pencerenin ÇEVRİLMİŞ satır cümlesi son deneme olarak saklanıyor, öteki dildeki kişiye o dilde görünüyordu).
    return { tur: "gonderildi", kapi, isaret: null, mesaj: kapi.aciklama ?? sunucuCumlesi(e) };
  }
}

/**
 * Gelen kutusundaki dosyayı alır ve aktarılacak `File`'a çevirir: ad satırın kendi adıdır (kapılar riser numarasını adından okur),
 * MIME biçimin kanonik türüdür (J5). Okuma bugünkü `GET /api/dokuman/:id`'dir (gelen kutusu denetimi J1).
 */
export async function dosyaGetir(d: AktarimDosyasi): Promise<File> {
  const r = await fetch(`/api/dokuman/${encodeURIComponent(d.dokumanId)}`, { credentials: "same-origin" });
  if (!r.ok) {
    const g = await r.json().catch(() => null);
    throw new YuklemeHatasi(cevir(govdeCumlesi(g) ?? "Document not found."), r.status, g);
  }
  return new File([await r.blob()], d.ad, { type: d.mime });
}

/** Sayfanın gerçek bağlantısı. */
export const canliBaglanti: AkisBaglantisi = {
  post: (yol, govde) => api.post(yol, govde),
  yukle: (yol, dosya, alanlar, ekDosyalar, dosyaAlan) => dosyaYukle(yol, dosya, alanlar, ekDosyalar, dosyaAlan),
  getir: dosyaGetir,
};

/** Eşlenebilir excel satırları (J10): açık, tam görünür, başkasında değil, xlsx, aynı ailenin excel'i ve (adı söylüyorsa) aynı riser / SN. */
export function eslesenExceller(satirlar: readonly GelenSatiri[], pdf: Pick<GelenSatiri, "id">, aile: DonusturucuAilesi, rn: string | null, sn: string | null): GelenSatiri[] {
  const beklenen = `donusturucu:${aile}:excel`;
  return satirlar.filter((s) => {
    if (s.id === pdf.id || s.durum !== "acik" || s.gorunum !== "tam" || s.bicim !== "xlsx" || s.etiket === "dosyalaniyor") return false;
    if (!(s.tur === beklenen || (s.tur === null && s.ipucu?.tur === beklenen))) return false;
    if (aile === "mrb") return !sn || !s.ipucu?.sn || s.ipucu.sn === sn;
    return !rn || !s.ipucu?.rn || s.ipucu.rn === rn;
  });
}

/** Proje belgesinin kapsam seçeneği "is_emri:<no>" biçiminden kapsamı ve anahtarı. */
export function kapsamOku(deger: string): { kapsam: GirdiKapsami | null; anahtar: string | null } {
  if (deger === "proje") return { kapsam: "proje", anahtar: null };
  if (deger === "riser") return { kapsam: "riser", anahtar: null };
  if (deger.startsWith("is_emri:")) return { kapsam: "is_emri", anahtar: deger.slice("is_emri:".length) || null };
  return { kapsam: null, anahtar: null };
}

/** Project documents türünün bu sayfadaki kapsamları (riser kapsamlı türler riser ister). */
export const projeTuru = (tur: string | null): DosyaGirdiTuru | null => turTanimi(tur)?.proje ?? null;
